export type LangCode = 'en' | 'es' | 'fr' | 'de' | 'pt' | 'it' | 'ja' | 'zh' | 'ar' | 'hi';

export interface Translations {
  // Meta
  langName: string;
  langFlag: string;
  dir: 'ltr' | 'rtl';

  // App
  appName: string;
  signIn: string;
  signOut: string;
  username: string;
  password: string;
  signingIn: string;
  connecting: string;

  // Nav
  navBracket: string;
  navPlayers: string;
  navHistory: string;
  navUsers: string;
  navAdmin: string;

  // Status
  statusRegistration: string;
  statusActive: string;
  statusComplete: string;

  // Players page
  players: string;
  registered: string;
  addPlayer: string;
  playerName: string;
  removePlayer: string;
  startTournament: string;
  slotsRemaining: string;
  byesAdded: string;
  noPlayersYet: string;

  // Bracket
  awaitingDraw: string;
  awaitingDrawDesc: string;
  champion: string;
  complete: string;
  vsLabel: string;

  // Match card
  clickToPlay: string;
  inProgress: string;
  live: string;

  // Match play
  matchComplete: string;
  wins: string;
  shotsPlayed: string;
  elapsed: string;
  notStarted: string;
  startMatch: string;
  startMatchDesc: string;
  shotClockDesc: string;
  atTheTable: string;
  shotClock: string;
  nextLegalPot: string;
  potBall: string;
  selectFoulBall: string;
  miss: string;
  noPot: string;
  foul: string;
  selectFoulType: string;
  cancelFoul: string;
  tapBallAbove: string;
  noContact: string;
  plusToOpponent: string;
  undo: string;
  nothingToUndo: string;
  cueBallPotted: string;
  ballOffTable: string;
  endMatchEarly: string;
  declareWinner: string;
  finishMatchBtn: string;
  finishFrameBtn: string;
  enterFinalScore: string;
  scoresInvalid: string;
  cancel: string;
  shotHistory: string;
  redsRemaining: string;
  firstHalf: string;
  secondHalf: string;
  remaining: string;
  backToBracket: string;

  // Flash states
  shotClockExpired: string;
  losesTheFrame: string;
  matchClockExpired: string;
  endMatchToDeclare: string;
  dismiss: string;

  // Foul toast
  foulToOpponent: string;
  potted: string;
  noPotnPlayerChanged: string;
  lastShotUndone: string;
  cannotUndo: string;

  // Admin
  adminDashboard: string;
  tournamentStatus: string;
  registrationOpen: string;
  inProgressStatus: string;
  tournamentName: string;
  save: string;
  saving: string;
  newTournament: string;
  newTournamentDesc: string;
  startNewTournament: string;
  rounds: string;
  matchesDone: string;

  // History
  tournamentHistory: string;
  noHistory: string;
  noHistoryDesc: string;
  viewDetails: string;
  viewDetails2: string;
  participants: string;
  shotsCount: string;

  // Users
  userManagement: string;
  addNewUser: string;
  allUsers: string;
  you: string;
  superuser: string;
  user: string;
  joined: string;
  resetPasswordBtn: string;
  deleteUser: string;
  createUser: string;
  creating: string;
  passwordMinLength: string;
  userIsolationNote: string;

  // Tournaments page
  tournamentsTitle: string;
  newTournament2: string;      // button label "+ New Tournament",
  currentTournament: string;
  pastTournaments: string;
  publicTournamentsHeading: string;
  publicTournamentsSubtitle: string;
  noPublicTournaments: string;
  hostedByLabel: string;
  watchLiveBtn: string;
  backToPublicList: string;
  spectatingBadge: string;
  noHistoryYet: string;
  noHistoryYetDesc: string;
  createTournament: string;
  nextBtn: string;
  backBtn: string;
  editTournament: string;
  tournamentNameLabel: string;
  dateTimeLabel: string;
  dateTimeHint: string;
  maxPlayersLabel: string;
  maxPlayersHint: string;
  handicapLabel: string;
  handicapOnDesc: string;
  handicapOffDesc: string;
  handicapHint: string;
  makePublicLabel: string;
  makePublicHint: string;
  pauseClocks: string;
  resumeClocks: string;
  saveChanges: string;
  confirmCreateTitle: string;
  confirmCreateMsg: string;     // takes {name} placeholder
  cancelLabel: string;
  confirmLabel: string;
  registrationLabel: string;
  activeLabel: string;
  completeLabel: string;
  maxLabel: string;
  handicapBadge: string;

  // Players admin page
  playerManagement: string;
  playerManagementDesc: string;
  deletePlayerTitle: string;
  deletePlayerMsg: string;      // takes {name}
  changePhoto: string;
  deletePlayer: string;
  newPhotoSelected: string;
  handicapEditHint: string;
  handicapValue: string;
  clickToEditHandicap: string;
  playerCountAll: string;
  playerCountMatch: string;
  clickToChangePhoto: string;
  photoFromPrevious: string;

  // Match page additions
  handicapStartTitle: string;
  handicapStartDesc: string;
  debugJumpBtn: string;
  pointsAdvantageApplied: string;

  // Announcements (voice)
  voiceHalfTime: string;

  // Language
  language: string;
  profile: string;
  changePassword: string;
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
  passwordChanged: string;
  forgotPassword: string;
  sendResetLink: string;
  resetLinkSent: string;
  resetPassword: string;
  resetPasswordDesc: string;
  setNewPassword: string;
  accountDetails: string;
  memberSince: string;
  emailAddress: string;
  // pts label for handicap input
  handicapPts: string;
  // password strength labels
  passwordWeak: string;
  passwordFair: string;
  passwordGood: string;
  passwordStrong: string;
  // signup validation
  passwordsNoMatch: string;
  // repeat password field label
  repeatPassword: string;
  // signup in-progress label
  creatingAccount: string;
  // password min chars hint
  minChars: string;
  // username format hint
  usernameHint: string;
  // users page
  deactivateAccount: string;
  // new password field label
  newPasswordMin: string;
  // suspension reason field
  suspensionReason: string;
  // confirm suspension button
  confirmSuspend: string;
  // password updated confirmation
  passwordUpdated: string;
  // New UI strings
  splashTagline: string;
  splashSubtitle: string;
  splashSubtitleAllFree: string;
  splashSubtitlePaid: string;
  splashSubtitleNFree: string;
  splashNoCreditCard: string;
  splashNoCreditCardAllFree: string;
  splashNoCreditCardPaid: string;
  splashNoCreditCardNFree: string;
  splashStep1Title: string;
  splashStep1Desc: string;
  splashStep1DescAllFree: string;
  splashStep1DescPaid: string;
  splashStep1DescNFree: string;
  whoBreaks: string;
  whoBreaksDesc: string;
  breakOffBtn: string;
  breaksOff: string;
  selectPlayerFirst: string;
  matchClockStartsOnBreak: string;
  foulCueBallInHand: string;
  pointsAwardedToOpponent: string;
  toPlayFromHand: string;
  clocksPausedMsg: string;
  resumeMatch: string;
  freeBallLabel: string;
  freeBallSnookeredMsg: string;
  freeBallActiveBanner: string;
  respotBlackBanner: string;
  higherValueFoul: string;
  selectHighestBallTouched: string;
  highestBreakLabel: string;
  highBreakPrizeLabel: string;
  highBreakPrizeHint: string;
  contactTitle: string;
  contactSubtitle: string;
  contactSubjectLabel: string;
  contactMessageLabel: string;
  contactSendBtn: string;
  contactSentTitle: string;
  contactSentDesc: string;
  contactSendAnother: string;
  contactAimToRespond: string;
  changeEmailTitle: string;
  changeEmailNewLabel: string;
  changeEmailSendBtn: string;
  sendPasswordResetLink: string;
  backToSignIn: string;
  viewDraw: string;
  loadingTournament: string;
  loadingMatch: string;
  tournamentNotFound: string;
  matchNotFound: string;
  backToHistory: string;
  backToDraw: string;
  backToUsers: string;
  deleteTournamentTitle: string;
  deleteTournamentConfirm: string;
  tournamentsHeading: string;
  loadingTournaments: string;
  noTournamentsYet: string;
  viewThisUsersTournaments: string;
  grantFreeForLife: string;
  revokeFreeForLife: string;
  // Round names
  roundFinal: string;
  roundSemiFinals: string;
  roundQuarterFinals: string;
  roundOf16: string;
  roundOf: string;  // prefix for "Round of {n}"
  // Bracket/tournament
  owner: string;
  timePlayed: string;
  matchesPlayed: string;
  // Players page
  noPlayersRegistered: string;
  startTypingPlayers: string;
  startTournamentConfirm: string;
  // Splash page steps
  splashFeaturesHeading: string;
  splashFooterTagline: string;
  splashUpAndRunning: string;
  splashStep2Title: string;
  splashStep2Desc: string;
  splashStep3Title: string;
  splashStep3Desc: string;
  splashStep4Title: string;
  splashStep4Desc: string;
  splashReadyTitle: string;
  splashGetStarted: string;
  splashGetStartedPaid: string;
  splashPricingAllFree: string;
  splashPricingPaidOnly: string;
  splashPricingOneFree: string;
  splashPricingNFree: string;
  privacyPolicy: string;
  // Email verification
  resend: string;
  resending: string;
  newLinkSent: string;
  didntGetIt: string;
  // Forgot password
  sendResetCode: string;
  verifyCode: string;
  verifying: string;
  resendCode: string;
  // Match page
  handicapStart: string;
  // Players admin
  noPlayersFound: string;
  noPlayersMatching: string;
  // Header
  navContact: string;
  navPublic: string;
  navFaq: string;
  navLeagues: string;
  faqSubtitle: string;
  faqSearch: string;
  faqNoResults: string;
  faqContact: string;
  faqContactLink: string;
  // Superuser
  paymentsEnabled: string;
  paymentsDisabled: string;
  // Historic/UsersPage
  statusLabel: string;
  fromLabel: string;
  // Free for life
  freeForLife: string;
  freeForLifeGranted: string;
  // Auth / Splash buttons
  createAccount: string;
  splashSignIn: string;
  splashSignUp: string;
  dontHaveAccount: string;
  createFreeAccount: string;
  signInNow: string;
  // OAuth sign-in
  orContinueWith: string;
  continueWithGoogle: string;
  continueWithFacebook: string;
  oauthErrorTitle: string;
  oauthErrorGeneric: string;
  oauthErrorEmailNotVerified: string;
  oauthErrorAccountSuspended: string;
  oauthErrorDenied: string;
  oauthErrorProviderDisabled: string;
  noPasswordSetError: string;
  // Nav
  navPlayersAdmin: string;
  // Players admin
  allPlayersDesc: string;
  // Password strength
  pwStrengthWeak: string;
  pwStrengthFair: string;
  pwStrengthGood: string;
  pwStrengthStrong: string;
  // Shot clock pause button
  pauseShotClock: string;
  resumeShotClock: string;
  // Tournament dialog & page
  newTournamentTitle: string;
  editTournamentTitle: string;
  locationLabel: string;
  locationPlaceholder: string;
  locationHint: string;
  entryFeeLabel: string;
  entryFeeHint: string;
  prizePlacesLabel: string;
  prizePlacesNone: string;
  prizePlacesHint: string;
  prizePoolLabel: string;
  matchFormatLabel: string;
  shootoutDesc: string;
  snooker900Desc: string;
  sixRedsLabel: string;
  sixRedsDesc: string;
  standardFormatHint: string;
  bestOfDialogTitle: string;
  bestOfDialogDesc: string;
  bestOfContinueBtn: string;
  bestOfBackBtn: string;
  cancelBtn: string;
  timedTournamentTitle: string;
  timedTournamentDesc: string;
  standardTournamentTitle: string;
  standardTournamentDesc: string;
  chooseTournamentType: string;
  completedTournamentsAppearHere: string;
  maxEntriesLabel: string;
  prizePlaceSingle: string;
  prizePlacePlural: string;
  prizePoolPrefix: string;
  entryLabel: string;
  handicapTournament: string;
  scratchTournament: string;
  highBreakPrizeDisplay: string;
  noDateVenueWarning: string;
  additionalTextLabel: string;
  additionalTextPlaceholder: string;
  additionalTextHint: string;
  downloadPdfPoster: string;
  generatingPoster: string;
  paymentGateTitle: string;
  paymentGateDesc: string;
  editBtn: string;
  posterBtn: string;
  sharedBadge: string;
  publicBadge: string;
  privateBadge: string;
  togglePublicHint: string;
  adminsBtn: string;
  adminsDesc: string;
  usernamePlaceholder: string;
  addBtn: string;
  removeBtn: string;
  noAdminsYet: string;
  statusRegistrationLabel: string;
  statusActiveLabel: string;
  statusCompleteLabel: string;
  // Bracket page
  bracketWinner: string;
  bracketChampionTitle: string;
  bracketSavingLabel: string;
  bracketSaveResult: string;
  bracketEntries: string;
  bracketEntry: string;
  bracketPrizePool: string;
  bracketHighBreak: string;
  bracketSixReds: string;
  bracketHandicap: string;
  bracketShootoutLabel: string;
  bracketSnooker900Label: string;
  bracketStandardLabel: string;
  bracketPlace: string;
  bracketPlaces: string;
  // Tournament stats grid
  statsPlayersLabel: string;
  statsHighBreakLabel: string;
  statsDateLabel: string;
  statsVenueLabel: string;
  // Match play
  spectatorView: string;
  // App-level messages
  resetLinkInvalidTitle: string;
  resetLinkExpiredMsg: string;
  resetLinkInvalidMsg: string;
  emailUpdatedTitle: string;
  emailChangeLinkInvalidTitle: string;
  emailAlreadyTaken: string;
  emailChangeLinkInvalidMsg: string;
  accountSuspendedTitle: string;
  accountSuspendedMsg: string;
  // Match card
  editMatchResult: string;
  // Admin stats
  adminOnlineNow: string;
  adminTotalAccounts: string;
  adminAwaitingVerification: string;
  adminNewThisWeek: string;
  adminNewThisMonth: string;
  adminMatchesInProgress: string;
  adminInProgress: string;
  adminUniquePlayerEntries: string;
  adminTotalEver: string;
  adminLoadingStats: string;
  // Superuser settings
  settingsSavePrices: string;
  settingsCurrentState: string;
  settingsTimedLabel: string;
  settingsStandardLabel: string;
  settingsPerUserOverrides: string;
  // Users page
  usersAccountStates: string;
  usersActiveState: string;
  usersPendingState: string;
  usersSuspendedState: string;
  usersDeactivatedState: string;
  // Generic
  loadingLabel: string;
  // Leagues
  leaguesEmptyDesc: string;
  createLeagueBtn: string;
  leagueNamePlaceholder: string;
  divisionTabTeams: string;
  divisionTabFixtures: string;
  divisionTabStandings: string;
  standingsTeamCol: string;
  noTeamsInDivision: string;
  fixtureStatusScheduled: string;
  fixtureStatusLineupSet: string;
  fixtureStatusInProgress: string;
  backToFixture: string;
  publicLeaguesTitle: string;
  publicLeaguesDesc: string;
  noPublicLeaguesYet: string;
  backToPublicLeagues: string;
  noFixturesYetLabel: string;
  noTeamsYetLabel: string;
  backToAllSeasons: string;
  noPastSeasonsYet: string;
  noPastSeasonsYetOwner: string;
  endedLabel: string;
  promotedLabel: string;
  relegatedLabel: string;
  finalStandingsLabel: string;
  fixturesLabel: string;
  historyTabLabel: string;
  doubleRoundRobinLabel: string;
  pendingClaimApprovalLabel: string;
  approveBtn: string;
  rejectBtn: string;
  tierFieldLabel: string;
  promotionSpotsFieldLabel: string;
  relegationSpotsFieldLabel: string;
  seasonManagementHint: string;
  togglePublicTooltip: string;
  toggleClaimApprovalTooltip: string;
  publicChipLabel: string;
  privateChipLabel: string;
  claimsApprovalChipLabel: string;
  claimsInstantChipLabel: string;
  endSeasonBtn: string;
  browsePublicLeaguesLink: string;
  myStatsTitle: string;
  statsPlayedLabel: string;
  statsWonLabel: string;
  statsLostLabel: string;
  seasonLabelFieldLabel: string;
  seasonLabelPlaceholder: string;
  seasonCountsHint: string;
  tierLabel: string;
  previewBtn: string;
  reviewMovesHint: string;
  noMovesThisSeason: string;
  confirmEndSeasonBtn: string;
}

const en: Translations = {
  langName: 'English',
  appName: 'Shootout Comps',
  signIn: 'Sign In',
  signingIn: 'Signing in…',
  navBracket: 'Tournament',
  statusRegistration: 'Registration Open',
  players: 'Players',
  removePlayer: 'Remove',
  slotsRemaining: 'slots remaining',
  noPlayersYet: 'No players registered yet',
  awaitingDraw: 'Awaiting Draw',
  champion: 'Champion',
  clickToPlay: '→ Click to play',
  matchComplete: 'Match Complete',
  notStarted: 'Not started',
  startMatchDesc: 'Ready to begin? Starting will begin the 10-minute match clock.',
  shotClockDesc: 'Shot clock: 15s for first 5 min · 10s for last 5 min',
  atTheTable: 'At the table',
  nextLegalPot: 'Next legal pot:',
  miss: 'Miss',
  cancelFoul: 'Cancel',
  noContact: 'No Contact',
  undo: 'Undo',
  cueBallPotted: 'Cue Ball Potted',
  endMatchEarly: 'End Match Early',
  finishMatchBtn: 'Finish Match',
  finishFrameBtn: 'Finish Frame',
  enterFinalScore: 'Enter final score:',
  scoresInvalid: 'Enter two different scores',
  shotHistory: 'Shot history',
  firstHalf: '1st half — 15s shots',
  backToBracket: '← Back to Tournament',
  shotClockExpired: 'SHOT CLOCK EXPIRED',
  matchClockExpired: 'MATCH CLOCK EXPIRED',
  dismiss: 'Dismiss',
  foulToOpponent: 'Foul — +{n} to opponent',
  noPotnPlayerChanged: '↩ No pot — player changed',
  cannotUndo: 'Cannot undo',
  adminDashboard: 'Admin Dashboard',
  registrationOpen: 'Registration Open',
  tournamentName: 'Tournament Name',
  newTournament: '🆕 New Tournament',
  newTournamentDesc: 'Starting a new tournament archives the current one.',
  startNewTournament: 'Start New Tournament',
  tournamentHistory: 'Tournament History',
  noHistoryDesc: 'Completed tournaments will appear here after you reset the current one.',
  viewDetails: '→ View details',
  participants: 'Participants',
  userManagement: 'User Management',
  you: 'You',
  resetPasswordBtn: '🔑 Reset PW',
  passwordMinLength: 'Password must be at least 8 characters',
  userIsolationNote: 'Each user can only see and manage their own tournaments.',
  voiceHalfTime: '10 second shot clock now in operation',
  language: 'Language',
  profile: 'My Profile',
  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  passwordChanged: 'Password changed successfully.',
  forgotPassword: 'Forgot password?',
  sendResetLink: 'Send Reset Link',
  resetLinkSent: 'Reset link sent — check your email.',
  resetPassword: 'Reset Password',
  resetPasswordDesc: "Enter your email and we'll send a reset link.",
  setNewPassword: 'Set New Password',
  accountDetails: 'Account Details',
  memberSince: 'Member since',
  tournamentsTitle: 'Tournaments',
  newTournament2: '+ New Tournament',
  currentTournament: 'Current Tournament',
  pastTournaments: 'Past Tournaments',
  publicTournamentsHeading: 'Public Tournaments',
  publicTournamentsSubtitle: 'Tournaments other users have made public — any signed-in user can view the bracket and watch matches live.',
  noPublicTournaments: 'No public tournaments right now.',
  hostedByLabel: 'Hosted by',
  watchLiveBtn: 'Watch Live',
  backToPublicList: 'Back to Public Tournaments',
  spectatingBadge: '👀 Spectating',
  noHistoryYet: 'No past tournaments yet.',
  noHistoryYetDesc: 'Completed tournaments appear here.',
  createTournament: 'Create Tournament',
  nextBtn: 'Next',
  backBtn: 'Back',
  editTournament: 'Edit Tournament',
  tournamentNameLabel: 'Tournament Name',
  dateTimeLabel: 'Date & Time',
  dateTimeHint: 'Shown on the tournaments list',
  maxPlayersLabel: 'Maximum Players (bracket size)',
  maxPlayersHint: 'Empty slots are filled with BYEs automatically',
  handicapLabel: 'Handicap Tournament',
  handicapOnDesc: 'Handicap ON — players get a points start',
  handicapOffDesc: 'Handicap OFF — scratch tournament',
  pauseClocks: '⏸ Pause Clocks',
  resumeClocks: '▶ Resume Clocks',
  saveChanges: 'Save Changes',
  confirmCreateTitle: 'Start New Tournament?',
  confirmCreateMsg: 'The current tournament will be marked as complete and archived.',
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  registrationLabel: 'Registration',
  activeLabel: 'In Progress',
  completeLabel: 'Complete',
  maxLabel: 'Max',
  handicapBadge: 'Handicap',
  playerManagement: 'Player Management',
  playerManagementDesc: 'Click the photo to change it · Names cannot be changed',
  deletePlayerTitle: 'Delete Player',
  deletePlayerMsg: 'Remove this player from the tournament? This cannot be undone.',
  changePhoto: '📷 Photo',
  deletePlayer: '🗑 Delete',
  newPhotoSelected: 'New photo selected ✓',
  handicapEditHint: 'Handicap',
  handicapValue: 'Handicap',
  clickToEditHandicap: 'Click to edit handicap',
  playerCountAll: '{n} player{s} across all tournaments',
  playerCountMatch: '{n} player{s} matching "{q}"',
  clickToChangePhoto: 'Click to change photo',
  photoFromPrevious: '🖼 Photo from previous tournament',
  handicapStartTitle: '🏅 Handicap Start',
  handicapStartDesc: 'points advantage applied at match start',
  pointsAdvantageApplied: 'Points advantage applied at match start',
  debugJumpBtn: '🛠 Debug: Jump to 5:30 remaining',
  handicapPts: 'pts — higher = weaker player = more points start',
  passwordWeak: 'Weak',
  passwordFair: 'Fair',
  passwordGood: 'Good',
  passwordStrong: 'Strong',
  passwordsNoMatch: 'Passwords do not match',
  repeatPassword: 'Repeat Password',
  creatingAccount: 'Creating account…',
  minChars: 'Min 8 characters',
  usernameHint: 'Letters, numbers, spaces, underscores and hyphens',
  deactivateAccount: 'Deactivate Account',
  newPasswordMin: 'New password (min 8)',
  suspensionReason: 'Suspension reason (optional)',
  confirmSuspend: 'Confirm Suspend',
  passwordUpdated: 'Password updated ✓',
  addNewUser: 'Add New User',
  addPlayer: 'Add Player',
  allUsers: 'All Users',
  awaitingDrawDesc: 'Register players then start the tournament to generate the bracket.',
  ballOffTable: 'Ball Off Table',
  byesAdded: '{n} BYE(s) added to complete the bracket',
  cancel: 'Cancel',
  complete: 'Complete',
  connecting: 'Connecting…',
  createUser: '+ Add User',
  creating: 'Creating…',
  declareWinner: 'Declare winner:',
  deleteUser: 'Delete',
  dir: 'ltr',
  elapsed: 'elapsed',
  endMatchToDeclare: 'End match to declare a winner',
  foul: 'Foul',
  inProgress: 'In Progress',
  inProgressStatus: 'Tournament in progress',
  joined: 'Joined',
  langFlag: '🇬🇧',
  lastShotUndone: '↩ Last shot undone',
  live: 'LIVE',
  losesTheFrame: 'loses the frame',
  matchesDone: 'Matches Done',
  navAdmin: 'Admin',
  navHistory: 'Tournaments',
  navPlayers: 'Add Players',
  navUsers: 'Users',
  noHistory: 'No past tournaments.',
  noPot: 'No pot',
  nothingToUndo: 'Nothing to undo',
  password: 'Password',
  playerName: 'Player name…',
  plusToOpponent: '+{n} to opponent',
  potBall: 'Pot a ball',
  potted: '{ball} potted (+{n})',
  redsRemaining: 'reds remaining',
  registered: 'registered',
  remaining: 'remaining',
  rounds: 'Rounds',
  save: 'Save',
  saving: 'Saving…',
  secondHalf: '2nd Half',

  selectFoulBall: 'Select the ball fouled on:',
  selectFoulType: 'Select foul type',
  shotClock: 'Shot clock',
  shotsCount: 'shots',
  shotsPlayed: 'Shots played',
  signOut: 'Sign out',
  startMatch: 'Start Match',
  startTournament: 'Start Tournament',
  statusActive: '● In Progress',
  statusComplete: '✓ Complete',
  superuser: 'superuser',
  tapBallAbove: 'Tap the ball fouled on above',
  tournamentStatus: 'Tournament Status',
  user: 'user',
  username: 'Username',
  viewDetails2: 'View bracket and results',
  vsLabel: 'VS',
  wins: 'wins',
  roundFinal: 'Final',
  roundSemiFinals: 'Semi-Finals',
  roundQuarterFinals: 'Quarter-Finals',
  roundOf16: 'Round of 16',
  roundOf: 'Round of',
  owner: 'Owner',
  timePlayed: 'played',
  matchesPlayed: 'played',
  noPlayersRegistered: 'No players registered yet',
  startTypingPlayers: 'Start typing to see players from previous tournaments',
  startTournamentConfirm: 'Start the tournament? The bracket will be generated automatically.',
  splashFeaturesHeading: 'Everything you need to run a shootout',
  splashFooterTagline: 'Shootout Comps — Tournament management',
  splashUpAndRunning: 'Up and running in minutes',
  splashStep2Title: 'Register your players',
  splashStep2Desc: 'Add up to 32 players with photos',
  splashStep3Title: 'Start the tournament',
  splashStep3Desc: 'The bracket is generated automatically',
  splashStep4Title: 'Manage matches live',
  splashStep4Desc: 'Score every shot, track the clock, view results',
  splashReadyTitle: 'Ready to run your shootout?',
  splashGetStarted: '🏆 Get Started Free',
  splashGetStartedPaid: '🏆 Create Account',
  splashPricingAllFree: 'All tournaments are free — no payment required.',
  splashPricingPaidOnly: 'Tournaments are {price} each — create an account to get started.',
  splashPricingOneFree: 'Your first tournament is free, then {price} each after that.',
  splashPricingNFree: 'Your first {n} tournaments are free, then {price} each after that.',
  privacyPolicy: 'Privacy Policy',
  resend: 'Resend',
  resending: 'Sending…',
  newLinkSent: '✓ New link sent — check your inbox',
  didntGetIt: "Didn't get it? Resend email",
  sendResetCode: 'Send Reset Code',
  verifyCode: 'Verify Code',
  verifying: 'Verifying…',
  resendCode: 'Resend code',
  handicapStart: '🏅 Handicap Start',
  noPlayersFound: 'No players found across your tournaments.',
  noPlayersMatching: 'No players matching',
  navContact: 'Contact',
  navPublic: 'Public',
  navFaq: 'Help & FAQ',
  navLeagues: 'Leagues',
  faqSubtitle: 'Everything you need to know about running a Shootout, Snooker 900, or Standard tournament.',
  faqSearch: 'Search questions…',
  faqNoResults: 'No questions match your search.',
  faqContact: 'Still have a question?',
  faqContactLink: 'Get in touch via the Contact page',
  paymentsEnabled: 'Payments ENABLED',
  paymentsDisabled: 'Payments DISABLED',
  statusLabel: 'Status',
  fromLabel: 'From',
  freeForLife: '♾ Free',
  freeForLifeGranted: '♾ Free ✓',
  createAccount: '🏆 Create Account',
  splashSignIn: 'Sign In',
  splashSignUp: 'Sign Up',
  dontHaveAccount: "Don't have an account?",
  createFreeAccount: 'Create free account',
  signInNow: '🏆 Sign In Now',
  orContinueWith: 'or continue with',
  continueWithGoogle: 'Continue with Google',
  continueWithFacebook: 'Continue with Facebook',
  oauthErrorTitle: 'Sign-In Failed',
  oauthErrorGeneric: 'Something went wrong signing you in. Please try again.',
  oauthErrorEmailNotVerified: "That account doesn't have a verified email address, so we can't sign you in with it.",
  oauthErrorAccountSuspended: 'This account has been suspended.',
  oauthErrorDenied: 'You cancelled sign-in.',
  oauthErrorProviderDisabled: 'Sign-in with this provider is currently turned off.',
  noPasswordSetError: 'This account signs in with Google or Facebook — use one of those buttons instead.',
  navPlayersAdmin: '⚙ Players',
  allPlayersDesc: 'All players across every tournament you have created. Click the photo to update it; handicaps are editable.',
  pwStrengthWeak: 'Weak',
  pwStrengthFair: 'Fair',
  pwStrengthGood: 'Good',
  pwStrengthStrong: 'Strong',
  pauseShotClock: 'Pause',
  resumeShotClock: 'Resume',
  newTournamentTitle: '🏆 New Tournament',
  editTournamentTitle: '✎ Edit Tournament',
  locationLabel: '📍 Location / Venue',
  locationPlaceholder: 'e.g. The Crown, Manchester',
  locationHint: 'Optional — shown on the tournament card.',
  entryFeeLabel: '💰 Entry Fee',
  entryFeeHint: 'Leave blank if there is no entry fee.',
  prizePlacesLabel: '🏆 Prize Places',
  prizePlacesNone: 'None',
  prizePlacesHint: 'Select how many finishing places receive prize money.',
  prizePoolLabel: 'Total prize pool',
  matchFormatLabel: '🔴 Match Format',
  shootoutDesc: 'Shootout: 10-min match · {r} reds · 15s shots (first 5 min) · 10s shots (last 5 min)',
  snooker900Desc: 'Snooker 900: 15-min match · {r} reds · 20s shots throughout',
  sixRedsLabel: '🔴 Six Reds — only 6 reds used instead of 15',
  sixRedsDesc: 'Six Reds',
  standardFormatHint: 'Standard snooker: no time limit · full scoring rules · {r} reds',
  bestOfDialogTitle: 'Frames Per Round',
  bestOfDialogDesc: "Choose how many frames are needed to win each round (odd numbers only, so there's always a winner).",
  bestOfContinueBtn: 'Continue',
  bestOfBackBtn: 'Back',
  handicapHint: "When enabled, enter each player's handicap on registration. The weaker player receives an advantage equal to the difference.",
  makePublicLabel: 'Public Tournament',
  makePublicHint: 'Anyone signed in can view the bracket and watch matches live.',
  cancelBtn: 'Cancel',
  timedTournamentTitle: 'Timed Tournament',
  timedTournamentDesc: 'Shootout or Snooker 900 · shot clock enforced',
  standardTournamentTitle: 'Standard Tournament',
  standardTournamentDesc: 'Standard snooker rules · no time limit · optional six reds',
  chooseTournamentType: 'Choose the type of tournament you want to create.',
  completedTournamentsAppearHere: 'Completed tournaments appear here.',
  maxEntriesLabel: 'Max {n} entries',
  prizePlaceSingle: 'prize place',
  prizePlacePlural: 'prize places',
  prizePoolPrefix: 'Pool',
  entryLabel: 'Entry',
  handicapTournament: 'Handicap tournament',
  scratchTournament: 'Scratch tournament',
  highBreakPrizeDisplay: 'High break prize',
  noDateVenueWarning: 'No date, venue, entry fee or prizes set. Edit the tournament first for a richer poster.',
  additionalTextLabel: 'Additional text (optional)',
  additionalTextPlaceholder: 'e.g. All welcome! Contact John on 07700 900000 to enter.',
  additionalTextHint: 'Printed at the bottom of the poster.',
  downloadPdfPoster: '⬇ Download PDF Poster',
  generatingPoster: '⏳ Generating…',
  paymentGateTitle: 'New Tournament',
  paymentGateDesc: "You've used your free tournament allowance. A one-off payment of {amount} is required to create another tournament.",
  editBtn: '✎ Edit',
  posterBtn: '🖨 Poster',
  sharedBadge: 'Shared',
  publicBadge: 'Public',
  privateBadge: 'Private',
  togglePublicHint: 'Click to switch between public and private',
  adminsBtn: 'Admins',
  adminsDesc: 'Admins have full scoring and management access to this tournament, except deleting it or managing this list.',
  usernamePlaceholder: 'Username…',
  addBtn: 'Add',
  removeBtn: 'Remove',
  noAdminsYet: 'No admins added yet.',
  statusRegistrationLabel: 'Registration',
  statusActiveLabel: 'In Progress',
  statusCompleteLabel: 'Complete',
    emailAddress: 'Email',
  splashTagline: 'Run your shootout tournament like a pro.',
  splashSubtitle: 'Live scoring, shot clocks, player profiles and full match history — run under Shootout or Snooker 900 rules. First tournament free.',
  splashSubtitleAllFree: 'Live scoring, shot clocks, player profiles and full match history — run under Shootout or Snooker 900 rules. All tournaments free.',
  splashSubtitlePaid: 'Live scoring, shot clocks, player profiles and full match history — run under Shootout or Snooker 900 rules.',
  splashSubtitleNFree: 'Live scoring, shot clocks, player profiles and full match history — run under Shootout or Snooker 900 rules. First {n} tournaments free.',
  splashNoCreditCard: 'No credit card required · First tournament free',
  splashNoCreditCardAllFree: 'No credit card required · All tournaments free',
  splashNoCreditCardPaid: 'No credit card required',
  splashNoCreditCardNFree: 'No credit card required · First {n} tournaments free',
  splashStep1Title: 'Create your account',
  splashStep1Desc: 'Sign up with email — verified instantly. First tournament free.',
  splashStep1DescAllFree: 'Sign up with email — verified instantly. All tournaments free.',
  splashStep1DescPaid: 'Sign up with email — verified instantly.',
  splashStep1DescNFree: 'Sign up with email — verified instantly. First {n} tournaments free.',
  whoBreaks: 'Who Breaks?',
  whoBreaksDesc: 'Select the player who will break off. The match clock starts when you confirm.',
  breakOffBtn: 'Break Off',
  breaksOff: 'Breaks Off',
  selectPlayerFirst: 'Select a player above first',
  matchClockStartsOnBreak: 'The match clock starts when the break-off is confirmed.',
  foulCueBallInHand: 'Foul — Cue Ball in Hand',
  pointsAwardedToOpponent: 'points awarded to the opponent.',
  toPlayFromHand: 'to play from hand.',
  clocksPausedMsg: 'Both clocks are paused.',
  resumeMatch: '▶ Resume Match',
  freeBallLabel: 'Free ball',
  freeBallSnookeredMsg: 'is snookered on every ball. Their next shot may nominate any ball; it scores as the real ball on.',
  freeBallActiveBanner: '🔴 FREE BALL — nominate any ball for this shot',
  respotBlackBanner: '🎱 BLACK RE-SPOTTED — frame level, who won the toss?',
  higherValueFoul: 'Higher value foul',
  selectHighestBallTouched: 'Select the highest value ball touched',
  highestBreakLabel: 'Highest Break',
  highBreakPrizeLabel: '🔴 High Break Prize',
  highBreakPrizeHint: 'Optional prize awarded to the player with the highest break. Shown on the poster.',
  contactTitle: 'Contact Us',
  contactSubtitle: "Have a question or feedback? Send us a message and we'll get back to you.",
  contactSubjectLabel: 'Subject',
  contactMessageLabel: 'Message',
  contactSendBtn: '✉ Send Message',
  contactSentTitle: 'Message Sent',
  contactSentDesc: "Thanks for reaching out! We'll reply as soon as we can.",
  contactSendAnother: 'Send another message',
  contactAimToRespond: 'We aim to respond within 1–2 business days.',
  changeEmailTitle: 'Change Email Address',
  changeEmailNewLabel: 'New email address',
  changeEmailSendBtn: 'Send Verification Email',
  sendPasswordResetLink: 'Send a password reset link to',
  backToSignIn: '← Back to Sign In',
  viewDraw: 'View draw →',
  loadingTournament: 'Loading tournament…',
  loadingMatch: 'Loading match…',
  tournamentNotFound: 'Tournament not found',
  matchNotFound: 'Match not found',
  backToHistory: '← Back to History',
  backToDraw: '← Back to Draw',
  backToUsers: '← Back to Users',
  deleteTournamentTitle: 'Delete Tournament',
  deleteTournamentConfirm: 'This will permanently remove the tournament and all its match data. This cannot be undone.',
  tournamentsHeading: 'Tournaments',
  loadingTournaments: 'Loading tournaments…',
  noTournamentsYet: "This user hasn't created any tournaments yet.",
  viewThisUsersTournaments: "View this user's tournaments",
  grantFreeForLife: 'Grant free tournaments for life',
  revokeFreeForLife: 'Revoke free tournaments',
  bracketWinner: 'Winner',
  bracketChampionTitle: 'Champion',
  bracketSavingLabel: 'Saving…',
  bracketSaveResult: 'Save Result',
  bracketEntries: 'entries',
  bracketEntry: 'entry',
  bracketPrizePool: 'prize pool',
  bracketHighBreak: 'high break',
  bracketSixReds: 'Six Reds',
  bracketHandicap: 'Handicap',
  bracketShootoutLabel: 'Shootout',
  bracketSnooker900Label: 'Snooker 900',
  bracketStandardLabel: 'Standard',
  bracketPlace: 'place',
  bracketPlaces: 'places',
  statsPlayersLabel: 'Players',
  statsHighBreakLabel: 'High Break',
  statsDateLabel: 'Date',
  statsVenueLabel: 'Venue',
  spectatorView: 'Spectator view — another device is scoring this match',
  resetLinkInvalidTitle: 'Reset Link Invalid',
  resetLinkExpiredMsg: 'This reset link has expired.',
  resetLinkInvalidMsg: 'This reset link is invalid or has already been used.',
  emailUpdatedTitle: 'Email Updated',
  emailChangeLinkInvalidTitle: 'Link Invalid',
  emailAlreadyTaken: 'That email address has already been taken by another account.',
  emailChangeLinkInvalidMsg: 'This email change link is invalid or has already been used.',
  accountSuspendedTitle: 'Account Suspended',
  accountSuspendedMsg: 'Your account has been suspended.',
  editMatchResult: 'Edit Match Result',
  adminOnlineNow: 'Online now (5 min)',
  adminTotalAccounts: 'Total accounts',
  adminAwaitingVerification: 'Awaiting verification',
  adminNewThisWeek: 'New this week',
  adminNewThisMonth: 'New this month',
  adminMatchesInProgress: 'Matches in progress',
  adminInProgress: 'In progress',
  adminUniquePlayerEntries: 'Unique player entries',
  adminTotalEver: 'Total ever',
  adminLoadingStats: 'Loading stats…',
  settingsSavePrices: 'Save Prices',
  settingsCurrentState: 'Current state:',
  settingsTimedLabel: 'Timed',
  settingsStandardLabel: 'Standard',
  settingsPerUserOverrides: 'Per-user overrides',
  usersAccountStates: 'Account states:',
  usersActiveState: 'Active',
  usersPendingState: 'Pending',
  usersSuspendedState: 'Suspended',
  usersDeactivatedState: 'Deactivated',
  loadingLabel: 'Loading…',
  leaguesEmptyDesc: 'Run a season-long, team-based competition — divisions, fixtures and standings. Create your first league to get started.',
  createLeagueBtn: '+ Create League',
  leagueNamePlaceholder: 'League name',
  divisionTabTeams: '👥 Teams',
  divisionTabFixtures: '📅 Fixtures',
  divisionTabStandings: '🏆 Standings',
  standingsTeamCol: 'Team',
  noTeamsInDivision: 'No teams in this division yet.',
  fixtureStatusScheduled: 'Scheduled',
  fixtureStatusLineupSet: 'Lineup set',
  fixtureStatusInProgress: 'In progress',
  backToFixture: '← Back to Fixture',
  publicLeaguesTitle: '🌐 Public Leagues',
  publicLeaguesDesc: 'Browse and spectate leagues other organisers have made public.',
  noPublicLeaguesYet: 'No public leagues yet.',
  backToPublicLeagues: '← Public Leagues',
  noFixturesYetLabel: 'No fixtures yet.',
  noTeamsYetLabel: 'No teams yet.',
  backToAllSeasons: '← All seasons',
  noPastSeasonsYet: 'No past seasons yet.',
  noPastSeasonsYetOwner: 'No past seasons yet — they\'ll appear here after this division\'s first "End Season".',
  endedLabel: 'Ended',
  promotedLabel: 'promoted',
  relegatedLabel: 'relegated',
  finalStandingsLabel: 'Final standings',
  fixturesLabel: 'Fixtures',
  historyTabLabel: '📜 History',
  doubleRoundRobinLabel: 'Home & away (double round-robin)',
  pendingClaimApprovalLabel: '⏳ pending approval',
  approveBtn: 'Approve',
  rejectBtn: 'Reject',
  tierFieldLabel: 'Tier (1 = top division)',
  promotionSpotsFieldLabel: 'Promotion spots (default)',
  relegationSpotsFieldLabel: 'Relegation spots (default)',
  seasonManagementHint: "Season management: this division's rank tier (1 = top) and the default promotion/relegation counts pre-filled into the next End Season preview. These can be overridden per-season when ending a season.",
  togglePublicTooltip: 'Toggle whether any signed-in user can browse and spectate this league',
  toggleClaimApprovalTooltip: 'Toggle whether roster self-claims need owner/admin approval before taking effect',
  publicChipLabel: '🌐 Public',
  privateChipLabel: '🔒 Private',
  claimsApprovalChipLabel: '🛂 Claims: Approval',
  claimsInstantChipLabel: '⚡ Claims: Instant',
  endSeasonBtn: '🏁 End Season',
  browsePublicLeaguesLink: '🌐 Browse Public Leagues',
  myStatsTitle: 'My Stats',
  statsPlayedLabel: 'Played',
  statsWonLabel: 'Won',
  statsLostLabel: 'Lost',
  seasonLabelFieldLabel: 'Season label',
  seasonLabelPlaceholder: 'e.g. 2025/26',
  seasonCountsHint: "Promotion/relegation counts for this season — pre-filled from each division's defaults, editable just this once.",
  tierLabel: 'tier',
  previewBtn: 'Preview →',
  reviewMovesHint: "Review proposed moves below — untick any team you want to leave in its current division. Every division's fixtures will be archived and reset regardless.",
  noMovesThisSeason: 'No promotion/relegation moves this season.',
  confirmEndSeasonBtn: 'Confirm & End Season',
};

const es: Translations = {
  langName: 'Español',
  appName: 'Shootout Comps',
  signIn: 'Iniciar sesión',
  signingIn: 'Iniciando sesión…',
  navBracket: 'Torneo',
  statusRegistration: 'Registro abierto',
  players: 'Jugadores',
  removePlayer: 'Eliminar',
  slotsRemaining: 'lugares disponibles',
  noPlayersYet: 'Sin jugadores registrados aún',
  awaitingDraw: 'Esperando sorteo',
  champion: 'Campeón',
  clickToPlay: '→ Clic para jugar',
  matchComplete: 'Partido completado',
  notStarted: 'No iniciado',
  startMatchDesc: '¿Listo para comenzar? Al iniciar comenzará el reloj de 10 minutos.',
  shotClockDesc: 'Reloj de golpe: 15s los primeros 5 min · 10s los últimos 5 min',
  atTheTable: 'En la mesa',
  nextLegalPot: 'Próxima bola legal:',
  miss: 'Fallo',
  cancelFoul: 'Cancelar',
  noContact: 'Sin contacto',
  undo: 'Deshacer',
  cueBallPotted: 'Bola blanca embocada',
  endMatchEarly: 'Terminar partido antes',
  finishMatchBtn: 'Finalizar partido',
  finishFrameBtn: 'Finalizar frame',
  enterFinalScore: 'Introduce el resultado final:',
  scoresInvalid: 'Introduce dos resultados diferentes',
  shotHistory: 'Historial de golpes',
  firstHalf: '1ª mitad — 15s por golpe',
  backToBracket: '← Volver al torneo',
  shotClockExpired: 'RELOJ DE GOLPE EXPIRADO',
  matchClockExpired: 'RELOJ DE PARTIDO EXPIRADO',
  dismiss: 'Cerrar',
  foulToOpponent: 'Falta — +{n} al rival',
  noPotnPlayerChanged: '↩ Sin emboque — cambio de jugador',
  cannotUndo: 'No se puede deshacer',
  adminDashboard: 'Panel de administración',
  registrationOpen: 'Registro abierto',
  tournamentName: 'Nombre del torneo',
  newTournament: '🆕 Nuevo Torneo',
  newTournamentDesc: 'Iniciar un nuevo torneo archiva el actual.',
  startNewTournament: 'Iniciar Nuevo Torneo',
  tournamentHistory: 'Historial de torneos',
  noHistoryDesc: 'Los torneos completados aparecerán aquí después de reiniciar.',
  viewDetails: '→ Ver detalles',
  participants: 'Participantes',
  userManagement: 'Gestión de usuarios',
  you: 'Tú',
  resetPasswordBtn: '🔑 Restablecer',
  passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
  userIsolationNote: 'Cada usuario solo puede ver y gestionar sus propios torneos.',
  voiceHalfTime: 'Reloj de golpe de 10 segundos en operación',
  language: 'Idioma',
  profile: 'My Profile',
  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  passwordChanged: 'Password changed successfully.',
  forgotPassword: 'Forgot password?',
  sendResetLink: 'Send Reset Link',
  resetLinkSent: 'Reset link sent — check your email.',
  resetPassword: 'Reset Password',
  resetPasswordDesc: "Enter your email and we'll send a reset link.",
  setNewPassword: 'Set New Password',
  accountDetails: 'Account Details',
  memberSince: 'Member since',
  tournamentsTitle: 'Torneos',
  newTournament2: '+ Nuevo Torneo',
  currentTournament: 'Torneo Actual',
  pastTournaments: 'Torneos Pasados',
  publicTournamentsHeading: 'Torneos Públicos',
  publicTournamentsSubtitle: 'Torneos que otros usuarios han hecho públicos — cualquier usuario con sesión iniciada puede ver el cuadro y seguir los partidos en directo.',
  noPublicTournaments: 'No hay torneos públicos por ahora.',
  hostedByLabel: 'Organizado por',
  watchLiveBtn: 'Ver en Directo',
  backToPublicList: 'Volver a Torneos Públicos',
  spectatingBadge: '👀 Viendo',
  noHistoryYet: 'Aun no hay torneos pasados.',
  noHistoryYetDesc: 'Los torneos completados apareceran aqui.',
  createTournament: 'Crear Torneo',
  nextBtn: 'Siguiente',
  backBtn: 'Atrás',
  editTournament: 'Editar Torneo',
  tournamentNameLabel: 'Nombre del Torneo',
  dateTimeLabel: 'Fecha y Hora',
  dateTimeHint: 'Mostrado en la lista de torneos',
  maxPlayersLabel: 'Maximo de Jugadores',
  maxPlayersHint: 'Los huecos vacios se rellenan con BYEs',
  handicapLabel: 'Torneo con Handicap',
  handicapOnDesc: 'Handicap ACTIVADO — ventaja de puntos',
  handicapOffDesc: 'Handicap DESACTIVADO — torneo libre',
  pauseClocks: 'Pausar Relojes',
  resumeClocks: 'Reanudar Relojes',
  saveChanges: 'Guardar Cambios',
  confirmCreateTitle: 'Iniciar Nuevo Torneo?',
  confirmCreateMsg: 'El torneo actual se archivara.',
  cancelLabel: 'Cancelar',
  confirmLabel: 'Confirmar',
  registrationLabel: 'Registro',
  activeLabel: 'En Curso',
  completeLabel: 'Completado',
  maxLabel: 'Max',
  handicapBadge: 'Handicap',
  playerManagement: 'Gestion de Jugadores',
  playerManagementDesc: 'Clic en la foto para cambiarla',
  deletePlayerTitle: 'Eliminar Jugador',
  deletePlayerMsg: 'Este jugador sera eliminado.',
  changePhoto: 'Foto',
  deletePlayer: 'Eliminar',
  newPhotoSelected: 'Nueva foto seleccionada',
  handicapEditHint: 'Handicap',
  handicapValue: 'Hándicap',
  clickToEditHandicap: 'Haz clic para editar el hándicap',
  playerCountAll: '{n} jugador{s} en todos los torneos',
  playerCountMatch: '{n} jugador{s} que coinciden con "{q}"',
  clickToChangePhoto: 'Clic para cambiar foto',
  photoFromPrevious: 'Foto de torneo anterior',
  handicapStartTitle: 'Inicio con Handicap',
  handicapStartDesc: 'Ventaja aplicada al inicio',
  debugJumpBtn: 'Debug: Saltar a 5:30',
  pointsAdvantageApplied: 'Ventaja aplicada al inicio',
  handicapPts: 'pts — mayor = jugador más débil = más puntos de ventaja',
  passwordWeak: 'Débil',
  passwordFair: 'Regular',
  passwordGood: 'Buena',
  passwordStrong: 'Fuerte',
  passwordsNoMatch: 'Las contraseñas no coinciden',
  repeatPassword: 'Repetir Contraseña',
  creatingAccount: 'Creando cuenta…',
  minChars: 'Mín. 8 caracteres',
  usernameHint: 'Letras, números, espacios, guiones bajos y guiones',
  deactivateAccount: 'Desactivar Cuenta',
  newPasswordMin: 'Nueva contraseña (mín. 8)',
  suspensionReason: 'Razón de suspensión (opcional)',
  confirmSuspend: 'Confirmar Suspensión',
  passwordUpdated: 'Contraseña actualizada ✓',
  addNewUser: 'Añadir Usuario',
  addPlayer: 'Añadir Jugador',
  allUsers: 'Todos los Usuarios',
  awaitingDrawDesc: 'Registra jugadores y luego inicia el torneo.',
  ballOffTable: 'Bola Fuera',
  byesAdded: '{n} BYE(s) añadidos',
  cancel: 'Cancelar',
  complete: 'Completo',
  connecting: 'Conectando…',
  createUser: '+ Añadir',
  creating: 'Creando…',
  declareWinner: 'Declarar ganador:',
  deleteUser: 'Eliminar',
  dir: 'ltr',
  elapsed: 'transcurrido',
  endMatchToDeclare: 'Termina el partido para declarar ganador',
  foul: 'Falta',
  inProgress: 'En Curso',
  inProgressStatus: 'Torneo en curso',
  joined: 'Se unió',
  splashTagline: 'Organiza tu torneo de billar snooker como un profesional.',
  splashSubtitle: 'Marcador en vivo, relojes de tiro, perfiles de jugadores e historial completo — bajo reglas Shootout o Snooker 900. Primer torneo gratis.',
  splashSubtitleAllFree: 'Marcador en vivo, relojes de tiro, perfiles de jugadores e historial completo. Todos los torneos son gratuitos.',
  splashSubtitlePaid: 'Marcador en vivo, relojes de tiro, perfiles de jugadores e historial completo.',
  splashSubtitleNFree: 'Marcador en vivo, relojes de tiro, perfiles de jugadores e historial completo. Primeros {n} torneos gratis.',
  splashNoCreditCard: 'Sin tarjeta de crédito · Primer torneo gratis',
  splashNoCreditCardAllFree: 'Sin tarjeta de crédito · Todos los torneos gratis',
  splashNoCreditCardPaid: 'Sin tarjeta de crédito',
  splashNoCreditCardNFree: 'Sin tarjeta de crédito · Primeros {n} torneos gratis',
  splashStep1Title: 'Crea tu cuenta',
  splashStep1Desc: 'Regístrate con correo electrónico. Primer torneo gratis.',
  splashStep1DescAllFree: 'Regístrate con correo electrónico. Todos los torneos gratuitos.',
  splashStep1DescPaid: 'Regístrate con correo electrónico.',
  splashStep1DescNFree: 'Regístrate con correo electrónico. Primeros {n} torneos gratis.',
  whoBreaks: '¿Quién saca?',
  whoBreaksDesc: 'Selecciona el jugador que sacará. El reloj comienza al confirmar.',
  breakOffBtn: 'Sacar',
  breaksOff: 'Saca',
  selectPlayerFirst: 'Selecciona un jugador primero',
  matchClockStartsOnBreak: 'El reloj del partido comienza al confirmar el saque.',
  foulCueBallInHand: 'Falta — Bola libre',
  pointsAwardedToOpponent: 'puntos otorgados al oponente.',
  toPlayFromHand: 'juega con bola en mano.',
  clocksPausedMsg: 'Ambos relojes están pausados.',
  resumeMatch: '▶ Reanudar partido',
  freeBallLabel: 'Free ball',
  freeBallSnookeredMsg: 'está snookered en todas las bolas. Su siguiente tiro puede nominar cualquier bola; puntúa como la bola real en juego.',
  freeBallActiveBanner: '🔴 FREE BALL — elige cualquier bola para este tiro',
  respotBlackBanner: '🎱 NEGRA RECOLOCADA — frame igualado, ¿quién ganó el sorteo?',
  higherValueFoul: 'Falta de mayor valor',
  selectHighestBallTouched: 'Selecciona la bola de mayor valor tocada',
  highestBreakLabel: 'Mayor serie',
  highBreakPrizeLabel: '🔴 Premio a la mayor serie',
  highBreakPrizeHint: 'Premio opcional al jugador con la mayor serie. Aparece en el cartel.',
  contactTitle: 'Contáctanos',
  contactSubtitle: '¿Tienes alguna pregunta? Envíanos un mensaje.',
  contactSubjectLabel: 'Asunto',
  contactMessageLabel: 'Mensaje',
  contactSendBtn: '✉ Enviar mensaje',
  contactSentTitle: 'Mensaje enviado',
  contactSentDesc: '¡Gracias por contactarnos! Te responderemos pronto.',
  contactSendAnother: 'Enviar otro mensaje',
  contactAimToRespond: 'Respondemos en 1–2 días hábiles.',
  changeEmailTitle: 'Cambiar correo electrónico',
  changeEmailNewLabel: 'Nuevo correo electrónico',
  changeEmailSendBtn: 'Enviar correo de verificación',
  sendPasswordResetLink: 'Enviar enlace de restablecimiento a',
  backToSignIn: '← Volver al inicio de sesión',
  viewDraw: 'Ver cuadro →',
  loadingTournament: 'Cargando torneo…',
  loadingMatch: 'Cargando partido…',
  tournamentNotFound: 'Torneo no encontrado',
  matchNotFound: 'Partido no encontrado',
  backToHistory: '← Volver al historial',
  backToDraw: '← Volver al cuadro',
  backToUsers: '← Volver a usuarios',
  deleteTournamentTitle: 'Eliminar torneo',
  deleteTournamentConfirm: 'Esto eliminará permanentemente el torneo y todos sus datos.',
  tournamentsHeading: 'Torneos',
  loadingTournaments: 'Cargando torneos…',
  noTournamentsYet: 'Este usuario aún no ha creado torneos.',
  viewThisUsersTournaments: 'Ver torneos de este usuario',
  grantFreeForLife: 'Conceder torneos gratuitos de por vida',
  revokeFreeForLife: 'Revocar torneos gratuitos',
    langFlag: '🇪🇸',
  lastShotUndone: '↩ Último golpe deshecho',
  live: 'EN VIVO',
  losesTheFrame: 'pierde el cuadro',
  matchesDone: 'Partidos Jugados',
  navAdmin: 'Admin',
  navHistory: 'Torneos',
  navPlayers: 'Añadir Jugadores',
  navUsers: 'Usuarios',
  noHistory: 'Sin torneos pasados.',
  noPot: 'Sin potear',
  nothingToUndo: 'Nada que deshacer',
  password: 'Contraseña',
  playerName: 'Nombre del jugador…',
  plusToOpponent: '+{n} al oponente',
  potBall: 'Potear bola',
  potted: '{ball} poteada (+{n})',
  redsRemaining: 'rojas restantes',
  registered: 'registrado',
  remaining: 'restante',
  rounds: 'Rondas',
  save: 'Guardar',
  saving: 'Guardando…',
  secondHalf: '2ª Parte',

  selectFoulBall: 'Selecciona la bola con falta:',
  selectFoulType: 'Tipo de falta',
  shotClock: 'Reloj de golpe',
  shotsCount: 'golpes',
  shotsPlayed: 'Golpes jugados',
  signOut: 'Cerrar sesión',
  startMatch: 'Iniciar Partido',
  startTournament: 'Iniciar Torneo',
  statusActive: '● En Curso',
  statusComplete: '✓ Completo',
  superuser: 'superusuario',
  tapBallAbove: 'Toca la bola con falta arriba',
  tournamentStatus: 'Estado del Torneo',
  user: 'usuario',
  username: 'Nombre de usuario',
  viewDetails2: 'Ver cuadro y resultados',
  vsLabel: 'VS',
  wins: 'gana',
  roundFinal: 'Final',
  roundSemiFinals: 'Semifinales',
  roundQuarterFinals: 'Cuartos de final',
  roundOf16: 'Ronda de 16',
  roundOf: 'Ronda de',
  owner: 'Propietario',
  timePlayed: 'jugado',
  matchesPlayed: 'jugados',
  noPlayersRegistered: 'No hay jugadores registrados aún',
  startTypingPlayers: 'Empieza a escribir para ver jugadores de torneos anteriores',
  startTournamentConfirm: '¿Iniciar el torneo? El cuadro se generará automáticamente.',
  splashFeaturesHeading: 'Todo lo que necesitas para organizar un shootout',
  splashFooterTagline: 'Shootout Comps — Gestión de torneos',
  splashUpAndRunning: 'En marcha en minutos',
  splashStep2Title: 'Registra tus jugadores',
  splashStep2Desc: 'Añade hasta 32 jugadores con fotos',
  splashStep3Title: 'Inicia el torneo',
  splashStep3Desc: 'El cuadro se genera automáticamente',
  splashStep4Title: 'Gestiona partidos en vivo',
  splashStep4Desc: 'Puntúa cada tiro, controla el reloj, ve los resultados',
  splashReadyTitle: '¿Listo para tu shootout?',
  splashGetStarted: '🏆 Empezar gratis',
  splashGetStartedPaid: '🏆 Crear cuenta',
  splashPricingAllFree: 'Todos los torneos son gratuitos — sin pago requerido.',
  splashPricingPaidOnly: 'Los torneos cuestan {price} cada uno.',
  splashPricingOneFree: 'Tu primer torneo es gratis, luego {price} cada uno.',
  splashPricingNFree: 'Tus primeros {n} torneos son gratis, luego {price} cada uno.',
  privacyPolicy: 'Política de privacidad',
  resend: 'Reenviar',
  resending: 'Enviando…',
  newLinkSent: '✓ Nuevo enlace enviado — revisa tu correo',
  didntGetIt: '¿No lo recibiste? Reenviar correo',
  sendResetCode: 'Enviar código de restablecimiento',
  verifyCode: 'Verificar código',
  verifying: 'Verificando…',
  resendCode: 'Reenviar código',
  handicapStart: '🏅 Inicio con hándicap',
  noPlayersFound: 'No se encontraron jugadores en tus torneos.',
  noPlayersMatching: 'Sin jugadores que coincidan con',
  navContact: 'Contacto',
  navPublic: 'Público',
  navFaq: 'Ayuda y FAQ',
  navLeagues: 'Ligas',
  faqSubtitle: 'Todo lo que necesitas saber para organizar un torneo Shootout, Snooker 900 o Estándar.',
  faqSearch: 'Buscar preguntas…',
  faqNoResults: 'Ninguna pregunta coincide con tu búsqueda.',
  faqContact: '¿Aún tienes una pregunta?',
  faqContactLink: 'Contáctanos desde la página de contacto',
  paymentsEnabled: 'Pagos ACTIVADOS',
  paymentsDisabled: 'Pagos DESACTIVADOS',
  statusLabel: 'Estado',
  fromLabel: 'De',
  freeForLife: '♾ Gratis',
  freeForLifeGranted: '♾ Gratis ✓',
  createAccount: '🏆 Crear cuenta',
  splashSignIn: 'Iniciar sesión',
  splashSignUp: 'Registrarse',
  dontHaveAccount: '¿No tienes cuenta?',
  createFreeAccount: 'Crear cuenta gratis',
  signInNow: '🏆 Iniciar sesión ahora',
  orContinueWith: 'o continúa con',
  continueWithGoogle: 'Continuar con Google',
  continueWithFacebook: 'Continuar con Facebook',
  oauthErrorTitle: 'Error al iniciar sesión',
  oauthErrorGeneric: 'Algo salió mal al iniciar sesión. Inténtalo de nuevo.',
  oauthErrorEmailNotVerified: 'Esa cuenta no tiene un correo electrónico verificado, así que no podemos iniciar sesión con ella.',
  oauthErrorAccountSuspended: 'Esta cuenta ha sido suspendida.',
  oauthErrorDenied: 'Has cancelado el inicio de sesión.',
  oauthErrorProviderDisabled: 'El inicio de sesión con este proveedor está desactivado actualmente.',
  noPasswordSetError: 'Esta cuenta inicia sesión con Google o Facebook: usa uno de esos botones en su lugar.',
  navPlayersAdmin: '⚙ Jugadores',
  allPlayersDesc: 'Todos los jugadores de todos los torneos que has creado. Haz clic en la foto para actualizarla; los hándicaps son editables.',
  pwStrengthWeak: 'Débil',
  pwStrengthFair: 'Regular',
  pwStrengthGood: 'Buena',
  pwStrengthStrong: 'Fuerte',
  pauseShotClock: 'Pausar',
  resumeShotClock: 'Reanudar',
  newTournamentTitle: '🏆 Nuevo Torneo',
  editTournamentTitle: '✎ Editar Torneo',
  locationLabel: '📍 Lugar / Sede',
  locationPlaceholder: 'ej. El Bar Crown, Madrid',
  locationHint: 'Opcional — se muestra en la tarjeta del torneo.',
  entryFeeLabel: '💰 Cuota de inscripción',
  entryFeeHint: 'Deja en blanco si no hay cuota.',
  prizePlacesLabel: '🏆 Puestos premiados',
  prizePlacesNone: 'Ninguno',
  prizePlacesHint: 'Selecciona cuántos puestos reciben premio.',
  prizePoolLabel: 'Premio total',
  matchFormatLabel: '🔴 Formato del partido',
  shootoutDesc: 'Shootout: 10 min · {r} rojas · 15s tiros (5 min) · 10s (últimos 5)',
  snooker900Desc: 'Snooker 900: 15 min · {r} rojas · 20s tiros',
  sixRedsLabel: '🔴 Seis Rojas — solo 6 rojas en lugar de 15',
  sixRedsDesc: 'Seis Rojas',
  standardFormatHint: 'Snooker estándar: sin límite de tiempo · reglas completas · {r} rojas',
  bestOfDialogTitle: 'Frames por ronda',
  bestOfDialogDesc: 'Elige cuántos frames se necesitan para ganar cada ronda (solo números impares, para que siempre haya un ganador).',
  bestOfContinueBtn: 'Continuar',
  bestOfBackBtn: 'Atrás',
  handicapHint: 'Cuando esté activado, ingresa el hándicap de cada jugador. El jugador más débil recibe la diferencia de ventaja.',
  makePublicLabel: 'Torneo Público',
  makePublicHint: 'Cualquier usuario con sesión iniciada podrá ver el cuadro y seguir los partidos en directo.',
  cancelBtn: 'Cancelar',
  timedTournamentTitle: 'Torneo Cronometrado',
  timedTournamentDesc: 'Shootout o Snooker 900 · reloj de tiro',
  standardTournamentTitle: 'Torneo Estándar',
  standardTournamentDesc: 'Reglas estándar · sin límite de tiempo · seis rojas opcional',
  chooseTournamentType: 'Elige el tipo de torneo que quieres crear.',
  completedTournamentsAppearHere: 'Los torneos completados aparecen aquí.',
  maxEntriesLabel: 'Máx {n} participantes',
  prizePlaceSingle: 'puesto premiado',
  prizePlacePlural: 'puestos premiados',
  prizePoolPrefix: 'Premio',
  entryLabel: 'Inscripción',
  handicapTournament: 'Torneo con hándicap',
  scratchTournament: 'Torneo scratch',
  highBreakPrizeDisplay: 'Premio al máximo break',
  noDateVenueWarning: 'Sin fecha, sede, cuota ni premios. Edita el torneo primero para un póster más completo.',
  additionalTextLabel: 'Texto adicional (opcional)',
  additionalTextPlaceholder: 'ej. ¡Todos bienvenidos! Contacta a Juan al 07700 900000.',
  additionalTextHint: 'Se imprime al pie del póster.',
  downloadPdfPoster: '⬇ Descargar póster PDF',
  generatingPoster: '⏳ Generando…',
  paymentGateTitle: 'Nuevo Torneo',
  paymentGateDesc: 'Has usado tu torneo gratuito. Se requiere un pago único de {amount} para crear otro torneo.',
  editBtn: '✎ Editar',
  posterBtn: '🖨 Póster',
  sharedBadge: 'Compartido',
  publicBadge: 'Público',
  privateBadge: 'Privado',
  togglePublicHint: 'Haz clic para alternar entre público y privado',
  adminsBtn: 'Admins',
  adminsDesc: 'Los administradores tienen acceso completo para puntuar y gestionar este torneo, excepto eliminarlo o gestionar esta lista.',
  usernamePlaceholder: 'Nombre de usuario…',
  addBtn: 'Añadir',
  removeBtn: 'Eliminar',
  noAdminsYet: 'Aún no se han añadido administradores.',
  statusRegistrationLabel: 'Registro',
  statusActiveLabel: 'En curso',
  statusCompleteLabel: 'Completado',
  emailAddress: 'Email',
  bracketWinner: 'Ganador',
  bracketChampionTitle: 'Campeón',
  bracketSavingLabel: 'Guardando…',
  bracketSaveResult: 'Guardar resultado',
  bracketEntries: 'participantes',
  bracketEntry: 'participante',
  bracketPrizePool: 'premio total',
  bracketHighBreak: 'mejor serie',
  bracketSixReds: 'Seis Rojas',
  bracketHandicap: 'Hándicap',
  bracketShootoutLabel: 'Shootout',
  bracketSnooker900Label: 'Snooker 900',
  bracketStandardLabel: 'Estándar',
  bracketPlace: 'puesto',
  bracketPlaces: 'puestos',
  statsPlayersLabel: 'Jugadores',
  statsHighBreakLabel: 'Mejor Serie',
  statsDateLabel: 'Fecha',
  statsVenueLabel: 'Sede',
  spectatorView: 'Vista espectador — otro dispositivo está marcando este partido',
  resetLinkInvalidTitle: 'Enlace inválido',
  resetLinkExpiredMsg: 'Este enlace de restablecimiento ha expirado.',
  resetLinkInvalidMsg: 'Este enlace es inválido o ya fue usado.',
  emailUpdatedTitle: 'Email actualizado',
  emailChangeLinkInvalidTitle: 'Enlace inválido',
  emailAlreadyTaken: 'Esa dirección de email ya está en uso por otra cuenta.',
  emailChangeLinkInvalidMsg: 'Este enlace de cambio de email es inválido o ya fue usado.',
  accountSuspendedTitle: 'Cuenta suspendida',
  accountSuspendedMsg: 'Tu cuenta ha sido suspendida.',
  editMatchResult: 'Editar resultado del partido',
  adminOnlineNow: 'En línea ahora (5 min)',
  adminTotalAccounts: 'Total de cuentas',
  adminAwaitingVerification: 'Esperando verificación',
  adminNewThisWeek: 'Nuevos esta semana',
  adminNewThisMonth: 'Nuevos este mes',
  adminMatchesInProgress: 'Partidos en curso',
  adminInProgress: 'En curso',
  adminUniquePlayerEntries: 'Entradas únicas de jugadores',
  adminTotalEver: 'Total histórico',
  adminLoadingStats: 'Cargando estadísticas…',
  settingsSavePrices: 'Guardar precios',
  settingsCurrentState: 'Estado actual:',
  settingsTimedLabel: 'Cronometrado',
  settingsStandardLabel: 'Estándar',
  settingsPerUserOverrides: 'Excepciones por usuario',
  usersAccountStates: 'Estados de cuenta:',
  usersActiveState: 'Activo',
  usersPendingState: 'Pendiente',
  usersSuspendedState: 'Suspendido',
  usersDeactivatedState: 'Desactivado',
  loadingLabel: 'Cargando…',
  leaguesEmptyDesc: 'Organiza una competición por equipos a lo largo de toda la temporada — divisiones, partidos y clasificación. Crea tu primera liga para empezar.',
  createLeagueBtn: '+ Crear liga',
  leagueNamePlaceholder: 'Nombre de la liga',
  divisionTabTeams: '👥 Equipos',
  divisionTabFixtures: '📅 Partidos',
  divisionTabStandings: '🏆 Clasificación',
  standingsTeamCol: 'Equipo',
  noTeamsInDivision: 'Todavía no hay equipos en esta división.',
  fixtureStatusScheduled: 'Programado',
  fixtureStatusLineupSet: 'Alineación fijada',
  fixtureStatusInProgress: 'En curso',
  backToFixture: '← Volver al partido',
  publicLeaguesTitle: '🌐 Ligas Públicas',
  publicLeaguesDesc: 'Explora y observa ligas que otros organizadores han hecho públicas.',
  noPublicLeaguesYet: 'Todavía no hay ligas públicas.',
  backToPublicLeagues: '← Ligas Públicas',
  noFixturesYetLabel: 'Todavía no hay partidos.',
  noTeamsYetLabel: 'Todavía no hay equipos.',
  backToAllSeasons: '← Todas las temporadas',
  noPastSeasonsYet: 'Todavía no hay temporadas pasadas.',
  noPastSeasonsYetOwner: 'Todavía no hay temporadas pasadas — aparecerán aquí después de la primera "Finalizar Temporada" de esta división.',
  endedLabel: 'Finalizada',
  promotedLabel: 'ascendidos',
  relegatedLabel: 'descendidos',
  finalStandingsLabel: 'Clasificación final',
  fixturesLabel: 'Partidos',
  historyTabLabel: '📜 Historial',
  doubleRoundRobinLabel: 'Ida y vuelta (doble round-robin)',
  pendingClaimApprovalLabel: '⏳ aprobación pendiente',
  approveBtn: 'Aprobar',
  rejectBtn: 'Rechazar',
  tierFieldLabel: 'Nivel (1 = división superior)',
  promotionSpotsFieldLabel: 'Plazas de ascenso (por defecto)',
  relegationSpotsFieldLabel: 'Plazas de descenso (por defecto)',
  seasonManagementHint: 'Gestión de temporada: el nivel de esta división (1 = superior) y las plazas de ascenso/descenso por defecto que se rellenan en la próxima vista previa de Finalizar Temporada. Se pueden anular cada temporada.',
  togglePublicTooltip: 'Alternar si cualquier usuario registrado puede explorar y observar esta liga',
  toggleClaimApprovalTooltip: 'Alternar si las autorreclamaciones de la plantilla necesitan aprobación del propietario/admin',
  publicChipLabel: '🌐 Pública',
  privateChipLabel: '🔒 Privada',
  claimsApprovalChipLabel: '🛂 Reclamaciones: Aprobación',
  claimsInstantChipLabel: '⚡ Reclamaciones: Instantáneas',
  endSeasonBtn: '🏁 Finalizar Temporada',
  browsePublicLeaguesLink: '🌐 Explorar Ligas Públicas',
  myStatsTitle: 'Mis Estadísticas',
  statsPlayedLabel: 'Jugados',
  statsWonLabel: 'Ganados',
  statsLostLabel: 'Perdidos',
  seasonLabelFieldLabel: 'Nombre de la temporada',
  seasonLabelPlaceholder: 'p. ej. 2025/26',
  seasonCountsHint: 'Plazas de ascenso/descenso para esta temporada — rellenadas con los valores por defecto de cada división, editables solo por esta vez.',
  tierLabel: 'nivel',
  previewBtn: 'Vista previa →',
  reviewMovesHint: 'Revisa los movimientos propuestos abajo — desmarca cualquier equipo que quieras dejar en su división actual. Los partidos de todas las divisiones se archivarán y reiniciarán de todos modos.',
  noMovesThisSeason: 'No hay movimientos de ascenso/descenso esta temporada.',
  confirmEndSeasonBtn: 'Confirmar y Finalizar Temporada',
};

const fr: Translations = {
  langName: 'Français',
  appName: 'Shootout Comps',
  signIn: 'Se connecter',
  signingIn: 'Connexion…',
  navBracket: 'Tournoi',
  statusRegistration: 'Inscriptions ouvertes',
  players: 'Joueurs',
  removePlayer: 'Supprimer',
  slotsRemaining: 'places disponibles',
  noPlayersYet: 'Aucun joueur inscrit',
  awaitingDraw: 'En attente du tirage',
  champion: 'Champion',
  clickToPlay: '→ Cliquer pour jouer',
  matchComplete: 'Match terminé',
  notStarted: 'Pas commencé',
  startMatchDesc: 'Prêt à commencer ? Cela démarrera l\'horloge de 10 minutes.',
  shotClockDesc: 'Horloge de coup : 15s les 5 premières min · 10s les 5 dernières min',
  atTheTable: 'À la table',
  nextLegalPot: 'Prochain coup légal :',
  miss: 'Raté',
  cancelFoul: 'Annuler',
  noContact: 'Sans contact',
  undo: 'Annuler',
  cueBallPotted: 'Bille blanche empochée',
  endMatchEarly: 'Terminer le match tôt',
  finishMatchBtn: 'Terminer le match',
  finishFrameBtn: 'Terminer la manche',
  enterFinalScore: 'Saisir le score final :',
  scoresInvalid: 'Saisissez deux scores différents',
  shotHistory: 'Historique des coups',
  firstHalf: '1ère mi-temps — 15s/coup',
  backToBracket: '← Retour au tournoi',
  shotClockExpired: 'HORLOGE DE COUP EXPIRÉE',
  matchClockExpired: 'HORLOGE DU MATCH EXPIRÉE',
  dismiss: 'Fermer',
  foulToOpponent: 'Faute — +{n} à l\'adversaire',
  noPotnPlayerChanged: '↩ Raté — changement de joueur',
  cannotUndo: 'Impossible d\'annuler',
  adminDashboard: 'Tableau de bord admin',
  registrationOpen: 'Inscriptions ouvertes',
  tournamentName: 'Nom du tournoi',
  newTournament: '🆕 Nouveau tournoi',
  newTournamentDesc: 'Démarrer un nouveau tournoi archive le tournoi actuel.',
  startNewTournament: 'Nouveau tournoi',
  tournamentHistory: 'Historique des tournois',
  noHistoryDesc: 'Les tournois terminés apparaîtront ici.',
  viewDetails: '→ Voir les détails',
  participants: 'Participants',
  userManagement: 'Gestion des utilisateurs',
  you: 'Vous',
  resetPasswordBtn: '🔑 Réinit. MdP',
  passwordMinLength: 'Le mot de passe doit comporter au moins 8 caractères',
  userIsolationNote: 'Chaque utilisateur ne peut voir que ses propres tournois.',
  voiceHalfTime: 'Horloge de coup de 10 secondes maintenant en vigueur',
  language: 'Langue',
  profile: 'My Profile',
  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  passwordChanged: 'Password changed successfully.',
  forgotPassword: 'Forgot password?',
  sendResetLink: 'Send Reset Link',
  resetLinkSent: 'Reset link sent — check your email.',
  resetPassword: 'Reset Password',
  resetPasswordDesc: "Enter your email and we'll send a reset link.",
  setNewPassword: 'Set New Password',
  accountDetails: 'Account Details',
  memberSince: 'Member since',
  tournamentsTitle: 'Tournois',
  newTournament2: '+ Nouveau Tournoi',
  currentTournament: 'Tournoi en Cours',
  pastTournaments: 'Tournois Passes',
  publicTournamentsHeading: 'Tournois Publics',
  publicTournamentsSubtitle: 'Tournois que d\'autres utilisateurs ont rendus publics — tout utilisateur connecté peut voir le tableau et suivre les matchs en direct.',
  noPublicTournaments: 'Aucun tournoi public pour le moment.',
  hostedByLabel: 'Organisé par',
  watchLiveBtn: 'Voir en Direct',
  backToPublicList: 'Retour aux Tournois Publics',
  spectatingBadge: '👀 En train de regarder',
  noHistoryYet: 'Aucun tournoi passe.',
  noHistoryYetDesc: 'Les tournois termines apparaitront ici.',
  createTournament: 'Creer un Tournoi',
  nextBtn: 'Suivant',
  backBtn: 'Retour',
  editTournament: 'Modifier le Tournoi',
  tournamentNameLabel: 'Nom du Tournoi',
  dateTimeLabel: 'Date et Heure',
  dateTimeHint: 'Affiche dans la liste des tournois',
  maxPlayersLabel: 'Nombre Maximum de Joueurs',
  maxPlayersHint: 'Les cases vides sont remplies par des BYEs',
  handicapLabel: 'Tournoi avec Handicap',
  handicapOnDesc: 'Handicap ACTIVE — avantage en points',
  handicapOffDesc: 'Handicap DESACTIVE — tournoi scratch',
  pauseClocks: 'Mettre en Pause',
  resumeClocks: 'Reprendre',
  saveChanges: 'Enregistrer',
  confirmCreateTitle: 'Demarrer un Nouveau Tournoi?',
  confirmCreateMsg: 'Le tournoi actuel sera archive.',
  cancelLabel: 'Annuler',
  confirmLabel: 'Confirmer',
  registrationLabel: 'Inscriptions',
  activeLabel: 'En Cours',
  completeLabel: 'Termine',
  maxLabel: 'Max',
  handicapBadge: 'Handicap',
  playerManagement: 'Gestion des Joueurs',
  playerManagementDesc: 'Cliquez sur la photo pour la modifier',
  deletePlayerTitle: 'Supprimer le Joueur',
  deletePlayerMsg: 'Ce joueur sera supprime.',
  changePhoto: 'Photo',
  deletePlayer: 'Supprimer',
  newPhotoSelected: 'Nouvelle photo selectionnee',
  handicapEditHint: 'Handicap',
  handicapValue: 'Handicap',
  clickToEditHandicap: 'Cliquer pour modifier le handicap',
  playerCountAll: '{n} joueur{s} dans tous les tournois',
  playerCountMatch: '{n} joueur{s} correspondant à "{q}"',
  clickToChangePhoto: 'Cliquer pour changer la photo',
  photoFromPrevious: 'Photo du tournoi precedent',
  handicapStartTitle: 'Depart avec Handicap',
  handicapStartDesc: 'Avantage applique au debut',
  debugJumpBtn: 'Debug: Aller a 5:30',
  pointsAdvantageApplied: 'Avantage applique au debut',
  handicapPts: 'pts — plus élevé = joueur plus faible = plus de points',
  passwordWeak: 'Faible',
  passwordFair: 'Moyenne',
  passwordGood: 'Bonne',
  passwordStrong: 'Forte',
  passwordsNoMatch: 'Les mots de passe ne correspondent pas',
  repeatPassword: 'Répéter le mot de passe',
  creatingAccount: 'Création du compte…',
  minChars: 'Min. 8 caractères',
  usernameHint: 'Lettres, chiffres, espaces, tirets bas et tirets',
  deactivateAccount: 'Désactiver le Compte',
  newPasswordMin: 'Nouveau mot de passe (min. 8)',
  suspensionReason: 'Raison de la suspension (optionnel)',
  confirmSuspend: 'Confirmer la Suspension',
  passwordUpdated: 'Mot de passe mis à jour ✓',
  addNewUser: 'Ajouter un Utilisateur',
  addPlayer: 'Ajouter un Joueur',
  allUsers: 'Tous les Utilisateurs',
  awaitingDrawDesc: 'Inscrivez les joueurs puis démarrez le tournoi.',
  ballOffTable: 'Balle hors table',
  byesAdded: '{n} BYE(s) ajouté(s)',
  cancel: 'Annuler',
  complete: 'Terminé',
  connecting: 'Connexion…',
  createUser: '+ Ajouter',
  creating: 'Création…',
  declareWinner: 'Déclarer le vainqueur :',
  deleteUser: 'Supprimer',
  dir: 'ltr',
  elapsed: 'écoulé',
  endMatchToDeclare: 'Terminez le match pour déclarer le vainqueur',
  foul: 'Faute',
  inProgress: 'En Cours',
  inProgressStatus: 'Tournoi en cours',
  joined: 'Inscrit',
  splashTagline: 'Organisez votre tournoi de snooker comme un pro.',
  splashSubtitle: 'Score en direct, chronomètres, profils joueurs et historique complet — sous règles Shootout ou Snooker 900. Premier tournoi gratuit.',
  splashSubtitleAllFree: 'Score en direct, chronomètres, profils joueurs et historique complet. Tous les tournois sont gratuits.',
  splashSubtitlePaid: 'Score en direct, chronomètres, profils joueurs et historique complet.',
  splashSubtitleNFree: 'Score en direct, chronomètres, profils joueurs et historique complet. Les {n} premiers tournois sont gratuits.',
  splashNoCreditCard: 'Sans carte de crédit · Premier tournoi gratuit',
  splashNoCreditCardAllFree: 'Sans carte de crédit · Tous les tournois gratuits',
  splashNoCreditCardPaid: 'Sans carte de crédit',
  splashNoCreditCardNFree: 'Sans carte de crédit · {n} premiers tournois gratuits',
  splashStep1Title: 'Créez votre compte',
  splashStep1Desc: 'Inscrivez-vous par e-mail. Premier tournoi gratuit.',
  splashStep1DescAllFree: 'Inscrivez-vous par e-mail. Tous les tournois gratuits.',
  splashStep1DescPaid: 'Inscrivez-vous par e-mail.',
  splashStep1DescNFree: 'Inscrivez-vous par e-mail. Les {n} premiers tournois sont gratuits.',
  whoBreaks: 'Qui casse?',
  whoBreaksDesc: 'Sélectionnez le joueur qui cassera. La pendule démarre à la confirmation.',
  breakOffBtn: 'Casser',
  breaksOff: 'Casse',
  selectPlayerFirst: 'Sélectionnez un joueur d\'abord',
  matchClockStartsOnBreak: 'La pendule démarre à la confirmation du casseur.',
  foulCueBallInHand: 'Faute — Bille en main',
  pointsAwardedToOpponent: 'points accordés à l\'adversaire.',
  toPlayFromHand: 'joue bille en main.',
  clocksPausedMsg: 'Les deux pendules sont en pause.',
  resumeMatch: '▶ Reprendre le match',
  freeBallLabel: 'Free ball',
  freeBallSnookeredMsg: 'est snooké sur toutes les boules. Son prochain coup peut désigner n\'importe quelle boule ; elle compte comme la boule réellement à jouer.',
  freeBallActiveBanner: '🔴 FREE BALL — désignez n\'importe quelle boule pour ce coup',
  respotBlackBanner: '🎱 NOIRE REPLACÉE — manche à égalité, qui a gagné le tirage au sort ?',
  higherValueFoul: 'Faute de valeur supérieure',
  selectHighestBallTouched: 'Sélectionnez la bille de plus haute valeur touchée',
  highestBreakLabel: 'Meilleure série',
  highBreakPrizeLabel: '🔴 Prix de la meilleure série',
  highBreakPrizeHint: 'Prix optionnel au joueur avec la meilleure série. Affiché sur l\'affiche.',
  contactTitle: 'Nous contacter',
  contactSubtitle: 'Une question ? Envoyez-nous un message.',
  contactSubjectLabel: 'Sujet',
  contactMessageLabel: 'Message',
  contactSendBtn: '✉ Envoyer le message',
  contactSentTitle: 'Message envoyé',
  contactSentDesc: 'Merci de nous avoir contactés ! Nous répondrons dès que possible.',
  contactSendAnother: 'Envoyer un autre message',
  contactAimToRespond: 'Nous répondons dans 1–2 jours ouvrables.',
  changeEmailTitle: 'Changer d\'adresse e-mail',
  changeEmailNewLabel: 'Nouvelle adresse e-mail',
  changeEmailSendBtn: 'Envoyer l\'e-mail de vérification',
  sendPasswordResetLink: 'Envoyer un lien de réinitialisation à',
  backToSignIn: '← Retour à la connexion',
  viewDraw: 'Voir le tableau →',
  loadingTournament: 'Chargement du tournoi…',
  loadingMatch: 'Chargement du match…',
  tournamentNotFound: 'Tournoi introuvable',
  matchNotFound: 'Match introuvable',
  backToHistory: '← Retour à l\'historique',
  backToDraw: '← Retour au tableau',
  backToUsers: '← Retour aux utilisateurs',
  deleteTournamentTitle: 'Supprimer le tournoi',
  deleteTournamentConfirm: 'Cela supprimera définitivement le tournoi et toutes ses données.',
  tournamentsHeading: 'Tournois',
  loadingTournaments: 'Chargement des tournois…',
  noTournamentsYet: 'Cet utilisateur n\'a pas encore créé de tournois.',
  viewThisUsersTournaments: 'Voir les tournois de cet utilisateur',
  grantFreeForLife: 'Accorder des tournois gratuits à vie',
  revokeFreeForLife: 'Révoquer les tournois gratuits',
    langFlag: '🇫🇷',
  lastShotUndone: '↩ Dernier coup annulé',
  live: 'EN DIRECT',
  losesTheFrame: 'perd la manche',
  matchesDone: 'Matchs joués',
  navAdmin: 'Admin',
  navHistory: 'Tournois',
  navPlayers: 'Ajouter Joueurs',
  navUsers: 'Utilisateurs',
  noHistory: 'Aucun tournoi passé.',
  noPot: 'Pas de pot',
  nothingToUndo: 'Rien à annuler',
  password: 'Mot de passe',
  playerName: 'Nom du joueur…',
  plusToOpponent: '+{n} à l\'adversaire',
  potBall: 'Empocher une balle',
  potted: '{ball} empochée (+{n})',
  redsRemaining: 'rouges restantes',
  registered: 'inscrit',
  remaining: 'restant',
  rounds: 'Tours',
  save: 'Enregistrer',
  saving: 'Enregistrement…',
  secondHalf: '2e Mi-temps',

  selectFoulBall: 'Sélectionner la balle fautée :',
  selectFoulType: 'Type de faute',
  shotClock: 'Chrono tir',
  shotsCount: 'coups',
  shotsPlayed: 'Coups joués',
  signOut: 'Se déconnecter',
  startMatch: 'Démarrer le Match',
  startTournament: 'Démarrer le Tournoi',
  statusActive: '● En Cours',
  statusComplete: '✓ Terminé',
  superuser: 'super-utilisateur',
  tapBallAbove: 'Touchez la balle fautée ci-dessus',
  tournamentStatus: 'Statut du Tournoi',
  user: 'utilisateur',
  username: 'Nom d\'utilisateur',
  viewDetails2: 'Voir le tableau et les résultats',
  vsLabel: 'VS',
  wins: 'gagne',
  roundFinal: 'Finale',
  roundSemiFinals: 'Demi-finales',
  roundQuarterFinals: 'Quarts de finale',
  roundOf16: 'Huitièmes de finale',
  roundOf: 'Tour de',
  owner: 'Propriétaire',
  timePlayed: 'joué',
  matchesPlayed: 'joués',
  noPlayersRegistered: "Aucun joueur enregistré pour l'instant",
  startTypingPlayers: 'Commencez à taper pour voir les joueurs des tournois précédents',
  startTournamentConfirm: 'Démarrer le tournoi ? Le tableau sera généré automatiquement.',
  splashFeaturesHeading: 'Tout ce qu\'il faut pour organiser un shootout',
  splashFooterTagline: 'Shootout Comps — Gestion de tournois',
  splashUpAndRunning: 'Opérationnel en quelques minutes',
  splashStep2Title: 'Enregistrez vos joueurs',
  splashStep2Desc: "Ajoutez jusqu'à 32 joueurs avec photos",
  splashStep3Title: 'Démarrez le tournoi',
  splashStep3Desc: 'Le tableau est généré automatiquement',
  splashStep4Title: 'Gérez les matchs en direct',
  splashStep4Desc: 'Comptabilisez chaque tir, suivez le temps, voyez les résultats',
  splashReadyTitle: 'Prêt à lancer votre tournoi ?',
  splashGetStarted: '🏆 Commencer gratuitement',
  splashGetStartedPaid: '🏆 Créer un compte',
  splashPricingAllFree: 'Tous les tournois sont gratuits — aucun paiement requis.',
  splashPricingPaidOnly: 'Les tournois coûtent {price} chacun.',
  splashPricingOneFree: 'Votre premier tournoi est gratuit, puis {price} chacun.',
  splashPricingNFree: 'Vos {n} premiers tournois sont gratuits, puis {price} chacun.',
  privacyPolicy: 'Politique de confidentialité',
  resend: 'Renvoyer',
  resending: 'Envoi…',
  newLinkSent: '✓ Nouveau lien envoyé — vérifiez votre boîte',
  didntGetIt: "Pas reçu ? Renvoyer l'e-mail",
  sendResetCode: 'Envoyer le code de réinitialisation',
  verifyCode: 'Vérifier le code',
  verifying: 'Vérification…',
  resendCode: 'Renvoyer le code',
  handicapStart: '🏅 Départ avec handicap',
  noPlayersFound: 'Aucun joueur trouvé dans vos tournois.',
  noPlayersMatching: 'Aucun joueur correspondant à',
  navContact: 'Contact',
  navPublic: 'Public',
  navFaq: 'Aide et FAQ',
  navLeagues: 'Ligues',
  faqSubtitle: 'Tout ce que vous devez savoir pour organiser un tournoi Shootout, Snooker 900 ou Standard.',
  faqSearch: 'Rechercher une question…',
  faqNoResults: 'Aucune question ne correspond à votre recherche.',
  faqContact: 'Vous avez encore une question ?',
  faqContactLink: 'Contactez-nous depuis la page contact',
  paymentsEnabled: 'Paiements ACTIVÉS',
  paymentsDisabled: 'Paiements DÉSACTIVÉS',
  statusLabel: 'Statut',
  fromLabel: 'De',
  freeForLife: '♾ Gratuit',
  freeForLifeGranted: '♾ Gratuit ✓',
  createAccount: '🏆 Créer un compte',
  splashSignIn: 'Se connecter',
  splashSignUp: "S'inscrire",
  dontHaveAccount: 'Pas encore de compte ?',
  createFreeAccount: 'Créer un compte gratuit',
  signInNow: '🏆 Se connecter maintenant',
  orContinueWith: 'ou continuer avec',
  continueWithGoogle: 'Continuer avec Google',
  continueWithFacebook: 'Continuer avec Facebook',
  oauthErrorTitle: 'Échec de la connexion',
  oauthErrorGeneric: "Une erreur s'est produite lors de la connexion. Veuillez réessayer.",
  oauthErrorEmailNotVerified: "Ce compte n'a pas d'adresse e-mail vérifiée, nous ne pouvons donc pas vous connecter avec.",
  oauthErrorAccountSuspended: 'Ce compte a été suspendu.',
  oauthErrorDenied: 'Vous avez annulé la connexion.',
  oauthErrorProviderDisabled: 'La connexion avec ce fournisseur est actuellement désactivée.',
  noPasswordSetError: 'Ce compte se connecte avec Google ou Facebook — utilisez plutôt l\'un de ces boutons.',
  navPlayersAdmin: '⚙ Joueurs',
  allPlayersDesc: 'Tous les joueurs de tous vos tournois. Cliquez sur la photo pour la mettre à jour ; les handicaps sont modifiables.',
  pwStrengthWeak: 'Faible',
  pwStrengthFair: 'Passable',
  pwStrengthGood: 'Bon',
  pwStrengthStrong: 'Fort',
  pauseShotClock: 'Pause',
  resumeShotClock: 'Reprendre',
  newTournamentTitle: '🏆 Nouveau Tournoi',
  editTournamentTitle: '✎ Modifier le Tournoi',
  locationLabel: '📍 Lieu / Salle',
  locationPlaceholder: 'ex. Le Crown, Paris',
  locationHint: 'Optionnel — affiché sur la carte du tournoi.',
  entryFeeLabel: "💰 Frais d'inscription",
  entryFeeHint: "Laissez vide s'il n'y a pas de frais.",
  prizePlacesLabel: '🏆 Places primées',
  prizePlacesNone: 'Aucune',
  prizePlacesHint: 'Sélectionnez combien de places reçoivent un prix.',
  prizePoolLabel: 'Total des prix',
  matchFormatLabel: '🔴 Format de match',
  shootoutDesc: 'Shootout : 10 min · {r} rouges · 15s tirs (5 min) · 10s (5 min)',
  snooker900Desc: 'Snooker 900 : 15 min · {r} rouges · 20s tirs',
  sixRedsLabel: '🔴 Six Rouges — seulement 6 rouges au lieu de 15',
  sixRedsDesc: 'Six Rouges',
  standardFormatHint: 'Snooker standard : sans limite de temps · règles complètes · {r} rouges',
  bestOfDialogTitle: 'Manches par tour',
  bestOfDialogDesc: "Choisissez combien de manches sont nécessaires pour remporter chaque tour (nombres impairs uniquement, pour qu'il y ait toujours un vainqueur).",
  bestOfContinueBtn: 'Continuer',
  bestOfBackBtn: 'Retour',
  handicapHint: 'Quand activé, saisissez le handicap de chaque joueur. Le joueur le plus faible reçoit la différence.',
  makePublicLabel: 'Tournoi Public',
  makePublicHint: 'Tout utilisateur connecté pourra voir le tableau et suivre les matchs en direct.',
  cancelBtn: 'Annuler',
  timedTournamentTitle: 'Tournoi Chronométré',
  timedTournamentDesc: 'Shootout ou Snooker 900 · horloge de tir',
  standardTournamentTitle: 'Tournoi Standard',
  standardTournamentDesc: 'Règles standard · sans limite de temps · six rouges optionnel',
  chooseTournamentType: 'Choisissez le type de tournoi à créer.',
  completedTournamentsAppearHere: 'Les tournois terminés apparaissent ici.',
  maxEntriesLabel: 'Max {n} participants',
  prizePlaceSingle: 'place primée',
  prizePlacePlural: 'places primées',
  prizePoolPrefix: 'Cagnotte',
  entryLabel: 'Inscription',
  handicapTournament: 'Tournoi handicap',
  scratchTournament: 'Tournoi scratch',
  highBreakPrizeDisplay: 'Prix meilleure série',
  noDateVenueWarning: 'Pas de date, lieu, frais ni prix. Modifiez le tournoi pour une affiche plus complète.',
  additionalTextLabel: 'Texte supplémentaire (optionnel)',
  additionalTextPlaceholder: 'ex. Bienvenue à tous ! Contactez Jean au 07700 900000.',
  additionalTextHint: "Imprimé en bas de l'affiche.",
  downloadPdfPoster: "⬇ Télécharger l'affiche PDF",
  generatingPoster: '⏳ Génération…',
  paymentGateTitle: 'Nouveau Tournoi',
  paymentGateDesc: 'Vous avez utilisé votre tournoi gratuit. Un paiement unique de {amount} est requis.',
  editBtn: '✎ Modifier',
  posterBtn: '🖨 Affiche',
  sharedBadge: 'Partagé',
  publicBadge: 'Public',
  privateBadge: 'Privé',
  togglePublicHint: 'Cliquez pour basculer entre public et privé',
  adminsBtn: 'Admins',
  adminsDesc: 'Les administrateurs ont un accès complet pour marquer et gérer ce tournoi, sauf le supprimer ou gérer cette liste.',
  usernamePlaceholder: "Nom d'utilisateur…",
  addBtn: 'Ajouter',
  removeBtn: 'Retirer',
  noAdminsYet: 'Aucun administrateur ajouté pour le moment.',
  statusRegistrationLabel: 'Inscription',
  statusActiveLabel: 'En cours',
  statusCompleteLabel: 'Terminé',
  emailAddress: 'Email',
  bracketWinner: 'Vainqueur',
  bracketChampionTitle: 'Champion',
  bracketSavingLabel: 'Enregistrement…',
  bracketSaveResult: 'Enregistrer le résultat',
  bracketEntries: 'participants',
  bracketEntry: 'participant',
  bracketPrizePool: 'cagnotte',
  bracketHighBreak: 'meilleur break',
  bracketSixReds: 'Six Rouges',
  bracketHandicap: 'Handicap',
  bracketShootoutLabel: 'Shootout',
  bracketSnooker900Label: 'Snooker 900',
  bracketStandardLabel: 'Standard',
  bracketPlace: 'place',
  bracketPlaces: 'places',
  statsPlayersLabel: 'Joueurs',
  statsHighBreakLabel: 'Meilleur Break',
  statsDateLabel: 'Date',
  statsVenueLabel: 'Lieu',
  spectatorView: 'Mode spectateur — un autre appareil marque ce match',
  resetLinkInvalidTitle: 'Lien invalide',
  resetLinkExpiredMsg: 'Ce lien de réinitialisation a expiré.',
  resetLinkInvalidMsg: 'Ce lien est invalide ou a déjà été utilisé.',
  emailUpdatedTitle: 'Email mis à jour',
  emailChangeLinkInvalidTitle: 'Lien invalide',
  emailAlreadyTaken: 'Cette adresse email est déjà utilisée par un autre compte.',
  emailChangeLinkInvalidMsg: 'Ce lien de changement d\'email est invalide ou a déjà été utilisé.',
  accountSuspendedTitle: 'Compte suspendu',
  accountSuspendedMsg: 'Votre compte a été suspendu.',
  editMatchResult: 'Modifier le résultat du match',
  adminOnlineNow: 'En ligne maintenant (5 min)',
  adminTotalAccounts: 'Total des comptes',
  adminAwaitingVerification: 'En attente de vérification',
  adminNewThisWeek: 'Nouveaux cette semaine',
  adminNewThisMonth: 'Nouveaux ce mois',
  adminMatchesInProgress: 'Matchs en cours',
  adminInProgress: 'En cours',
  adminUniquePlayerEntries: 'Entrées uniques de joueurs',
  adminTotalEver: 'Total historique',
  adminLoadingStats: 'Chargement des statistiques…',
  settingsSavePrices: 'Sauvegarder les prix',
  settingsCurrentState: 'État actuel :',
  settingsTimedLabel: 'Chronométré',
  settingsStandardLabel: 'Standard',
  settingsPerUserOverrides: 'Exceptions par utilisateur',
  usersAccountStates: 'États du compte :',
  usersActiveState: 'Actif',
  usersPendingState: 'En attente',
  usersSuspendedState: 'Suspendu',
  usersDeactivatedState: 'Désactivé',
  loadingLabel: 'Chargement…',
  leaguesEmptyDesc: 'Organisez une compétition par équipes sur toute une saison — divisions, rencontres et classement. Créez votre première ligue pour commencer.',
  createLeagueBtn: '+ Créer une ligue',
  leagueNamePlaceholder: 'Nom de la ligue',
  divisionTabTeams: '👥 Équipes',
  divisionTabFixtures: '📅 Rencontres',
  divisionTabStandings: '🏆 Classement',
  standingsTeamCol: 'Équipe',
  noTeamsInDivision: "Aucune équipe dans cette division pour l'instant.",
  fixtureStatusScheduled: 'Programmée',
  fixtureStatusLineupSet: 'Composition définie',
  fixtureStatusInProgress: 'En cours',
  backToFixture: '← Retour à la rencontre',
  publicLeaguesTitle: '🌐 Ligues Publiques',
  publicLeaguesDesc: 'Parcourez et suivez les ligues que d\'autres organisateurs ont rendues publiques.',
  noPublicLeaguesYet: 'Aucune ligue publique pour l\'instant.',
  backToPublicLeagues: '← Ligues Publiques',
  noFixturesYetLabel: 'Aucune rencontre pour l\'instant.',
  noTeamsYetLabel: 'Aucune équipe pour l\'instant.',
  backToAllSeasons: '← Toutes les saisons',
  noPastSeasonsYet: 'Aucune saison passée pour l\'instant.',
  noPastSeasonsYetOwner: 'Aucune saison passée pour l\'instant — elles apparaîtront ici après la première "Fin de Saison" de cette division.',
  endedLabel: 'Terminée',
  promotedLabel: 'promus',
  relegatedLabel: 'relégués',
  finalStandingsLabel: 'Classement final',
  fixturesLabel: 'Rencontres',
  historyTabLabel: '📜 Historique',
  doubleRoundRobinLabel: 'Aller-retour (double round-robin)',
  pendingClaimApprovalLabel: '⏳ approbation en attente',
  approveBtn: 'Approuver',
  rejectBtn: 'Refuser',
  tierFieldLabel: 'Niveau (1 = division supérieure)',
  promotionSpotsFieldLabel: 'Places de promotion (par défaut)',
  relegationSpotsFieldLabel: 'Places de relégation (par défaut)',
  seasonManagementHint: 'Gestion de saison : le niveau de cette division (1 = supérieur) et le nombre par défaut de promotions/relégations pré-rempli pour le prochain aperçu de fin de saison. Peut être modifié chaque saison.',
  togglePublicTooltip: 'Basculer si tout utilisateur connecté peut parcourir et suivre cette ligue',
  toggleClaimApprovalTooltip: 'Basculer si les auto-revendications d\'effectif nécessitent l\'approbation du propriétaire/admin',
  publicChipLabel: '🌐 Publique',
  privateChipLabel: '🔒 Privée',
  claimsApprovalChipLabel: '🛂 Revendications : Approbation',
  claimsInstantChipLabel: '⚡ Revendications : Instantanées',
  endSeasonBtn: '🏁 Fin de Saison',
  browsePublicLeaguesLink: '🌐 Parcourir les Ligues Publiques',
  myStatsTitle: 'Mes Statistiques',
  statsPlayedLabel: 'Joués',
  statsWonLabel: 'Gagnés',
  statsLostLabel: 'Perdus',
  seasonLabelFieldLabel: 'Nom de la saison',
  seasonLabelPlaceholder: 'ex. 2025/26',
  seasonCountsHint: 'Nombre de promotions/relégations pour cette saison — pré-rempli avec les valeurs par défaut de chaque division, modifiable juste pour cette fois.',
  tierLabel: 'niveau',
  previewBtn: 'Aperçu →',
  reviewMovesHint: 'Vérifiez les mouvements proposés ci-dessous — décochez toute équipe que vous souhaitez laisser dans sa division actuelle. Les rencontres de toutes les divisions seront de toute façon archivées et réinitialisées.',
  noMovesThisSeason: 'Aucun mouvement de promotion/relégation cette saison.',
  confirmEndSeasonBtn: 'Confirmer et Terminer la Saison',
};

const de: Translations = {
  langName: 'Deutsch',
  appName: 'Shootout Comps',
  signIn: 'Anmelden',
  signingIn: 'Anmelden…',
  navBracket: 'Turnier',
  statusRegistration: 'Anmeldung offen',
  players: 'Spieler',
  removePlayer: 'Entfernen',
  slotsRemaining: 'Plätze verfügbar',
  noPlayersYet: 'Noch keine Spieler angemeldet',
  awaitingDraw: 'Warte auf Auslosung',
  champion: 'Champion',
  clickToPlay: '→ Klicken zum Spielen',
  matchComplete: 'Spiel abgeschlossen',
  notStarted: 'Nicht gestartet',
  startMatchDesc: 'Bereit? Startet die 10-Minuten-Spieluhr.',
  shotClockDesc: 'Stoßuhr: 15s erste 5 Min · 10s letzte 5 Min',
  atTheTable: 'Am Tisch',
  nextLegalPot: 'Nächste legale Einlochung:',
  miss: 'Verfehlt',
  cancelFoul: 'Abbrechen',
  noContact: 'Kein Kontakt',
  undo: 'Rückgängig',
  cueBallPotted: 'Weiße Ball eingelocht',
  endMatchEarly: 'Spiel vorzeitig beenden',
  finishMatchBtn: 'Spiel beenden',
  finishFrameBtn: 'Frame beenden',
  enterFinalScore: 'Endstand eingeben:',
  scoresInvalid: 'Bitte zwei unterschiedliche Ergebnisse eingeben',
  shotHistory: 'Stoßverlauf',
  firstHalf: '1. Hälfte — 15s/Stoß',
  backToBracket: '← Zurück zum Turnier',
  shotClockExpired: 'STOSSZEIT ABGELAUFEN',
  matchClockExpired: 'SPIELZEIT ABGELAUFEN',
  dismiss: 'Schließen',
  foulToOpponent: 'Foul — +{n} für Gegner',
  noPotnPlayerChanged: '↩ Nicht eingelocht — Spielerwechsel',
  cannotUndo: 'Rückgängig nicht möglich',
  adminDashboard: 'Admin-Dashboard',
  registrationOpen: 'Anmeldung offen',
  tournamentName: 'Turniername',
  newTournament: '🆕 Neues Turnier',
  newTournamentDesc: 'Ein neues Turnier archiviert das aktuelle.',
  startNewTournament: 'Neues Turnier',
  tournamentHistory: 'Turnierverlauf',
  noHistoryDesc: 'Abgeschlossene Turniere erscheinen hier.',
  viewDetails: '→ Details anzeigen',
  participants: 'Teilnehmer',
  userManagement: 'Benutzerverwaltung',
  you: 'Du',
  resetPasswordBtn: '🔑 PW zurücksetzen',
  passwordMinLength: 'Passwort muss mindestens 8 Zeichen haben',
  userIsolationNote: 'Jeder Benutzer kann nur seine eigenen Turniere sehen.',
  voiceHalfTime: '10-Sekunden-Stoßuhr jetzt in Betrieb',
  language: 'Sprache',
  profile: 'My Profile',
  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  passwordChanged: 'Password changed successfully.',
  forgotPassword: 'Forgot password?',
  sendResetLink: 'Send Reset Link',
  resetLinkSent: 'Reset link sent — check your email.',
  resetPassword: 'Reset Password',
  resetPasswordDesc: "Enter your email and we'll send a reset link.",
  setNewPassword: 'Set New Password',
  accountDetails: 'Account Details',
  memberSince: 'Member since',
  tournamentsTitle: 'Turniere',
  newTournament2: '+ Neues Turnier',
  currentTournament: 'Aktuelles Turnier',
  pastTournaments: 'Vergangene Turniere',
  publicTournamentsHeading: 'Öffentliche Turniere',
  publicTournamentsSubtitle: 'Turniere, die andere Benutzer öffentlich gemacht haben — jeder angemeldete Benutzer kann den Turnierbaum ansehen und Spiele live verfolgen.',
  noPublicTournaments: 'Derzeit keine öffentlichen Turniere.',
  hostedByLabel: 'Veranstaltet von',
  watchLiveBtn: 'Live Ansehen',
  backToPublicList: 'Zurück zu Öffentlichen Turnieren',
  spectatingBadge: '👀 Zuschauen',
  noHistoryYet: 'Noch keine vergangenen Turniere.',
  noHistoryYetDesc: 'Abgeschlossene Turniere erscheinen hier.',
  createTournament: 'Turnier Erstellen',
  nextBtn: 'Weiter',
  backBtn: 'Zurück',
  editTournament: 'Turnier Bearbeiten',
  tournamentNameLabel: 'Turniername',
  dateTimeLabel: 'Datum & Uhrzeit',
  dateTimeHint: 'Wird in der Turnierliste angezeigt',
  maxPlayersLabel: 'Maximale Spieleranzahl',
  maxPlayersHint: 'Leere Platze werden mit BYEs gefullt',
  handicapLabel: 'Handicap-Turnier',
  handicapOnDesc: 'Handicap EIN — Punktevorsprung',
  handicapOffDesc: 'Handicap AUS — Scratch-Turnier',
  pauseClocks: 'Uhren Pausieren',
  resumeClocks: 'Uhren Fortsetzen',
  saveChanges: 'Anderungen Speichern',
  confirmCreateTitle: 'Neues Turnier Starten?',
  confirmCreateMsg: 'Das aktuelle Turnier wird archiviert.',
  cancelLabel: 'Abbrechen',
  confirmLabel: 'Bestatigen',
  registrationLabel: 'Anmeldung',
  activeLabel: 'Laufend',
  completeLabel: 'Abgeschlossen',
  maxLabel: 'Max',
  handicapBadge: 'Handicap',
  playerManagement: 'Spielerverwaltung',
  playerManagementDesc: 'Klicken Sie auf das Foto zum Andern',
  deletePlayerTitle: 'Spieler Loschen',
  deletePlayerMsg: 'Dieser Spieler wird entfernt.',
  changePhoto: 'Foto',
  deletePlayer: 'Loschen',
  newPhotoSelected: 'Neues Foto ausgewahlt',
  handicapEditHint: 'Handicap',
  handicapValue: 'Handicap',
  clickToEditHandicap: 'Klicken zum Handicap bearbeiten',
  playerCountAll: '{n} Spieler in allen Turnieren',
  playerCountMatch: '{n} Spieler passend zu "{q}"',
  clickToChangePhoto: 'Klicken zum Foto-Andern',
  photoFromPrevious: 'Foto aus fruherem Turnier',
  handicapStartTitle: 'Handicap-Start',
  handicapStartDesc: 'Vorsprung zu Spielbeginn',
  debugJumpBtn: 'Debug: Sprung zu 5:30',
  pointsAdvantageApplied: 'Vorsprung zu Beginn',
  handicapPts: 'Pkt — höher = schwächerer Spieler = mehr Punkte Vorsprung',
  passwordWeak: 'Schwach',
  passwordFair: 'Mittel',
  passwordGood: 'Gut',
  passwordStrong: 'Stark',
  passwordsNoMatch: 'Passwörter stimmen nicht überein',
  repeatPassword: 'Passwort wiederholen',
  creatingAccount: 'Konto wird erstellt…',
  minChars: 'Mind. 8 Zeichen',
  usernameHint: 'Buchstaben, Zahlen, Leerzeichen, Unterstriche und Bindestriche',
  deactivateAccount: 'Konto Deaktivieren',
  newPasswordMin: 'Neues Passwort (mind. 8)',
  suspensionReason: 'Sperrgrund (optional)',
  confirmSuspend: 'Sperrung Bestätigen',
  passwordUpdated: 'Passwort aktualisiert ✓',
  addNewUser: 'Benutzer Hinzufügen',
  addPlayer: 'Spieler Hinzufügen',
  allUsers: 'Alle Benutzer',
  awaitingDrawDesc: 'Spieler anmelden und Turnier starten.',
  ballOffTable: 'Ball vom Tisch',
  byesAdded: '{n} BYE(s) hinzugefügt',
  cancel: 'Abbrechen',
  complete: 'Abgeschlossen',
  connecting: 'Verbinden…',
  createUser: '+ Hinzufügen',
  creating: 'Erstellen…',
  declareWinner: 'Gewinner erklären:',
  deleteUser: 'Löschen',
  dir: 'ltr',
  elapsed: 'vergangen',
  endMatchToDeclare: 'Match beenden um Gewinner zu bestimmen',
  foul: 'Foul',
  inProgress: 'Laufend',
  inProgressStatus: 'Turnier läuft',
  joined: 'Beigetreten',
  splashTagline: 'Führe dein Snooker-Turnier wie ein Profi durch.',
  splashSubtitle: 'Live-Wertung, Schuss-Uhren, Spielerprofile und vollständige Matchhistorie — nach Shootout- oder Snooker-900-Regeln. Erstes Turnier kostenlos.',
  splashSubtitleAllFree: 'Live-Wertung, Schuss-Uhren, Spielerprofile und vollständige Matchhistorie. Alle Turniere kostenlos.',
  splashSubtitlePaid: 'Live-Wertung, Schuss-Uhren, Spielerprofile und vollständige Matchhistorie.',
  splashSubtitleNFree: 'Live-Wertung, Schuss-Uhren, Spielerprofile und vollständige Matchhistorie. Erste {n} Turniere kostenlos.',
  splashNoCreditCard: 'Keine Kreditkarte · Erstes Turnier kostenlos',
  splashNoCreditCardAllFree: 'Keine Kreditkarte · Alle Turniere kostenlos',
  splashNoCreditCardPaid: 'Keine Kreditkarte erforderlich',
  splashNoCreditCardNFree: 'Keine Kreditkarte · Erste {n} Turniere kostenlos',
  splashStep1Title: 'Konto erstellen',
  splashStep1Desc: 'Mit E-Mail anmelden. Erstes Turnier kostenlos.',
  splashStep1DescAllFree: 'Mit E-Mail anmelden. Alle Turniere kostenlos.',
  splashStep1DescPaid: 'Mit E-Mail anmelden.',
  splashStep1DescNFree: 'Mit E-Mail anmelden. Erste {n} Turniere kostenlos.',
  whoBreaks: 'Wer stößt an?',
  whoBreaksDesc: 'Wähle den Spieler, der anstoßen wird. Die Spieluhr startet bei Bestätigung.',
  breakOffBtn: 'Anstoß',
  breaksOff: 'Stößt an',
  selectPlayerFirst: 'Wähle zuerst einen Spieler',
  matchClockStartsOnBreak: 'Die Spieluhr startet bei Bestätigung des Anstoßes.',
  foulCueBallInHand: 'Foul — Queue-Ball in der Hand',
  pointsAwardedToOpponent: 'Punkte dem Gegner gutgeschrieben.',
  toPlayFromHand: 'spielt mit Ball in der Hand.',
  clocksPausedMsg: 'Beide Uhren sind pausiert.',
  resumeMatch: '▶ Spiel fortsetzen',
  freeBallLabel: 'Free Ball',
  freeBallSnookeredMsg: 'ist auf allen Bällen gesnookert. Der nächste Stoß darf einen beliebigen Ball benennen; er zählt als der eigentlich fällige Ball.',
  freeBallActiveBanner: '🔴 FREE BALL — beliebigen Ball für diesen Stoß wählen',
  respotBlackBanner: '🎱 SCHWARZE NEU AUFGESETZT — Frame unentschieden, wer hat die Auslosung gewonnen?',
  higherValueFoul: 'Foul mit höherem Wert',
  selectHighestBallTouched: 'Wähle den berührten Ball mit dem höchsten Wert',
  highestBreakLabel: 'Höchstes Break',
  highBreakPrizeLabel: '🔴 Highest-Break-Preis',
  highBreakPrizeHint: 'Optionaler Preis für das höchste Break. Erscheint auf dem Plakat.',
  contactTitle: 'Kontakt',
  contactSubtitle: 'Eine Frage? Schreib uns eine Nachricht.',
  contactSubjectLabel: 'Betreff',
  contactMessageLabel: 'Nachricht',
  contactSendBtn: '✉ Nachricht senden',
  contactSentTitle: 'Nachricht gesendet',
  contactSentDesc: 'Danke! Wir melden uns so schnell wie möglich.',
  contactSendAnother: 'Weitere Nachricht senden',
  contactAimToRespond: 'Wir antworten innerhalb von 1–2 Werktagen.',
  changeEmailTitle: 'E-Mail-Adresse ändern',
  changeEmailNewLabel: 'Neue E-Mail-Adresse',
  changeEmailSendBtn: 'Bestätigungs-E-Mail senden',
  sendPasswordResetLink: 'Passwort-Reset-Link senden an',
  backToSignIn: '← Zurück zur Anmeldung',
  viewDraw: 'Auslosung ansehen →',
  loadingTournament: 'Turnier wird geladen…',
  loadingMatch: 'Match wird geladen…',
  tournamentNotFound: 'Turnier nicht gefunden',
  matchNotFound: 'Match nicht gefunden',
  backToHistory: '← Zurück zur Geschichte',
  backToDraw: '← Zurück zur Auslosung',
  backToUsers: '← Zurück zu Benutzern',
  deleteTournamentTitle: 'Turnier löschen',
  deleteTournamentConfirm: 'Das Turnier und alle Matchdaten werden dauerhaft gelöscht.',
  tournamentsHeading: 'Turniere',
  loadingTournaments: 'Turniere werden geladen…',
  noTournamentsYet: 'Dieser Benutzer hat noch keine Turniere erstellt.',
  viewThisUsersTournaments: 'Turniere dieses Benutzers ansehen',
  grantFreeForLife: 'Lebenslang kostenlose Turniere gewähren',
  revokeFreeForLife: 'Kostenlose Turniere widerrufen',
    langFlag: '🇩🇪',
  lastShotUndone: '↩ Letzter Schuss rückgängig',
  live: 'LIVE',
  losesTheFrame: 'verliert das Frame',
  matchesDone: 'Spiele gespielt',
  navAdmin: 'Admin',
  navHistory: 'Turniere',
  navPlayers: 'Spieler hinzufügen',
  navUsers: 'Benutzer',
  noHistory: 'Keine vergangenen Turniere.',
  noPot: 'Kein Einlochen',
  nothingToUndo: 'Nichts rückgängig zu machen',
  password: 'Passwort',
  playerName: 'Spielername…',
  plusToOpponent: '+{n} zum Gegner',
  potBall: 'Ball einlochen',
  potted: '{ball} eingelocht (+{n})',
  redsRemaining: 'Rote verbleibend',
  registered: 'angemeldet',
  remaining: 'verbleibend',
  rounds: 'Runden',
  save: 'Speichern',
  saving: 'Speichern…',
  secondHalf: '2. Halbzeit',

  selectFoulBall: 'Foulball auswählen:',
  selectFoulType: 'Foulart',
  shotClock: 'Schuss-Uhr',
  shotsCount: 'Schüsse',
  shotsPlayed: 'Gespielte Schüsse',
  signOut: 'Abmelden',
  startMatch: 'Match Starten',
  startTournament: 'Turnier Starten',
  statusActive: '● Laufend',
  statusComplete: '✓ Abgeschlossen',
  superuser: 'Superbenutzer',
  tapBallAbove: 'Foulball oben antippen',
  tournamentStatus: 'Turnierstatus',
  user: 'Benutzer',
  username: 'Benutzername',
  viewDetails2: 'Tableau und Ergebnisse ansehen',
  vsLabel: 'VS',
  wins: 'gewinnt',
  roundFinal: 'Finale',
  roundSemiFinals: 'Halbfinale',
  roundQuarterFinals: 'Viertelfinale',
  roundOf16: 'Achtelfinale',
  roundOf: 'Runde der',
  owner: 'Eigentümer',
  timePlayed: 'gespielt',
  matchesPlayed: 'gespielt',
  noPlayersRegistered: 'Noch keine Spieler registriert',
  startTypingPlayers: 'Tippen um Spieler aus früheren Turnieren zu sehen',
  startTournamentConfirm: 'Turnier starten? Das Tableau wird automatisch erstellt.',
  splashFeaturesHeading: 'Alles, was du für ein Shootout-Turnier brauchst',
  splashFooterTagline: 'Shootout Comps — Turnierverwaltung',
  splashUpAndRunning: 'In Minuten einsatzbereit',
  splashStep2Title: 'Spieler registrieren',
  splashStep2Desc: 'Bis zu 32 Spieler mit Fotos hinzufügen',
  splashStep3Title: 'Turnier starten',
  splashStep3Desc: 'Das Tableau wird automatisch erstellt',
  splashStep4Title: 'Spiele live verwalten',
  splashStep4Desc: 'Jeden Stoß werten, Uhr verfolgen, Ergebnisse anzeigen',
  splashReadyTitle: 'Bereit für Ihr Turnier?',
  splashGetStarted: '🏆 Kostenlos starten',
  splashGetStartedPaid: '🏆 Konto erstellen',
  splashPricingAllFree: 'Alle Turniere sind kostenlos — keine Zahlung erforderlich.',
  splashPricingPaidOnly: 'Turniere kosten {price} pro Stück.',
  splashPricingOneFree: 'Ihr erstes Turnier ist kostenlos, danach {price} pro Stück.',
  splashPricingNFree: 'Ihre ersten {n} Turniere sind kostenlos, danach {price} pro Stück.',
  privacyPolicy: 'Datenschutzrichtlinie',
  resend: 'Erneut senden',
  resending: 'Senden…',
  newLinkSent: '✓ Neuer Link gesendet — prüfen Sie Ihr Postfach',
  didntGetIt: 'Nicht erhalten? E-Mail erneut senden',
  sendResetCode: 'Reset-Code senden',
  verifyCode: 'Code verifizieren',
  verifying: 'Verifizierung…',
  resendCode: 'Code erneut senden',
  handicapStart: '🏅 Handicap-Start',
  noPlayersFound: 'Keine Spieler in Ihren Turnieren gefunden.',
  noPlayersMatching: 'Keine Spieler passend zu',
  navContact: 'Kontakt',
  navPublic: 'Öffentlich',
  navFaq: 'Hilfe & FAQ',
  navLeagues: 'Ligen',
  faqSubtitle: 'Alles, was Sie über die Durchführung eines Shootout-, Snooker-900- oder Standard-Turniers wissen müssen.',
  faqSearch: 'Fragen durchsuchen…',
  faqNoResults: 'Keine Fragen entsprechen Ihrer Suche.',
  faqContact: 'Noch eine Frage?',
  faqContactLink: 'Kontaktieren Sie uns über die Kontaktseite',
  paymentsEnabled: 'Zahlungen AKTIVIERT',
  paymentsDisabled: 'Zahlungen DEAKTIVIERT',
  statusLabel: 'Status',
  fromLabel: 'Von',
  freeForLife: '♾ Kostenlos',
  freeForLifeGranted: '♾ Kostenlos ✓',
  createAccount: '🏆 Konto erstellen',
  splashSignIn: 'Anmelden',
  splashSignUp: 'Registrieren',
  dontHaveAccount: 'Noch kein Konto?',
  createFreeAccount: 'Kostenloses Konto erstellen',
  signInNow: '🏆 Jetzt anmelden',
  orContinueWith: 'oder weiter mit',
  continueWithGoogle: 'Weiter mit Google',
  continueWithFacebook: 'Weiter mit Facebook',
  oauthErrorTitle: 'Anmeldung fehlgeschlagen',
  oauthErrorGeneric: 'Bei der Anmeldung ist etwas schiefgelaufen. Bitte versuche es erneut.',
  oauthErrorEmailNotVerified: 'Dieses Konto hat keine verifizierte E-Mail-Adresse, daher können wir dich damit nicht anmelden.',
  oauthErrorAccountSuspended: 'Dieses Konto wurde gesperrt.',
  oauthErrorDenied: 'Du hast die Anmeldung abgebrochen.',
  oauthErrorProviderDisabled: 'Die Anmeldung mit diesem Anbieter ist derzeit deaktiviert.',
  noPasswordSetError: 'Dieses Konto meldet sich mit Google oder Facebook an — verwende stattdessen einen dieser Buttons.',
  navPlayersAdmin: '⚙ Spieler',
  allPlayersDesc: 'Alle Spieler aus allen Ihren Turnieren. Klicken Sie auf das Foto, um es zu aktualisieren; Handicaps sind bearbeitbar.',
  pwStrengthWeak: 'Schwach',
  pwStrengthFair: 'Ausreichend',
  pwStrengthGood: 'Gut',
  pwStrengthStrong: 'Stark',
  pauseShotClock: 'Pause',
  resumeShotClock: 'Fortsetzen',
  newTournamentTitle: '🏆 Neues Turnier',
  editTournamentTitle: '✎ Turnier bearbeiten',
  locationLabel: '📍 Ort / Veranstaltungsort',
  locationPlaceholder: 'z.B. The Crown, Berlin',
  locationHint: 'Optional — wird auf der Turnierkarte angezeigt.',
  entryFeeLabel: '💰 Teilnahmegebühr',
  entryFeeHint: 'Leer lassen, wenn keine Gebühr anfällt.',
  prizePlacesLabel: '🏆 Preisplätze',
  prizePlacesNone: 'Keine',
  prizePlacesHint: 'Wählen Sie, wie viele Plätze einen Preis erhalten.',
  prizePoolLabel: 'Gesamtpreisgeld',
  matchFormatLabel: '🔴 Spielformat',
  shootoutDesc: 'Shootout: 10 Min · {r} Rote · 15s Stöße (5 Min) · 10s (5 Min)',
  snooker900Desc: 'Snooker 900: 15 Min · {r} Rote · 20s Stöße',
  sixRedsLabel: '🔴 Sechs Rote — nur 6 statt 15 rote Kugeln',
  sixRedsDesc: 'Sechs Rote',
  standardFormatHint: 'Standard-Snooker: kein Zeitlimit · vollständige Regeln · {r} Rote',
  bestOfDialogTitle: 'Frames pro Runde',
  bestOfDialogDesc: 'Wähle, wie viele Frames zum Rundensieg nötig sind (nur ungerade Zahlen, damit es immer einen Sieger gibt).',
  bestOfContinueBtn: 'Weiter',
  bestOfBackBtn: 'Zurück',
  handicapHint: 'Wenn aktiviert, geben Sie das Handicap jedes Spielers bei der Anmeldung ein.',
  makePublicLabel: 'Öffentliches Turnier',
  makePublicHint: 'Jeder angemeldete Benutzer kann den Turnierbaum ansehen und Spiele live verfolgen.',
  cancelBtn: 'Abbrechen',
  timedTournamentTitle: 'Zeitgesteuert',
  timedTournamentDesc: 'Shootout oder Snooker 900 · Schussuhr',
  standardTournamentTitle: 'Standard-Turnier',
  standardTournamentDesc: 'Standardregeln · kein Zeitlimit · optional sechs Rote',
  chooseTournamentType: 'Wählen Sie den Turniertyp.',
  completedTournamentsAppearHere: 'Abgeschlossene Turniere erscheinen hier.',
  maxEntriesLabel: 'Max. {n} Teilnehmer',
  prizePlaceSingle: 'Preisplatz',
  prizePlacePlural: 'Preisplätze',
  prizePoolPrefix: 'Preisgeld',
  entryLabel: 'Eintritt',
  handicapTournament: 'Handicap-Turnier',
  scratchTournament: 'Scratch-Turnier',
  highBreakPrizeDisplay: 'Höchstserie-Preis',
  noDateVenueWarning: 'Kein Datum, Ort, Gebühr oder Preise gesetzt. Bearbeiten Sie das Turnier für ein reichhaltigeres Poster.',
  additionalTextLabel: 'Zusatztext (optional)',
  additionalTextPlaceholder: 'z.B. Alle willkommen! Kontakt: Johann, Tel. 07700 900000.',
  additionalTextHint: 'Wird unten auf dem Poster gedruckt.',
  downloadPdfPoster: '⬇ PDF-Poster herunterladen',
  generatingPoster: '⏳ Wird erstellt…',
  paymentGateTitle: 'Neues Turnier',
  paymentGateDesc: 'Sie haben Ihr kostenloses Turnier verwendet. Eine einmalige Zahlung von {amount} ist erforderlich.',
  editBtn: '✎ Bearbeiten',
  posterBtn: '🖨 Poster',
  sharedBadge: 'Geteilt',
  publicBadge: 'Öffentlich',
  privateBadge: 'Privat',
  togglePublicHint: 'Klicken, um zwischen öffentlich und privat zu wechseln',
  adminsBtn: 'Admins',
  adminsDesc: 'Admins haben vollen Zugriff zum Werten und Verwalten dieses Turniers, außer es zu löschen oder diese Liste zu verwalten.',
  usernamePlaceholder: 'Benutzername…',
  addBtn: 'Hinzufügen',
  removeBtn: 'Entfernen',
  noAdminsYet: 'Noch keine Admins hinzugefügt.',
  statusRegistrationLabel: 'Anmeldung',
  statusActiveLabel: 'Laufend',
  statusCompleteLabel: 'Abgeschlossen',
  emailAddress: 'Email',
  bracketWinner: 'Gewinner',
  bracketChampionTitle: 'Champion',
  bracketSavingLabel: 'Speichern…',
  bracketSaveResult: 'Ergebnis speichern',
  bracketEntries: 'Teilnehmer',
  bracketEntry: 'Teilnehmer',
  bracketPrizePool: 'Preisgeld',
  bracketHighBreak: 'Höchste Serie',
  bracketSixReds: 'Sechs Rote',
  bracketHandicap: 'Handicap',
  bracketShootoutLabel: 'Shootout',
  bracketSnooker900Label: 'Snooker 900',
  bracketStandardLabel: 'Standard',
  bracketPlace: 'Platz',
  bracketPlaces: 'Plätze',
  statsPlayersLabel: 'Spieler',
  statsHighBreakLabel: 'Höchste Serie',
  statsDateLabel: 'Datum',
  statsVenueLabel: 'Ort',
  spectatorView: 'Zuschauermodus — ein anderes Gerät wertet dieses Spiel aus',
  resetLinkInvalidTitle: 'Link ungültig',
  resetLinkExpiredMsg: 'Dieser Reset-Link ist abgelaufen.',
  resetLinkInvalidMsg: 'Dieser Link ist ungültig oder wurde bereits verwendet.',
  emailUpdatedTitle: 'E-Mail aktualisiert',
  emailChangeLinkInvalidTitle: 'Link ungültig',
  emailAlreadyTaken: 'Diese E-Mail-Adresse wird bereits von einem anderen Konto verwendet.',
  emailChangeLinkInvalidMsg: 'Dieser E-Mail-Änderungslink ist ungültig oder wurde bereits verwendet.',
  accountSuspendedTitle: 'Konto gesperrt',
  accountSuspendedMsg: 'Ihr Konto wurde gesperrt.',
  editMatchResult: 'Spielergebnis bearbeiten',
  adminOnlineNow: 'Jetzt online (5 Min.)',
  adminTotalAccounts: 'Konten gesamt',
  adminAwaitingVerification: 'Warten auf Verifizierung',
  adminNewThisWeek: 'Neu diese Woche',
  adminNewThisMonth: 'Neu diesen Monat',
  adminMatchesInProgress: 'Laufende Spiele',
  adminInProgress: 'Laufend',
  adminUniquePlayerEntries: 'Einzigartige Spielereinträge',
  adminTotalEver: 'Gesamt historisch',
  adminLoadingStats: 'Statistiken werden geladen…',
  settingsSavePrices: 'Preise speichern',
  settingsCurrentState: 'Aktueller Status:',
  settingsTimedLabel: 'Zeitgesteuert',
  settingsStandardLabel: 'Standard',
  settingsPerUserOverrides: 'Benutzerausnahmen',
  usersAccountStates: 'Kontostatus:',
  usersActiveState: 'Aktiv',
  usersPendingState: 'Ausstehend',
  usersSuspendedState: 'Gesperrt',
  usersDeactivatedState: 'Deaktiviert',
  loadingLabel: 'Laden…',
  leaguesEmptyDesc: 'Organisiere einen saisonlangen Mannschaftswettbewerb — Divisionen, Spielpaarungen und Tabelle. Erstelle deine erste Liga, um loszulegen.',
  createLeagueBtn: '+ Liga erstellen',
  leagueNamePlaceholder: 'Liganame',
  divisionTabTeams: '👥 Mannschaften',
  divisionTabFixtures: '📅 Spielpaarungen',
  divisionTabStandings: '🏆 Tabelle',
  standingsTeamCol: 'Mannschaft',
  noTeamsInDivision: 'Noch keine Mannschaften in dieser Division.',
  fixtureStatusScheduled: 'Angesetzt',
  fixtureStatusLineupSet: 'Aufstellung festgelegt',
  fixtureStatusInProgress: 'Läuft',
  backToFixture: '← Zurück zur Begegnung',
  publicLeaguesTitle: '🌐 Öffentliche Ligen',
  publicLeaguesDesc: 'Durchsuche und verfolge Ligen, die andere Organisatoren öffentlich gemacht haben.',
  noPublicLeaguesYet: 'Noch keine öffentlichen Ligen.',
  backToPublicLeagues: '← Öffentliche Ligen',
  noFixturesYetLabel: 'Noch keine Begegnungen.',
  noTeamsYetLabel: 'Noch keine Mannschaften.',
  backToAllSeasons: '← Alle Saisons',
  noPastSeasonsYet: 'Noch keine vergangenen Saisons.',
  noPastSeasonsYetOwner: 'Noch keine vergangenen Saisons — sie erscheinen hier nach dem ersten "Saison beenden" dieser Division.',
  endedLabel: 'Beendet',
  promotedLabel: 'aufgestiegen',
  relegatedLabel: 'abgestiegen',
  finalStandingsLabel: 'Abschlusstabelle',
  fixturesLabel: 'Begegnungen',
  historyTabLabel: '📜 Verlauf',
  doubleRoundRobinLabel: 'Hin- und Rückrunde (doppelte Round-Robin)',
  pendingClaimApprovalLabel: '⏳ Genehmigung ausstehend',
  approveBtn: 'Genehmigen',
  rejectBtn: 'Ablehnen',
  tierFieldLabel: 'Stufe (1 = oberste Division)',
  promotionSpotsFieldLabel: 'Aufstiegsplätze (Standard)',
  relegationSpotsFieldLabel: 'Abstiegsplätze (Standard)',
  seasonManagementHint: 'Saisonverwaltung: die Rangstufe dieser Division (1 = oberste) sowie die Standard-Anzahl der Auf-/Abstiegsplätze für die nächste Saisonende-Vorschau. Kann pro Saison überschrieben werden.',
  togglePublicTooltip: 'Umschalten, ob jeder angemeldete Nutzer diese Liga durchsuchen und verfolgen kann',
  toggleClaimApprovalTooltip: 'Umschalten, ob Kader-Selbstansprüche eine Genehmigung des Besitzers/Admins benötigen',
  publicChipLabel: '🌐 Öffentlich',
  privateChipLabel: '🔒 Privat',
  claimsApprovalChipLabel: '🛂 Ansprüche: Genehmigung',
  claimsInstantChipLabel: '⚡ Ansprüche: Sofort',
  endSeasonBtn: '🏁 Saison beenden',
  browsePublicLeaguesLink: '🌐 Öffentliche Ligen durchsuchen',
  myStatsTitle: 'Meine Statistiken',
  statsPlayedLabel: 'Gespielt',
  statsWonLabel: 'Gewonnen',
  statsLostLabel: 'Verloren',
  seasonLabelFieldLabel: 'Saisonbezeichnung',
  seasonLabelPlaceholder: 'z. B. 2025/26',
  seasonCountsHint: 'Auf-/Abstiegsplätze für diese Saison — vorausgefüllt mit den Standardwerten jeder Division, nur für dieses Mal änderbar.',
  tierLabel: 'Stufe',
  previewBtn: 'Vorschau →',
  reviewMovesHint: 'Überprüfe die vorgeschlagenen Bewegungen unten — entferne das Häkchen bei jeder Mannschaft, die in ihrer aktuellen Division bleiben soll. Die Begegnungen aller Divisionen werden trotzdem archiviert und zurückgesetzt.',
  noMovesThisSeason: 'Keine Auf-/Abstiegsbewegungen in dieser Saison.',
  confirmEndSeasonBtn: 'Bestätigen und Saison beenden',
};

const pt: Translations = {
  langName: 'Português',
  appName: 'Shootout Comps',
  signIn: 'Entrar',
  signingIn: 'Entrando…',
  navBracket: 'Torneio',
  statusRegistration: 'Inscrições abertas',
  players: 'Jogadores',
  removePlayer: 'Remover',
  slotsRemaining: 'vagas disponíveis',
  noPlayersYet: 'Nenhum jogador inscrito ainda',
  awaitingDraw: 'Aguardando sorteio',
  champion: 'Campeão',
  clickToPlay: '→ Clique para jogar',
  matchComplete: 'Partida concluída',
  notStarted: 'Não iniciado',
  startMatchDesc: 'Pronto para começar? Isso iniciará o relógio de 10 minutos.',
  shotClockDesc: 'Relógio de tacada: 15s primeiros 5 min · 10s últimos 5 min',
  atTheTable: 'Na mesa',
  nextLegalPot: 'Próxima caçapa legal:',
  miss: 'Erro',
  cancelFoul: 'Cancelar',
  noContact: 'Sem contato',
  undo: 'Desfazer',
  cueBallPotted: 'Bola branca caçapada',
  endMatchEarly: 'Encerrar partida antes',
  finishMatchBtn: 'Encerrar partida',
  finishFrameBtn: 'Encerrar frame',
  enterFinalScore: 'Insira o placar final:',
  scoresInvalid: 'Insira dois placares diferentes',
  shotHistory: 'Histórico de tacadas',
  firstHalf: '1º tempo — 15s/tacada',
  backToBracket: '← Voltar ao torneio',
  shotClockExpired: 'RELÓGIO DE TACADA EXPIRADO',
  matchClockExpired: 'RELÓGIO DA PARTIDA EXPIRADO',
  dismiss: 'Fechar',
  foulToOpponent: 'Falta — +{n} ao adversário',
  noPotnPlayerChanged: '↩ Sem caçapa — troca de jogador',
  cannotUndo: 'Não é possível desfazer',
  adminDashboard: 'Painel admin',
  registrationOpen: 'Inscrições abertas',
  tournamentName: 'Nome do torneio',
  newTournament: '🆕 Novo Torneio',
  newTournamentDesc: 'Iniciar um novo torneio arquiva o atual.',
  startNewTournament: 'Novo Torneio',
  tournamentHistory: 'Histórico de torneios',
  noHistoryDesc: 'Torneios concluídos aparecerão aqui.',
  viewDetails: '→ Ver detalhes',
  participants: 'Participantes',
  userManagement: 'Gestão de usuários',
  you: 'Você',
  resetPasswordBtn: '🔑 Redefinir senha',
  passwordMinLength: 'Senha deve ter pelo menos 8 caracteres',
  userIsolationNote: 'Cada usuário só pode ver seus próprios torneios.',
  voiceHalfTime: 'Relógio de tacada de 10 segundos em operação',
  language: 'Idioma',
  profile: 'My Profile',
  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  passwordChanged: 'Password changed successfully.',
  forgotPassword: 'Forgot password?',
  sendResetLink: 'Send Reset Link',
  resetLinkSent: 'Reset link sent — check your email.',
  resetPassword: 'Reset Password',
  resetPasswordDesc: "Enter your email and we'll send a reset link.",
  setNewPassword: 'Set New Password',
  accountDetails: 'Account Details',
  memberSince: 'Member since',
  tournamentsTitle: 'Torneios',
  newTournament2: '+ Novo Torneio',
  currentTournament: 'Torneio Atual',
  pastTournaments: 'Torneios Passados',
  publicTournamentsHeading: 'Torneios Públicos',
  publicTournamentsSubtitle: 'Torneios que outros usuários tornaram públicos — qualquer usuário conectado pode ver o chaveamento e acompanhar as partidas ao vivo.',
  noPublicTournaments: 'Nenhum torneio público no momento.',
  hostedByLabel: 'Organizado por',
  watchLiveBtn: 'Assistir ao Vivo',
  backToPublicList: 'Voltar aos Torneios Públicos',
  spectatingBadge: '👀 Assistindo',
  noHistoryYet: 'No past tournaments yet.',
  noHistoryYetDesc: 'Completed tournaments appear here.',
  createTournament: 'Create Tournament',
  nextBtn: 'Próximo',
  backBtn: 'Voltar',
  editTournament: 'Edit Tournament',
  tournamentNameLabel: 'Tournament Name',
  dateTimeLabel: 'Date & Time',
  dateTimeHint: 'Shown on the tournaments list',
  maxPlayersLabel: 'Maximum Players',
  maxPlayersHint: 'Empty slots filled with BYEs',
  handicapLabel: 'Handicap Tournament',
  handicapOnDesc: 'Handicap ON',
  handicapOffDesc: 'Handicap OFF',
  pauseClocks: 'Pause Clocks',
  resumeClocks: 'Resume Clocks',
  saveChanges: 'Save Changes',
  confirmCreateTitle: 'Start New Tournament?',
  confirmCreateMsg: 'Current tournament will be archived.',
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  registrationLabel: 'Registration',
  activeLabel: 'In Progress',
  completeLabel: 'Complete',
  maxLabel: 'Max',
  handicapBadge: 'Handicap',
  playerManagement: 'Player Management',
  playerManagementDesc: 'Click photo to change',
  deletePlayerTitle: 'Delete Player',
  deletePlayerMsg: 'This player will be removed.',
  changePhoto: 'Photo',
  deletePlayer: 'Delete',
  newPhotoSelected: 'New photo selected',
  handicapEditHint: 'Handicap',
  handicapValue: 'Handicap',
  clickToEditHandicap: 'Clique para editar o handicap',
  playerCountAll: '{n} jogador{s} em todos os torneios',
  playerCountMatch: '{n} jogador{s} correspondendo a "{q}"',
  clickToChangePhoto: 'Click to change photo',
  photoFromPrevious: 'Photo from previous tournament',
  handicapStartTitle: 'Handicap Start',
  handicapStartDesc: 'Points advantage applied',
  debugJumpBtn: 'Debug: Jump to 5:30',
  pointsAdvantageApplied: 'Points advantage applied',
  handicapPts: 'pts — maior = jogador mais fraco = mais pontos de vantagem',
  passwordWeak: 'Fraca',
  passwordFair: 'Regular',
  passwordGood: 'Boa',
  passwordStrong: 'Forte',
  passwordsNoMatch: 'As senhas não coincidem',
  repeatPassword: 'Repetir Senha',
  creatingAccount: 'Criando conta…',
  minChars: 'Mín. 8 caracteres',
  usernameHint: 'Letras, números, espaços, sublinhados e hífens',
  deactivateAccount: 'Desativar Conta',
  newPasswordMin: 'Nova senha (mín. 8)',
  suspensionReason: 'Motivo da suspensão (opcional)',
  confirmSuspend: 'Confirmar Suspensão',
  passwordUpdated: 'Senha atualizada ✓',
  addNewUser: 'Adicionar Usuário',
  addPlayer: 'Adicionar Jogador',
  allUsers: 'Todos os Usuários',
  awaitingDrawDesc: 'Cadastre jogadores e inicie o torneio.',
  ballOffTable: 'Bola Fora',
  byesAdded: '{n} BYE(s) adicionado(s)',
  cancel: 'Cancelar',
  complete: 'Concluído',
  connecting: 'Conectando…',
  createUser: '+ Adicionar',
  creating: 'Criando…',
  declareWinner: 'Declarar vencedor:',
  deleteUser: 'Excluir',
  dir: 'ltr',
  elapsed: 'decorrido',
  endMatchToDeclare: 'Encerre o jogo para declarar o vencedor',
  foul: 'Falta',
  inProgress: 'Em Andamento',
  inProgressStatus: 'Torneio em andamento',
  joined: 'Entrou',
  splashTagline: 'Organize seu torneio de snooker como um profissional.',
  splashSubtitle: 'Pontuação ao vivo, cronômetros, perfis de jogadores e histórico completo — sob regras Shootout ou Snooker 900. Primeiro torneio grátis.',
  splashSubtitleAllFree: 'Pontuação ao vivo, cronômetros, perfis de jogadores e histórico completo. Todos os torneios são gratuitos.',
  splashSubtitlePaid: 'Pontuação ao vivo, cronômetros, perfis de jogadores e histórico completo.',
  splashSubtitleNFree: 'Pontuação ao vivo, cronômetros, perfis de jogadores e histórico completo. Primeiros {n} torneios grátis.',
  splashNoCreditCard: 'Sem cartão de crédito · Primeiro torneio grátis',
  splashNoCreditCardAllFree: 'Sem cartão de crédito · Todos os torneios grátis',
  splashNoCreditCardPaid: 'Sem cartão de crédito',
  splashNoCreditCardNFree: 'Sem cartão de crédito · Primeiros {n} torneios grátis',
  splashStep1Title: 'Crie sua conta',
  splashStep1Desc: 'Cadastre-se com e-mail. Primeiro torneio grátis.',
  splashStep1DescAllFree: 'Cadastre-se com e-mail. Todos os torneios gratuitos.',
  splashStep1DescPaid: 'Cadastre-se com e-mail.',
  splashStep1DescNFree: 'Cadastre-se com e-mail. Primeiros {n} torneios grátis.',
  whoBreaks: 'Quem abre?',
  whoBreaksDesc: 'Selecione o jogador que vai abrir. O relógio inicia ao confirmar.',
  breakOffBtn: 'Abertura',
  breaksOff: 'Abre',
  selectPlayerFirst: 'Selecione um jogador primeiro',
  matchClockStartsOnBreak: 'O relógio inicia ao confirmar a abertura.',
  foulCueBallInHand: 'Falta — Bola na mão',
  pointsAwardedToOpponent: 'pontos concedidos ao adversário.',
  toPlayFromHand: 'joga com bola na mão.',
  clocksPausedMsg: 'Ambos os relógios estão pausados.',
  resumeMatch: '▶ Retomar partida',
  freeBallLabel: 'Free ball',
  freeBallSnookeredMsg: 'está encurralado (snookered) em todas as bolas. A próxima tacada pode indicar qualquer bola; ela pontua como a bola realmente em jogo.',
  freeBallActiveBanner: '🔴 FREE BALL — escolha qualquer bola para esta tacada',
  respotBlackBanner: '🎱 PRETA RECOLOCADA — frame empatado, quem ganhou o sorteio?',
  higherValueFoul: 'Falta de valor maior',
  selectHighestBallTouched: 'Selecione a bola de maior valor tocada',
  highestBreakLabel: 'Maior série',
  highBreakPrizeLabel: '🔴 Prêmio maior série',
  highBreakPrizeHint: 'Prêmio opcional ao jogador com a maior série. Exibido no cartaz.',
  contactTitle: 'Fale conosco',
  contactSubtitle: 'Tem uma dúvida? Envie uma mensagem.',
  contactSubjectLabel: 'Assunto',
  contactMessageLabel: 'Mensagem',
  contactSendBtn: '✉ Enviar mensagem',
  contactSentTitle: 'Mensagem enviada',
  contactSentDesc: 'Obrigado! Responderemos o mais breve possível.',
  contactSendAnother: 'Enviar outra mensagem',
  contactAimToRespond: 'Respondemos em 1–2 dias úteis.',
  changeEmailTitle: 'Alterar e-mail',
  changeEmailNewLabel: 'Novo endereço de e-mail',
  changeEmailSendBtn: 'Enviar e-mail de verificação',
  sendPasswordResetLink: 'Enviar link de redefinição para',
  backToSignIn: '← Voltar ao login',
  viewDraw: 'Ver chave →',
  loadingTournament: 'Carregando torneio…',
  loadingMatch: 'Carregando partida…',
  tournamentNotFound: 'Torneio não encontrado',
  matchNotFound: 'Partida não encontrada',
  backToHistory: '← Voltar ao histórico',
  backToDraw: '← Voltar à chave',
  backToUsers: '← Voltar aos usuários',
  deleteTournamentTitle: 'Excluir torneio',
  deleteTournamentConfirm: 'Isso excluirá permanentemente o torneio e todos os seus dados.',
  tournamentsHeading: 'Torneios',
  loadingTournaments: 'Carregando torneios…',
  noTournamentsYet: 'Este usuário ainda não criou torneios.',
  viewThisUsersTournaments: 'Ver torneios deste usuário',
  grantFreeForLife: 'Conceder torneios gratuitos vitalícios',
  revokeFreeForLife: 'Revogar torneios gratuitos',
    langFlag: '🇧🇷',
  lastShotUndone: '↩ Último tiro desfeito',
  live: 'AO VIVO',
  losesTheFrame: 'perde o frame',
  matchesDone: 'Partidas Realizadas',
  navAdmin: 'Admin',
  navHistory: 'Torneios',
  navPlayers: 'Adicionar Jogadores',
  navUsers: 'Usuários',
  noHistory: 'Nenhum torneio passado.',
  noPot: 'Sem encaçapar',
  nothingToUndo: 'Nada a desfazer',
  password: 'Senha',
  playerName: 'Nome do jogador…',
  plusToOpponent: '+{n} ao adversário',
  potBall: 'Encaçapar bola',
  potted: '{ball} encaçapada (+{n})',
  redsRemaining: 'vermelhas restantes',
  registered: 'registrado',
  remaining: 'restante',
  rounds: 'Rodadas',
  save: 'Salvar',
  saving: 'Salvando…',
  secondHalf: '2ª Metade',

  selectFoulBall: 'Selecione a bola faltada:',
  selectFoulType: 'Tipo de falta',
  shotClock: 'Relógio de tacada',
  shotsCount: 'tacadas',
  shotsPlayed: 'Tacadas jogadas',
  signOut: 'Sair',
  startMatch: 'Iniciar Partida',
  startTournament: 'Iniciar Torneio',
  statusActive: '● Em Andamento',
  statusComplete: '✓ Concluído',
  superuser: 'superusuário',
  tapBallAbove: 'Toque na bola faltada acima',
  tournamentStatus: 'Status do Torneio',
  user: 'usuário',
  username: 'Nome de usuário',
  viewDetails2: 'Ver chave e resultados',
  vsLabel: 'VS',
  wins: 'vence',
  roundFinal: 'Final',
  roundSemiFinals: 'Semifinais',
  roundQuarterFinals: 'Quartas de final',
  roundOf16: 'Oitavas de final',
  roundOf: 'Rodada de',
  owner: 'Proprietário',
  timePlayed: 'jogado',
  matchesPlayed: 'jogados',
  noPlayersRegistered: 'Nenhum jogador registrado ainda',
  startTypingPlayers: 'Comece a digitar para ver jogadores de torneios anteriores',
  startTournamentConfirm: 'Iniciar o torneio? A chave será gerada automaticamente.',
  splashFeaturesHeading: 'Tudo o que você precisa para organizar um shootout',
  splashFooterTagline: 'Shootout Comps — Gestão de torneios',
  splashUpAndRunning: 'Em funcionamento em minutos',
  splashStep2Title: 'Registre seus jogadores',
  splashStep2Desc: 'Adicione até 32 jogadores com fotos',
  splashStep3Title: 'Inicie o torneio',
  splashStep3Desc: 'A chave é gerada automaticamente',
  splashStep4Title: 'Gerencie partidas ao vivo',
  splashStep4Desc: 'Pontue cada tacada, acompanhe o relógio, veja os resultados',
  splashReadyTitle: 'Pronto para seu torneio?',
  splashGetStarted: '🏆 Começar gratuitamente',
  splashGetStartedPaid: '🏆 Criar conta',
  splashPricingAllFree: 'Todos os torneios são gratuitos — sem pagamento necessário.',
  splashPricingPaidOnly: 'Os torneios custam {price} cada um.',
  splashPricingOneFree: 'Seu primeiro torneio é gratuito, depois {price} cada um.',
  splashPricingNFree: 'Seus primeiros {n} torneios são gratuitos, depois {price} cada um.',
  privacyPolicy: 'Política de privacidade',
  resend: 'Reenviar',
  resending: 'Enviando…',
  newLinkSent: '✓ Novo link enviado — verifique sua caixa de entrada',
  didntGetIt: 'Não recebeu? Reenviar e-mail',
  sendResetCode: 'Enviar código de redefinição',
  verifyCode: 'Verificar código',
  verifying: 'Verificando…',
  resendCode: 'Reenviar código',
  handicapStart: '🏅 Início com handicap',
  noPlayersFound: 'Nenhum jogador encontrado em seus torneios.',
  noPlayersMatching: 'Nenhum jogador correspondente a',
  navContact: 'Contato',
  navPublic: 'Público',
  navFaq: 'Ajuda e FAQ',
  navLeagues: 'Ligas',
  faqSubtitle: 'Tudo o que você precisa saber para organizar um torneio Shootout, Snooker 900 ou Padrão.',
  faqSearch: 'Pesquisar perguntas…',
  faqNoResults: 'Nenhuma pergunta corresponde à sua pesquisa.',
  faqContact: 'Ainda tem uma pergunta?',
  faqContactLink: 'Entre em contato pela página de contato',
  paymentsEnabled: 'Pagamentos ATIVADOS',
  paymentsDisabled: 'Pagamentos DESATIVADOS',
  statusLabel: 'Status',
  fromLabel: 'De',
  freeForLife: '♾ Grátis',
  freeForLifeGranted: '♾ Grátis ✓',
  createAccount: '🏆 Criar conta',
  splashSignIn: 'Entrar',
  splashSignUp: 'Registrar',
  dontHaveAccount: 'Não tem conta?',
  createFreeAccount: 'Criar conta grátis',
  signInNow: '🏆 Entrar agora',
  orContinueWith: 'ou continue com',
  continueWithGoogle: 'Continuar com o Google',
  continueWithFacebook: 'Continuar com o Facebook',
  oauthErrorTitle: 'Falha ao entrar',
  oauthErrorGeneric: 'Algo deu errado ao entrar. Por favor, tente novamente.',
  oauthErrorEmailNotVerified: 'Essa conta não tem um endereço de e-mail verificado, então não podemos entrar com ela.',
  oauthErrorAccountSuspended: 'Esta conta foi suspensa.',
  oauthErrorDenied: 'Você cancelou o login.',
  oauthErrorProviderDisabled: 'O login com este provedor está desativado no momento.',
  noPasswordSetError: 'Esta conta entra com Google ou Facebook — use um desses botões.',
  navPlayersAdmin: '⚙ Jogadores',
  allPlayersDesc: 'Todos os jogadores de todos os seus torneios. Clique na foto para atualizá-la; os handicaps são editáveis.',
  pwStrengthWeak: 'Fraco',
  pwStrengthFair: 'Razoável',
  pwStrengthGood: 'Bom',
  pwStrengthStrong: 'Forte',
  pauseShotClock: 'Pausar',
  resumeShotClock: 'Retomar',
  newTournamentTitle: '🏆 Novo Torneio',
  editTournamentTitle: '✎ Editar Torneio',
  locationLabel: '📍 Local / Sede',
  locationPlaceholder: 'ex. The Crown, Lisboa',
  locationHint: 'Opcional — exibido no cartão do torneio.',
  entryFeeLabel: '💰 Taxa de inscrição',
  entryFeeHint: 'Deixe em branco se não houver taxa.',
  prizePlacesLabel: '🏆 Lugares premiados',
  prizePlacesNone: 'Nenhum',
  prizePlacesHint: 'Selecione quantos lugares recebem prêmios.',
  prizePoolLabel: 'Total de prêmios',
  matchFormatLabel: '🔴 Formato da partida',
  shootoutDesc: 'Shootout: 10 min · {r} vermelhas · 15s tacadas (5 min) · 10s (5 min)',
  snooker900Desc: 'Snooker 900: 15 min · {r} vermelhas · 20s tacadas',
  sixRedsLabel: '🔴 Seis Vermelhas — apenas 6 ao invés de 15',
  sixRedsDesc: 'Seis Vermelhas',
  standardFormatHint: 'Snooker padrão: sem limite de tempo · regras completas · {r} vermelhas',
  bestOfDialogTitle: 'Frames por rodada',
  bestOfDialogDesc: 'Escolha quantos frames são necessários para vencer cada rodada (apenas números ímpares, para que haja sempre um vencedor).',
  bestOfContinueBtn: 'Continuar',
  bestOfBackBtn: 'Voltar',
  handicapHint: 'Quando ativado, insira o handicap de cada jogador. O mais fraco recebe a diferença.',
  makePublicLabel: 'Torneio Público',
  makePublicHint: 'Qualquer usuário conectado poderá ver o chaveamento e acompanhar as partidas ao vivo.',
  cancelBtn: 'Cancelar',
  timedTournamentTitle: 'Torneio Cronometrado',
  timedTournamentDesc: 'Shootout ou Snooker 900 · relógio de tacada',
  standardTournamentTitle: 'Torneio Padrão',
  standardTournamentDesc: 'Regras padrão · sem limite de tempo · seis vermelhas opcional',
  chooseTournamentType: 'Escolha o tipo de torneio que deseja criar.',
  completedTournamentsAppearHere: 'Torneios concluídos aparecem aqui.',
  maxEntriesLabel: 'Máx {n} participantes',
  prizePlaceSingle: 'lugar premiado',
  prizePlacePlural: 'lugares premiados',
  prizePoolPrefix: 'Prêmio',
  entryLabel: 'Inscrição',
  handicapTournament: 'Torneio com handicap',
  scratchTournament: 'Torneio scratch',
  highBreakPrizeDisplay: 'Prêmio maior série',
  noDateVenueWarning: 'Sem data, local, taxa ou prêmios. Edite o torneio para um pôster mais completo.',
  additionalTextLabel: 'Texto adicional (opcional)',
  additionalTextPlaceholder: 'ex. Todos bem-vindos! Contate João: 07700 900000.',
  additionalTextHint: 'Impresso no rodapé do pôster.',
  downloadPdfPoster: '⬇ Baixar pôster PDF',
  generatingPoster: '⏳ Gerando…',
  paymentGateTitle: 'Novo Torneio',
  paymentGateDesc: 'Você usou seu torneio gratuito. Um pagamento único de {amount} é necessário.',
  editBtn: '✎ Editar',
  posterBtn: '🖨 Pôster',
  sharedBadge: 'Compartilhado',
  publicBadge: 'Público',
  privateBadge: 'Privado',
  togglePublicHint: 'Clique para alternar entre público e privado',
  adminsBtn: 'Admins',
  adminsDesc: 'Os administradores têm acesso total para pontuar e gerenciar este torneio, exceto excluí-lo ou gerenciar esta lista.',
  usernamePlaceholder: 'Nome de usuário…',
  addBtn: 'Adicionar',
  removeBtn: 'Remover',
  noAdminsYet: 'Nenhum administrador adicionado ainda.',
  statusRegistrationLabel: 'Inscrições',
  statusActiveLabel: 'Em andamento',
  statusCompleteLabel: 'Concluído',
  emailAddress: 'Email',
  bracketWinner: 'Vencedor',
  bracketChampionTitle: 'Campeão',
  bracketSavingLabel: 'Salvando…',
  bracketSaveResult: 'Salvar resultado',
  bracketEntries: 'participantes',
  bracketEntry: 'participante',
  bracketPrizePool: 'bolsa de prêmios',
  bracketHighBreak: 'maior break',
  bracketSixReds: 'Seis Vermelhas',
  bracketHandicap: 'Handicap',
  bracketShootoutLabel: 'Shootout',
  bracketSnooker900Label: 'Snooker 900',
  bracketStandardLabel: 'Standard',
  bracketPlace: 'lugar',
  bracketPlaces: 'lugares',
  statsPlayersLabel: 'Jogadores',
  statsHighBreakLabel: 'Maior Break',
  statsDateLabel: 'Data',
  statsVenueLabel: 'Local',
  spectatorView: 'Modo espectador — outro dispositivo está marcando este jogo',
  resetLinkInvalidTitle: 'Link inválido',
  resetLinkExpiredMsg: 'Este link de redefinição expirou.',
  resetLinkInvalidMsg: 'Este link é inválido ou já foi usado.',
  emailUpdatedTitle: 'Email atualizado',
  emailChangeLinkInvalidTitle: 'Link inválido',
  emailAlreadyTaken: 'Esse endereço de email já está sendo usado por outra conta.',
  emailChangeLinkInvalidMsg: 'Este link de alteração de email é inválido ou já foi usado.',
  accountSuspendedTitle: 'Conta suspensa',
  accountSuspendedMsg: 'Sua conta foi suspensa.',
  editMatchResult: 'Editar resultado da partida',
  adminOnlineNow: 'Online agora (5 min)',
  adminTotalAccounts: 'Total de contas',
  adminAwaitingVerification: 'Aguardando verificação',
  adminNewThisWeek: 'Novos esta semana',
  adminNewThisMonth: 'Novos este mês',
  adminMatchesInProgress: 'Partidas em andamento',
  adminInProgress: 'Em andamento',
  adminUniquePlayerEntries: 'Entradas únicas de jogadores',
  adminTotalEver: 'Total histórico',
  adminLoadingStats: 'Carregando estatísticas…',
  settingsSavePrices: 'Salvar preços',
  settingsCurrentState: 'Estado atual:',
  settingsTimedLabel: 'Cronometrado',
  settingsStandardLabel: 'Standard',
  settingsPerUserOverrides: 'Exceções por usuário',
  usersAccountStates: 'Estados de conta:',
  usersActiveState: 'Ativo',
  usersPendingState: 'Pendente',
  usersSuspendedState: 'Suspenso',
  usersDeactivatedState: 'Desativado',
  loadingLabel: 'Carregando…',
  leaguesEmptyDesc: 'Organize uma competição por equipas ao longo de uma temporada — divisões, jogos e classificação. Crie a sua primeira liga para começar.',
  createLeagueBtn: '+ Criar liga',
  leagueNamePlaceholder: 'Nome da liga',
  divisionTabTeams: '👥 Equipas',
  divisionTabFixtures: '📅 Jogos',
  divisionTabStandings: '🏆 Classificação',
  standingsTeamCol: 'Equipa',
  noTeamsInDivision: 'Ainda não há equipas nesta divisão.',
  fixtureStatusScheduled: 'Agendado',
  fixtureStatusLineupSet: 'Escalação definida',
  fixtureStatusInProgress: 'Em curso',
  backToFixture: '← Voltar ao jogo',
  publicLeaguesTitle: '🌐 Ligas Públicas',
  publicLeaguesDesc: 'Explore e acompanhe ligas que outros organizadores tornaram públicas.',
  noPublicLeaguesYet: 'Ainda não há ligas públicas.',
  backToPublicLeagues: '← Ligas Públicas',
  noFixturesYetLabel: 'Ainda não há jogos.',
  noTeamsYetLabel: 'Ainda não há equipas.',
  backToAllSeasons: '← Todas as épocas',
  noPastSeasonsYet: 'Ainda não há épocas passadas.',
  noPastSeasonsYetOwner: 'Ainda não há épocas passadas — aparecerão aqui após o primeiro "Terminar Época" desta divisão.',
  endedLabel: 'Terminada',
  promotedLabel: 'promovidos',
  relegatedLabel: 'despromovidos',
  finalStandingsLabel: 'Classificação final',
  fixturesLabel: 'Jogos',
  historyTabLabel: '📜 Histórico',
  doubleRoundRobinLabel: 'Casa e fora (round-robin duplo)',
  pendingClaimApprovalLabel: '⏳ aprovação pendente',
  approveBtn: 'Aprovar',
  rejectBtn: 'Rejeitar',
  tierFieldLabel: 'Nível (1 = divisão superior)',
  promotionSpotsFieldLabel: 'Vagas de promoção (padrão)',
  relegationSpotsFieldLabel: 'Vagas de despromoção (padrão)',
  seasonManagementHint: 'Gestão de época: o nível desta divisão (1 = superior) e o número padrão de vagas de promoção/despromoção pré-preenchido na próxima pré-visualização de fim de época. Pode ser alterado a cada época.',
  togglePublicTooltip: 'Alternar se qualquer utilizador autenticado pode explorar e acompanhar esta liga',
  toggleClaimApprovalTooltip: 'Alternar se as autorreivindicações de plantel precisam de aprovação do proprietário/admin',
  publicChipLabel: '🌐 Pública',
  privateChipLabel: '🔒 Privada',
  claimsApprovalChipLabel: '🛂 Reivindicações: Aprovação',
  claimsInstantChipLabel: '⚡ Reivindicações: Instantâneas',
  endSeasonBtn: '🏁 Terminar Época',
  browsePublicLeaguesLink: '🌐 Explorar Ligas Públicas',
  myStatsTitle: 'As Minhas Estatísticas',
  statsPlayedLabel: 'Jogados',
  statsWonLabel: 'Ganhos',
  statsLostLabel: 'Perdidos',
  seasonLabelFieldLabel: 'Nome da época',
  seasonLabelPlaceholder: 'ex. 2025/26',
  seasonCountsHint: 'Vagas de promoção/despromoção para esta época — pré-preenchidas com os valores padrão de cada divisão, editáveis só desta vez.',
  tierLabel: 'nível',
  previewBtn: 'Pré-visualizar →',
  reviewMovesHint: 'Reveja os movimentos propostos abaixo — desmarque qualquer equipa que queira manter na sua divisão atual. Os jogos de todas as divisões serão arquivados e reiniciados de qualquer forma.',
  noMovesThisSeason: 'Sem movimentos de promoção/despromoção nesta época.',
  confirmEndSeasonBtn: 'Confirmar e Terminar Época',
};

const it: Translations = {
  langName: 'Italiano',
  appName: 'Shootout Comps',
  signIn: 'Accedi',
  signingIn: 'Accesso…',
  navBracket: 'Torneo',
  statusRegistration: 'Iscrizioni aperte',
  players: 'Giocatori',
  removePlayer: 'Rimuovi',
  slotsRemaining: 'posti disponibili',
  noPlayersYet: 'Nessun giocatore iscritto',
  awaitingDraw: 'In attesa del sorteggio',
  champion: 'Campione',
  clickToPlay: '→ Clicca per giocare',
  matchComplete: 'Partita completata',
  notStarted: 'Non iniziato',
  startMatchDesc: 'Pronto? Avvierà il cronometro di 10 minuti.',
  shotClockDesc: 'Cronometro colpo: 15s primi 5 min · 10s ultimi 5 min',
  atTheTable: 'Al tavolo',
  nextLegalPot: 'Prossima buca legale:',
  miss: 'Mancato',
  cancelFoul: 'Annulla',
  noContact: 'Nessun contatto',
  undo: 'Annulla',
  cueBallPotted: 'Pallino bianco imbucato',
  endMatchEarly: 'Termina partita prima',
  finishMatchBtn: 'Termina partita',
  finishFrameBtn: 'Termina frame',
  enterFinalScore: 'Inserisci il punteggio finale:',
  scoresInvalid: 'Inserisci due punteggi diversi',
  shotHistory: 'Cronologia colpi',
  firstHalf: '1° tempo — 15s/colpo',
  backToBracket: '← Torna al torneo',
  shotClockExpired: 'CRONOMETRO COLPO SCADUTO',
  matchClockExpired: 'TEMPO PARTITA SCADUTO',
  dismiss: 'Chiudi',
  foulToOpponent: 'Fallo — +{n} all\'avversario',
  noPotnPlayerChanged: '↩ Nessuna buca — cambio giocatore',
  cannotUndo: 'Impossibile annullare',
  adminDashboard: 'Pannello admin',
  registrationOpen: 'Iscrizioni aperte',
  tournamentName: 'Nome torneo',
  newTournament: '🆕 Nuovo Torneo',
  newTournamentDesc: 'Avviare un nuovo torneo archivia quello attuale.',
  startNewTournament: 'Nuovo Torneo',
  tournamentHistory: 'Cronologia tornei',
  noHistoryDesc: 'I tornei completati appariranno qui.',
  viewDetails: '→ Vedi dettagli',
  participants: 'Partecipanti',
  userManagement: 'Gestione utenti',
  you: 'Tu',
  resetPasswordBtn: '🔑 Reset PW',
  passwordMinLength: 'La password deve avere almeno 8 caratteri',
  userIsolationNote: 'Ogni utente può vedere solo i propri tornei.',
  voiceHalfTime: 'Cronometro colpo di 10 secondi ora in funzione',
  language: 'Lingua',
  profile: 'My Profile',
  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  passwordChanged: 'Password changed successfully.',
  forgotPassword: 'Forgot password?',
  sendResetLink: 'Send Reset Link',
  resetLinkSent: 'Reset link sent — check your email.',
  resetPassword: 'Reset Password',
  resetPasswordDesc: "Enter your email and we'll send a reset link.",
  setNewPassword: 'Set New Password',
  accountDetails: 'Account Details',
  memberSince: 'Member since',
  tournamentsTitle: 'Tornei',
  newTournament2: '+ Nuovo Torneo',
  currentTournament: 'Torneo Corrente',
  pastTournaments: 'Tornei Passati',
  publicTournamentsHeading: 'Tornei Pubblici',
  publicTournamentsSubtitle: 'Tornei che altri utenti hanno reso pubblici — qualsiasi utente collegato può vedere il tabellone e seguire le partite dal vivo.',
  noPublicTournaments: 'Nessun torneo pubblico al momento.',
  hostedByLabel: 'Organizzato da',
  watchLiveBtn: 'Guarda dal Vivo',
  backToPublicList: 'Torna ai Tornei Pubblici',
  spectatingBadge: '👀 Sto guardando',
  noHistoryYet: 'No past tournaments yet.',
  noHistoryYetDesc: 'Completed tournaments appear here.',
  createTournament: 'Create Tournament',
  nextBtn: 'Avanti',
  backBtn: 'Indietro',
  editTournament: 'Edit Tournament',
  tournamentNameLabel: 'Tournament Name',
  dateTimeLabel: 'Date & Time',
  dateTimeHint: 'Shown on the tournaments list',
  maxPlayersLabel: 'Maximum Players',
  maxPlayersHint: 'Empty slots filled with BYEs',
  handicapLabel: 'Handicap Tournament',
  handicapOnDesc: 'Handicap ON',
  handicapOffDesc: 'Handicap OFF',
  pauseClocks: 'Pause Clocks',
  resumeClocks: 'Resume Clocks',
  saveChanges: 'Save Changes',
  confirmCreateTitle: 'Start New Tournament?',
  confirmCreateMsg: 'Current tournament will be archived.',
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  registrationLabel: 'Registration',
  activeLabel: 'In Progress',
  completeLabel: 'Complete',
  maxLabel: 'Max',
  handicapBadge: 'Handicap',
  playerManagement: 'Player Management',
  playerManagementDesc: 'Click photo to change',
  deletePlayerTitle: 'Delete Player',
  deletePlayerMsg: 'This player will be removed.',
  changePhoto: 'Photo',
  deletePlayer: 'Delete',
  newPhotoSelected: 'New photo selected',
  handicapEditHint: 'Handicap',
  handicapValue: 'Handicap',
  clickToEditHandicap: "Clicca per modificare l'handicap",
  playerCountAll: '{n} giocator{s} in tutti i tornei',
  playerCountMatch: '{n} giocator{s} corrispondenti a "{q}"',
  clickToChangePhoto: 'Click to change photo',
  photoFromPrevious: 'Photo from previous tournament',
  handicapStartTitle: 'Handicap Start',
  handicapStartDesc: 'Points advantage applied',
  debugJumpBtn: 'Debug: Jump to 5:30',
  pointsAdvantageApplied: 'Points advantage applied',
  handicapPts: 'pts — più alto = giocatore più debole = più punti di vantaggio',
  passwordWeak: 'Debole',
  passwordFair: 'Sufficiente',
  passwordGood: 'Buona',
  passwordStrong: 'Forte',
  passwordsNoMatch: 'Le password non corrispondono',
  repeatPassword: 'Ripeti Password',
  creatingAccount: 'Creazione account…',
  minChars: 'Min. 8 caratteri',
  usernameHint: 'Lettere, numeri, spazi, trattini bassi e trattini',
  deactivateAccount: 'Disattiva Account',
  newPasswordMin: 'Nuova password (min. 8)',
  suspensionReason: 'Motivo della sospensione (facoltativo)',
  confirmSuspend: 'Conferma Sospensione',
  passwordUpdated: 'Password aggiornata ✓',
  addNewUser: 'Aggiungi Utente',
  addPlayer: 'Aggiungi Giocatore',
  allUsers: 'Tutti gli Utenti',
  awaitingDrawDesc: 'Registra i giocatori e avvia il torneo.',
  ballOffTable: 'Palla fuori',
  byesAdded: '{n} BYE(s) aggiunto/i',
  cancel: 'Annulla',
  complete: 'Completato',
  connecting: 'Connessione…',
  createUser: '+ Aggiungi',
  creating: 'Creazione…',
  declareWinner: 'Dichiara il vincitore:',
  deleteUser: 'Elimina',
  dir: 'ltr',
  elapsed: 'trascorso',
  endMatchToDeclare: 'Termina il match per dichiarare il vincitore',
  foul: 'Fallo',
  inProgress: 'In Corso',
  inProgressStatus: 'Torneo in corso',
  joined: 'Iscritto',
  splashTagline: 'Organizza il tuo torneo di snooker come un professionista.',
  splashSubtitle: 'Punteggio in diretta, cronometri, profili giocatori e storico completo — con regole Shootout o Snooker 900. Primo torneo gratuito.',
  splashSubtitleAllFree: 'Punteggio in diretta, cronometri, profili giocatori e storico completo. Tutti i tornei sono gratuiti.',
  splashSubtitlePaid: 'Punteggio in diretta, cronometri, profili giocatori e storico completo.',
  splashSubtitleNFree: 'Punteggio in diretta, cronometri, profili giocatori e storico completo. I primi {n} tornei sono gratuiti.',
  splashNoCreditCard: 'Nessuna carta di credito · Primo torneo gratuito',
  splashNoCreditCardAllFree: 'Nessuna carta di credito · Tutti i tornei gratuiti',
  splashNoCreditCardPaid: 'Nessuna carta di credito',
  splashNoCreditCardNFree: 'Nessuna carta di credito · Primi {n} tornei gratuiti',
  splashStep1Title: 'Crea il tuo account',
  splashStep1Desc: 'Registrati con e-mail. Primo torneo gratuito.',
  splashStep1DescAllFree: 'Registrati con e-mail. Tutti i tornei gratuiti.',
  splashStep1DescPaid: 'Registrati con e-mail.',
  splashStep1DescNFree: 'Registrati con e-mail. I primi {n} tornei sono gratuiti.',
  whoBreaks: 'Chi batte?',
  whoBreaksDesc: 'Seleziona il giocatore che batterà. Il cronometro parte alla conferma.',
  breakOffBtn: 'Battuta iniziale',
  breaksOff: 'Batte',
  selectPlayerFirst: 'Seleziona prima un giocatore',
  matchClockStartsOnBreak: 'Il cronometro parte alla conferma della battuta.',
  foulCueBallInHand: 'Fallo — Bilia in mano',
  pointsAwardedToOpponent: 'punti assegnati all\'avversario.',
  toPlayFromHand: 'gioca con bilia in mano.',
  clocksPausedMsg: 'Entrambi i cronometri sono in pausa.',
  resumeMatch: '▶ Riprendi partita',
  freeBallLabel: 'Free ball',
  freeBallSnookeredMsg: 'è snookerato su tutte le palline. Il prossimo colpo può nominare qualsiasi pallina; conta come la pallina realmente di turno.',
  freeBallActiveBanner: '🔴 FREE BALL — scegli qualsiasi pallina per questo colpo',
  respotBlackBanner: '🎱 NERA RIPOSIZIONATA — frame in parità, chi ha vinto il sorteggio?',
  higherValueFoul: 'Fallo di valore superiore',
  selectHighestBallTouched: 'Seleziona la bilia di valore più alto toccata',
  highestBreakLabel: 'Serie più alta',
  highBreakPrizeLabel: '🔴 Premio serie più alta',
  highBreakPrizeHint: 'Premio opzionale al giocatore con la serie più alta. Mostrato sul manifesto.',
  contactTitle: 'Contattaci',
  contactSubtitle: 'Hai una domanda? Inviaci un messaggio.',
  contactSubjectLabel: 'Oggetto',
  contactMessageLabel: 'Messaggio',
  contactSendBtn: '✉ Invia messaggio',
  contactSentTitle: 'Messaggio inviato',
  contactSentDesc: 'Grazie! Risponderemo il prima possibile.',
  contactSendAnother: 'Invia un altro messaggio',
  contactAimToRespond: 'Rispondiamo entro 1–2 giorni lavorativi.',
  changeEmailTitle: 'Cambia e-mail',
  changeEmailNewLabel: 'Nuovo indirizzo e-mail',
  changeEmailSendBtn: 'Invia e-mail di verifica',
  sendPasswordResetLink: 'Invia link di reimpostazione a',
  backToSignIn: '← Torna all\'accesso',
  viewDraw: 'Vedi tabellone →',
  loadingTournament: 'Caricamento torneo…',
  loadingMatch: 'Caricamento partita…',
  tournamentNotFound: 'Torneo non trovato',
  matchNotFound: 'Partita non trovata',
  backToHistory: '← Torna alla storia',
  backToDraw: '← Torna al tabellone',
  backToUsers: '← Torna agli utenti',
  deleteTournamentTitle: 'Elimina torneo',
  deleteTournamentConfirm: 'Questo eliminerà definitivamente il torneo e tutti i dati.',
  tournamentsHeading: 'Tornei',
  loadingTournaments: 'Caricamento tornei…',
  noTournamentsYet: 'Questo utente non ha ancora creato tornei.',
  viewThisUsersTournaments: 'Vedi i tornei di questo utente',
  grantFreeForLife: 'Concedi tornei gratuiti a vita',
  revokeFreeForLife: 'Revoca tornei gratuiti',
    langFlag: '🇮🇹',
  lastShotUndone: '↩ Ultimo tiro annullato',
  live: 'LIVE',
  losesTheFrame: 'perde il frame',
  matchesDone: 'Partite Giocate',
  navAdmin: 'Admin',
  navHistory: 'Tornei',
  navPlayers: 'Aggiungi Giocatori',
  navUsers: 'Utenti',
  noHistory: 'Nessun torneo passato.',
  noPot: 'Nessuna buca',
  nothingToUndo: 'Nulla da annullare',
  password: 'Password',
  playerName: 'Nome giocatore…',
  plusToOpponent: '+{n} all\'avversario',
  potBall: 'Imbucare una palla',
  potted: '{ball} imbucata (+{n})',
  redsRemaining: 'rosse rimanenti',
  registered: 'registrato',
  remaining: 'rimanente',
  rounds: 'Round',
  save: 'Salva',
  saving: 'Salvataggio…',
  secondHalf: '2° Tempo',

  selectFoulBall: 'Seleziona la palla foulata:',
  selectFoulType: 'Tipo di fallo',
  shotClock: 'Cronometro tiro',
  shotsCount: 'colpi',
  shotsPlayed: 'Colpi giocati',
  signOut: 'Esci',
  startMatch: 'Inizia Partita',
  startTournament: 'Inizia Torneo',
  statusActive: '● In Corso',
  statusComplete: '✓ Completato',
  superuser: 'superutente',
  tapBallAbove: 'Tocca la palla foulata sopra',
  tournamentStatus: 'Stato del Torneo',
  user: 'utente',
  username: 'Nome utente',
  viewDetails2: 'Vedi tabellone e risultati',
  vsLabel: 'VS',
  wins: 'vince',
  roundFinal: 'Finale',
  roundSemiFinals: 'Semifinali',
  roundQuarterFinals: 'Quarti di finale',
  roundOf16: 'Ottavi di finale',
  roundOf: 'Turno di',
  owner: 'Proprietario',
  timePlayed: 'giocato',
  matchesPlayed: 'giocati',
  noPlayersRegistered: 'Nessun giocatore registrato ancora',
  startTypingPlayers: 'Inizia a digitare per vedere i giocatori dei tornei precedenti',
  startTournamentConfirm: 'Iniziare il torneo? Il tabellone sarà generato automaticamente.',
  splashFeaturesHeading: 'Tutto ciò che serve per organizzare uno shootout',
  splashFooterTagline: 'Shootout Comps — Gestione tornei',
  splashUpAndRunning: 'Operativo in pochi minuti',
  splashStep2Title: 'Registra i tuoi giocatori',
  splashStep2Desc: 'Aggiungi fino a 32 giocatori con foto',
  splashStep3Title: 'Inizia il torneo',
  splashStep3Desc: 'Il tabellone viene generato automaticamente',
  splashStep4Title: 'Gestisci le partite in diretta',
  splashStep4Desc: "Segna ogni colpo, tieni d'occhio il tempo, vedi i risultati",
  splashReadyTitle: 'Pronto per il tuo torneo?',
  splashGetStarted: '🏆 Inizia gratuitamente',
  splashGetStartedPaid: '🏆 Crea account',
  splashPricingAllFree: 'Tutti i tornei sono gratuiti — nessun pagamento richiesto.',
  splashPricingPaidOnly: 'I tornei costano {price} ciascuno.',
  splashPricingOneFree: 'Il primo torneo è gratuito, poi {price} ciascuno.',
  splashPricingNFree: 'I primi {n} tornei sono gratuiti, poi {price} ciascuno.',
  privacyPolicy: 'Informativa sulla privacy',
  resend: 'Rinvia',
  resending: 'Invio…',
  newLinkSent: '✓ Nuovo link inviato — controlla la tua casella',
  didntGetIt: 'Non ricevuto? Reinvia email',
  sendResetCode: 'Invia codice di reimpostazione',
  verifyCode: 'Verifica codice',
  verifying: 'Verifica…',
  resendCode: 'Rinvia codice',
  handicapStart: '🏅 Inizio con handicap',
  noPlayersFound: 'Nessun giocatore trovato nei tuoi tornei.',
  noPlayersMatching: 'Nessun giocatore corrispondente a',
  navContact: 'Contatto',
  navPublic: 'Pubblico',
  navFaq: 'Aiuto e FAQ',
  navLeagues: 'Campionati',
  faqSubtitle: 'Tutto quello che devi sapere per organizzare un torneo Shootout, Snooker 900 o Standard.',
  faqSearch: 'Cerca domande…',
  faqNoResults: 'Nessuna domanda corrisponde alla tua ricerca.',
  faqContact: 'Hai ancora una domanda?',
  faqContactLink: 'Contattaci dalla pagina dei contatti',
  paymentsEnabled: 'Pagamenti ATTIVATI',
  paymentsDisabled: 'Pagamenti DISATTIVATI',
  statusLabel: 'Stato',
  fromLabel: 'Da',
  freeForLife: '♾ Gratis',
  createAccount: '🏆 Crea account',
  splashSignIn: 'Accedi',
  splashSignUp: 'Registrati',
  dontHaveAccount: 'Non hai un account?',
  createFreeAccount: 'Crea account gratuito',
  signInNow: '🏆 Accedi ora',
  orContinueWith: 'oppure continua con',
  continueWithGoogle: 'Continua con Google',
  continueWithFacebook: 'Continua con Facebook',
  oauthErrorTitle: 'Accesso non riuscito',
  oauthErrorGeneric: "Qualcosa è andato storto durante l'accesso. Riprova.",
  oauthErrorEmailNotVerified: 'Quell\'account non ha un indirizzo email verificato, quindi non possiamo accedere con esso.',
  oauthErrorAccountSuspended: 'Questo account è stato sospeso.',
  oauthErrorDenied: "Hai annullato l'accesso.",
  oauthErrorProviderDisabled: 'L\'accesso con questo provider è attualmente disattivato.',
  noPasswordSetError: 'Questo account accede con Google o Facebook: usa invece uno di quei pulsanti.',
  navPlayersAdmin: '⚙ Giocatori',
  allPlayersDesc: 'Tutti i giocatori di tutti i tornei creati. Clicca sulla foto per aggiornarla; gli handicap sono modificabili.',
  pwStrengthWeak: 'Debole',
  pwStrengthFair: 'Sufficiente',
  pwStrengthGood: 'Buona',
  pwStrengthStrong: 'Forte',
  pauseShotClock: 'Pausa',
  resumeShotClock: 'Riprendi',
  newTournamentTitle: '🏆 Nuovo Torneo',
  editTournamentTitle: '✎ Modifica Torneo',
  locationLabel: '📍 Luogo / Sede',
  locationPlaceholder: 'es. The Crown, Roma',
  locationHint: 'Facoltativo — mostrato sulla scheda del torneo.',
  entryFeeLabel: '💰 Quota di iscrizione',
  entryFeeHint: "Lascia vuoto se non c'è quota.",
  prizePlacesLabel: '🏆 Posizioni premiate',
  prizePlacesNone: 'Nessuna',
  prizePlacesHint: 'Seleziona quante posizioni ricevono un premio.',
  prizePoolLabel: 'Montepremi totale',
  matchFormatLabel: '🔴 Formato partita',
  shootoutDesc: 'Shootout: 10 min · {r} rosse · 15s colpi (5 min) · 10s (5 min)',
  snooker900Desc: 'Snooker 900: 15 min · {r} rosse · 20s colpi',
  sixRedsLabel: '🔴 Sei Rosse — solo 6 rosse invece di 15',
  sixRedsDesc: 'Sei Rosse',
  standardFormatHint: 'Snooker standard: senza limite di tempo · regole complete · {r} rosse',
  bestOfDialogTitle: 'Frame per turno',
  bestOfDialogDesc: 'Scegli quanti frame sono necessari per vincere ogni turno (solo numeri dispari, così c\'è sempre un vincitore).',
  bestOfContinueBtn: 'Continua',
  bestOfBackBtn: 'Indietro',
  handicapHint: "Se attivato, inserire l'handicap di ogni giocatore. Il più debole riceve il vantaggio della differenza.",
  makePublicLabel: 'Torneo Pubblico',
  makePublicHint: 'Qualsiasi utente collegato potrà vedere il tabellone e seguire le partite dal vivo.',
  cancelBtn: 'Annulla',
  timedTournamentTitle: 'Torneo a Tempo',
  timedTournamentDesc: 'Shootout o Snooker 900 · orologio tiro',
  standardTournamentTitle: 'Torneo Standard',
  standardTournamentDesc: 'Regole standard · senza limite di tempo · sei rosse opzionale',
  chooseTournamentType: 'Scegli il tipo di torneo da creare.',
  completedTournamentsAppearHere: 'I tornei completati appaiono qui.',
  maxEntriesLabel: 'Max {n} partecipanti',
  prizePlaceSingle: 'posizione premiata',
  prizePlacePlural: 'posizioni premiate',
  prizePoolPrefix: 'Montepremi',
  entryLabel: 'Iscrizione',
  handicapTournament: 'Torneo handicap',
  scratchTournament: 'Torneo scratch',
  highBreakPrizeDisplay: 'Premio massimo break',
  noDateVenueWarning: 'Nessuna data, sede, quota o premi impostati. Modifica il torneo per un manifesto più ricco.',
  additionalTextLabel: 'Testo aggiuntivo (opzionale)',
  additionalTextPlaceholder: 'es. Tutti benvenuti! Contatta Giovanni: 07700 900000.',
  additionalTextHint: 'Stampato in fondo al manifesto.',
  downloadPdfPoster: '⬇ Scarica poster PDF',
  generatingPoster: '⏳ Generazione…',
  paymentGateTitle: 'Nuovo Torneo',
  paymentGateDesc: 'Hai utilizzato il tuo torneo gratuito. È richiesto un pagamento unico di {amount}.',
  editBtn: '✎ Modifica',
  posterBtn: '🖨 Manifesto',
  sharedBadge: 'Condiviso',
  publicBadge: 'Pubblico',
  privateBadge: 'Privato',
  togglePublicHint: 'Clicca per passare da pubblico a privato',
  adminsBtn: 'Admin',
  adminsDesc: "Gli admin hanno pieno accesso per segnare e gestire questo torneo, tranne eliminarlo o gestire questo elenco.",
  usernamePlaceholder: 'Nome utente…',
  addBtn: 'Aggiungi',
  removeBtn: 'Rimuovi',
  noAdminsYet: 'Nessun admin aggiunto finora.',
  statusRegistrationLabel: 'Iscrizioni',
  statusActiveLabel: 'In corso',
  statusCompleteLabel: 'Completato',
  freeForLifeGranted: '♾ Gratis ✓',
  emailAddress: 'Email',
  bracketWinner: 'Vincitore',
  bracketChampionTitle: 'Campione',
  bracketSavingLabel: 'Salvataggio…',
  bracketSaveResult: 'Salva risultato',
  bracketEntries: 'partecipanti',
  bracketEntry: 'partecipante',
  bracketPrizePool: 'montepremi',
  bracketHighBreak: 'massimo break',
  bracketSixReds: 'Sei Rosse',
  bracketHandicap: 'Handicap',
  bracketShootoutLabel: 'Shootout',
  bracketSnooker900Label: 'Snooker 900',
  bracketStandardLabel: 'Standard',
  bracketPlace: 'posto',
  bracketPlaces: 'posti',
  statsPlayersLabel: 'Giocatori',
  statsHighBreakLabel: 'Massimo Break',
  statsDateLabel: 'Data',
  statsVenueLabel: 'Sede',
  spectatorView: 'Modalità spettatore — un altro dispositivo sta registrando questo match',
  resetLinkInvalidTitle: 'Link non valido',
  resetLinkExpiredMsg: 'Questo link di reimpostazione è scaduto.',
  resetLinkInvalidMsg: 'Questo link non è valido o è già stato utilizzato.',
  emailUpdatedTitle: 'Email aggiornata',
  emailChangeLinkInvalidTitle: 'Link non valido',
  emailAlreadyTaken: 'Quell\'indirizzo email è già associato a un altro account.',
  emailChangeLinkInvalidMsg: 'Questo link di cambio email non è valido o è già stato utilizzato.',
  accountSuspendedTitle: 'Account sospeso',
  accountSuspendedMsg: 'Il tuo account è stato sospeso.',
  editMatchResult: 'Modifica risultato partita',
  adminOnlineNow: 'Online ora (5 min)',
  adminTotalAccounts: 'Totale account',
  adminAwaitingVerification: 'In attesa di verifica',
  adminNewThisWeek: 'Nuovi questa settimana',
  adminNewThisMonth: 'Nuovi questo mese',
  adminMatchesInProgress: 'Partite in corso',
  adminInProgress: 'In corso',
  adminUniquePlayerEntries: 'Iscrizioni uniche di giocatori',
  adminTotalEver: 'Totale storico',
  adminLoadingStats: 'Caricamento statistiche…',
  settingsSavePrices: 'Salva prezzi',
  settingsCurrentState: 'Stato attuale:',
  settingsTimedLabel: 'A tempo',
  settingsStandardLabel: 'Standard',
  settingsPerUserOverrides: 'Eccezioni per utente',
  usersAccountStates: 'Stati account:',
  usersActiveState: 'Attivo',
  usersPendingState: 'In attesa',
  usersSuspendedState: 'Sospeso',
  usersDeactivatedState: 'Disattivato',
  loadingLabel: 'Caricamento…',
  leaguesEmptyDesc: 'Organizza una competizione a squadre lunga una stagione — divisioni, incontri e classifica. Crea il tuo primo campionato per iniziare.',
  createLeagueBtn: '+ Crea campionato',
  leagueNamePlaceholder: 'Nome del campionato',
  divisionTabTeams: '👥 Squadre',
  divisionTabFixtures: '📅 Incontri',
  divisionTabStandings: '🏆 Classifica',
  standingsTeamCol: 'Squadra',
  noTeamsInDivision: 'Nessuna squadra ancora in questa divisione.',
  fixtureStatusScheduled: 'Programmato',
  fixtureStatusLineupSet: 'Formazione definita',
  fixtureStatusInProgress: 'In corso',
  backToFixture: "← Torna all'incontro",
  publicLeaguesTitle: '🌐 Campionati Pubblici',
  publicLeaguesDesc: 'Sfoglia e segui i campionati che altri organizzatori hanno reso pubblici.',
  noPublicLeaguesYet: 'Nessun campionato pubblico ancora.',
  backToPublicLeagues: '← Campionati Pubblici',
  noFixturesYetLabel: 'Nessun incontro ancora.',
  noTeamsYetLabel: 'Nessuna squadra ancora.',
  backToAllSeasons: '← Tutte le stagioni',
  noPastSeasonsYet: 'Nessuna stagione passata ancora.',
  noPastSeasonsYetOwner: 'Nessuna stagione passata ancora — appariranno qui dopo il primo "Termina Stagione" di questa divisione.',
  endedLabel: 'Terminata',
  promotedLabel: 'promosse',
  relegatedLabel: 'retrocesse',
  finalStandingsLabel: 'Classifica finale',
  fixturesLabel: 'Incontri',
  historyTabLabel: '📜 Cronologia',
  doubleRoundRobinLabel: 'Andata e ritorno (doppio round-robin)',
  pendingClaimApprovalLabel: '⏳ approvazione in sospeso',
  approveBtn: 'Approva',
  rejectBtn: 'Rifiuta',
  tierFieldLabel: 'Livello (1 = divisione superiore)',
  promotionSpotsFieldLabel: 'Posti promozione (predefinito)',
  relegationSpotsFieldLabel: 'Posti retrocessione (predefinito)',
  seasonManagementHint: 'Gestione stagione: il livello di questa divisione (1 = superiore) e il numero predefinito di posti promozione/retrocessione precompilato per la prossima anteprima di fine stagione. Può essere modificato ogni stagione.',
  togglePublicTooltip: 'Attiva/disattiva se qualsiasi utente autenticato può sfogliare e seguire questo campionato',
  toggleClaimApprovalTooltip: 'Attiva/disattiva se le autorivendicazioni della rosa richiedono l\'approvazione del proprietario/admin',
  publicChipLabel: '🌐 Pubblico',
  privateChipLabel: '🔒 Privato',
  claimsApprovalChipLabel: '🛂 Rivendicazioni: Approvazione',
  claimsInstantChipLabel: '⚡ Rivendicazioni: Istantanee',
  endSeasonBtn: '🏁 Termina Stagione',
  browsePublicLeaguesLink: '🌐 Sfoglia Campionati Pubblici',
  myStatsTitle: 'Le Mie Statistiche',
  statsPlayedLabel: 'Giocati',
  statsWonLabel: 'Vinti',
  statsLostLabel: 'Persi',
  seasonLabelFieldLabel: 'Nome stagione',
  seasonLabelPlaceholder: 'es. 2025/26',
  seasonCountsHint: 'Posti promozione/retrocessione per questa stagione — precompilati con i valori predefiniti di ogni divisione, modificabili solo per questa volta.',
  tierLabel: 'livello',
  previewBtn: 'Anteprima →',
  reviewMovesHint: 'Rivedi i movimenti proposti qui sotto — deseleziona qualsiasi squadra che vuoi lasciare nella sua divisione attuale. Gli incontri di tutte le divisioni verranno comunque archiviati e azzerati.',
  noMovesThisSeason: 'Nessun movimento di promozione/retrocessione questa stagione.',
  confirmEndSeasonBtn: 'Conferma e Termina Stagione',
};

const ja: Translations = {
  langName: '日本語',
  appName: 'Shootout Comps',
  signIn: 'サインイン',
  signingIn: 'サインイン中…',
  navBracket: 'トーナメント',
  statusRegistration: '登録受付中',
  players: '選手',
  removePlayer: '削除',
  slotsRemaining: '枠残り',
  noPlayersYet: '選手が登録されていません',
  awaitingDraw: '抽選待ち',
  champion: 'チャンピオン',
  clickToPlay: '→ クリックして試合',
  matchComplete: '試合終了',
  notStarted: '未開始',
  startMatchDesc: '準備ができたら？ 10分間のマッチクロックが始まります。',
  shotClockDesc: 'ショットクロック：最初の5分は15秒・残り5分は10秒',
  atTheTable: 'テーブルで',
  nextLegalPot: '次の合法ショット：',
  miss: 'ミス',
  cancelFoul: 'キャンセル',
  noContact: '無接触',
  undo: '元に戻す',
  cueBallPotted: '手玉ポット',
  endMatchEarly: '試合を早期終了',
  finishMatchBtn: '試合を終了',
  finishFrameBtn: 'フレームを終了',
  enterFinalScore: '最終スコアを入力:',
  scoresInvalid: '異なる2つのスコアを入力してください',
  shotHistory: 'ショット履歴',
  firstHalf: '前半 — 15秒/ショット',
  backToBracket: '← トーナメントに戻る',
  shotClockExpired: 'ショットクロック時間切れ',
  matchClockExpired: 'マッチクロック時間切れ',
  dismiss: '閉じる',
  foulToOpponent: 'ファウル — 相手に+{n}',
  noPotnPlayerChanged: '↩ ポットなし — 選手交代',
  cannotUndo: '元に戻せません',
  adminDashboard: '管理ダッシュボード',
  registrationOpen: '登録受付中',
  tournamentName: 'トーナメント名',
  newTournament: '🆕 新しいトーナメント',
  newTournamentDesc: '新しいトーナメントを開始すると現在のものがアーカイブされます。',
  startNewTournament: '新しいトーナメント',
  tournamentHistory: 'トーナメント履歴',
  noHistoryDesc: '完了したトーナメントはここに表示されます。',
  viewDetails: '→ 詳細を見る',
  participants: '参加者',
  userManagement: 'ユーザー管理',
  you: 'あなた',
  resetPasswordBtn: '🔑 PW リセット',
  passwordMinLength: 'パスワードは8文字以上が必要です',
  userIsolationNote: '各ユーザーは自分のトーナメントのみ閲覧できます。',
  voiceHalfTime: '10秒ショットクロックが有効になりました',
  language: '言語',
  profile: 'My Profile',
  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  passwordChanged: 'Password changed successfully.',
  forgotPassword: 'Forgot password?',
  sendResetLink: 'Send Reset Link',
  resetLinkSent: 'Reset link sent — check your email.',
  resetPassword: 'Reset Password',
  resetPasswordDesc: "Enter your email and we'll send a reset link.",
  setNewPassword: 'Set New Password',
  accountDetails: 'Account Details',
  memberSince: 'Member since',
  tournamentsTitle: 'トーナメント',
  newTournament2: '+ 新しいトーナメント',
  currentTournament: '現在のトーナメント',
  pastTournaments: '過去のトーナメント',
  publicTournamentsHeading: '公開トーナメント',
  publicTournamentsSubtitle: '他のユーザーが公開したトーナメントです。ログイン済みのユーザーなら誰でも組み合わせを見たり、試合をライブで観戦できます。',
  noPublicTournaments: '現在、公開トーナメントはありません。',
  hostedByLabel: '主催者',
  watchLiveBtn: 'ライブ観戦',
  backToPublicList: '公開トーナメントに戻る',
  spectatingBadge: '👀 観戦中',
  noHistoryYet: 'No past tournaments yet.',
  noHistoryYetDesc: 'Completed tournaments appear here.',
  createTournament: 'Create Tournament',
  nextBtn: '次へ',
  backBtn: '戻る',
  editTournament: 'Edit Tournament',
  tournamentNameLabel: 'Tournament Name',
  dateTimeLabel: 'Date & Time',
  dateTimeHint: 'Shown on the tournaments list',
  maxPlayersLabel: 'Maximum Players',
  maxPlayersHint: 'Empty slots filled with BYEs',
  handicapLabel: 'Handicap Tournament',
  handicapOnDesc: 'Handicap ON',
  handicapOffDesc: 'Handicap OFF',
  pauseClocks: 'Pause Clocks',
  resumeClocks: 'Resume Clocks',
  saveChanges: 'Save Changes',
  confirmCreateTitle: 'Start New Tournament?',
  confirmCreateMsg: 'Current tournament will be archived.',
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  registrationLabel: 'Registration',
  activeLabel: 'In Progress',
  completeLabel: 'Complete',
  maxLabel: 'Max',
  handicapBadge: 'Handicap',
  playerManagement: 'Player Management',
  playerManagementDesc: 'Click photo to change',
  deletePlayerTitle: 'Delete Player',
  deletePlayerMsg: 'This player will be removed.',
  changePhoto: 'Photo',
  deletePlayer: 'Delete',
  newPhotoSelected: 'New photo selected',
  handicapEditHint: 'Handicap',
  handicapValue: 'ハンディキャップ',
  clickToEditHandicap: 'クリックしてハンディキャップを編集',
  playerCountAll: '全トーナメントで{n}人のプレイヤー',
  playerCountMatch: '「{q}」に一致する{n}人のプレイヤー',
  clickToChangePhoto: 'Click to change photo',
  photoFromPrevious: 'Photo from previous tournament',
  handicapStartTitle: 'Handicap Start',
  handicapStartDesc: 'Points advantage applied',
  debugJumpBtn: 'Debug: Jump to 5:30',
  pointsAdvantageApplied: 'Points advantage applied',
  handicapPts: 'ポイント — 高いほど弱い選手 = より多くのポイントスタート',
  passwordWeak: '弱い',
  passwordFair: '普通',
  passwordGood: '良い',
  passwordStrong: '強い',
  passwordsNoMatch: 'パスワードが一致しません',
  repeatPassword: 'パスワードを繰り返す',
  creatingAccount: 'アカウント作成中…',
  minChars: '最低8文字',
  usernameHint: '文字、数字、スペース、アンダースコア、ハイフンが使用可能',
  deactivateAccount: 'アカウント無効化',
  newPasswordMin: '新しいパスワード (最低8文字)',
  suspensionReason: '停止理由 (任意)',
  confirmSuspend: '停止を確認',
  passwordUpdated: 'パスワード更新済み ✓',
  addNewUser: 'ユーザー追加',
  addPlayer: '選手追加',
  allUsers: '全ユーザー',
  awaitingDrawDesc: '選手を登録してトーナメントを開始してください。',
  ballOffTable: 'ボールオフテーブル',
  byesAdded: '{n} BYEを追加',
  cancel: 'キャンセル',
  complete: '完了',
  connecting: '接続中…',
  createUser: '+ 追加',
  creating: '作成中…',
  declareWinner: '勝者を宣言:',
  deleteUser: '削除',
  dir: 'ltr',
  elapsed: '経過',
  endMatchToDeclare: '試合終了で勝者を宣言',
  foul: 'ファウル',
  inProgress: '進行中',
  inProgressStatus: 'トーナメント進行中',
  joined: '参加',
  splashTagline: 'スヌーカートーナメントをプロのように運営しましょう。',
  splashSubtitle: 'ライブスコア、ショットクロック、選手プロフィール、完全な試合履歴 — シュートアウトまたはスヌーカー900ルール。初回トーナメント無料。',
  splashSubtitleAllFree: 'ライブスコア、ショットクロック、選手プロフィール、完全な試合履歴。すべてのトーナメントが無料。',
  splashSubtitlePaid: 'ライブスコア、ショットクロック、選手プロフィール、完全な試合履歴。',
  splashSubtitleNFree: 'ライブスコア、ショットクロック、選手プロフィール、完全な試合履歴。最初の{n}回のトーナメントが無料。',
  splashNoCreditCard: 'クレジットカード不要 · 初回トーナメント無料',
  splashNoCreditCardAllFree: 'クレジットカード不要 · すべて無料',
  splashNoCreditCardPaid: 'クレジットカード不要',
  splashNoCreditCardNFree: 'クレジットカード不要 · 最初の{n}回無料',
  splashStep1Title: 'アカウント作成',
  splashStep1Desc: 'メールで登録。初回トーナメント無料。',
  splashStep1DescAllFree: 'メールで登録。すべてのトーナメントが無料。',
  splashStep1DescPaid: 'メールで登録。',
  splashStep1DescNFree: 'メールで登録。最初の{n}回のトーナメントが無料。',
  whoBreaks: '誰がブレイク？',
  whoBreaksDesc: 'ブレイクを行う選手を選択してください。確認するとマッチクロックが開始します。',
  breakOffBtn: 'ブレイクオフ',
  breaksOff: 'ブレイク',
  selectPlayerFirst: '先に選手を選択してください',
  matchClockStartsOnBreak: 'ブレイクオフの確認でマッチクロックが開始します。',
  foulCueBallInHand: 'ファウル — キューボールインハンド',
  pointsAwardedToOpponent: 'ポイントが対戦相手に付与されました。',
  toPlayFromHand: 'がハンドから打ちます。',
  clocksPausedMsg: '両方のクロックが一時停止中です。',
  resumeMatch: '▶ 試合再開',
  freeBallLabel: 'フリーボール',
  freeBallSnookeredMsg: 'は全てのボールに対してスヌーカーされています。次のショットでは任意のボールを指定でき、本来狙うべきボールとして得点されます。',
  freeBallActiveBanner: '🔴 フリーボール — このショットは任意のボールを狙えます',
  respotBlackBanner: '🎱 黒ボール再スポット — フレームが同点です。コイントスの勝者は?',
  higherValueFoul: '高得点ファウル',
  selectHighestBallTouched: '触れた最も高い得点の球を選択',
  highestBreakLabel: '最高ブレイク',
  highBreakPrizeLabel: '🔴 最高ブレイク賞',
  highBreakPrizeHint: '最高ブレイクの選手への任意の賞金。ポスターに表示されます。',
  contactTitle: 'お問い合わせ',
  contactSubtitle: 'ご質問はありますか？メッセージをお送りください。',
  contactSubjectLabel: '件名',
  contactMessageLabel: 'メッセージ',
  contactSendBtn: '✉ メッセージを送る',
  contactSentTitle: 'メッセージ送信済み',
  contactSentDesc: 'ご連絡ありがとうございます。できるだけ早く返信いたします。',
  contactSendAnother: '別のメッセージを送る',
  contactAimToRespond: '1〜2営業日以内に返答いたします。',
  changeEmailTitle: 'メールアドレス変更',
  changeEmailNewLabel: '新しいメールアドレス',
  changeEmailSendBtn: '確認メールを送る',
  sendPasswordResetLink: 'パスワードリセットリンクを送信:',
  backToSignIn: '← サインインに戻る',
  viewDraw: '組み合わせを見る →',
  loadingTournament: 'トーナメント読み込み中…',
  loadingMatch: '試合読み込み中…',
  tournamentNotFound: 'トーナメントが見つかりません',
  matchNotFound: '試合が見つかりません',
  backToHistory: '← 履歴に戻る',
  backToDraw: '← 組み合わせに戻る',
  backToUsers: '← ユーザーに戻る',
  deleteTournamentTitle: 'トーナメント削除',
  deleteTournamentConfirm: 'このトーナメントとすべての試合データが完全に削除されます。',
  tournamentsHeading: 'トーナメント',
  loadingTournaments: 'トーナメント読み込み中…',
  noTournamentsYet: 'このユーザーはまだトーナメントを作成していません。',
  viewThisUsersTournaments: 'このユーザーのトーナメントを表示',
  grantFreeForLife: '永久無料トーナメントを付与',
  revokeFreeForLife: '無料トーナメントを取り消す',
    langFlag: '🇯🇵',
  lastShotUndone: '↩ 最後のショットを元に戻した',
  live: 'LIVE',
  losesTheFrame: 'フレームを失う',
  matchesDone: '試合完了',
  navAdmin: '管理',
  navHistory: 'トーナメント',
  navPlayers: '選手追加',
  navUsers: 'ユーザー',
  noHistory: '過去のトーナメントなし。',
  noPot: 'ポットなし',
  nothingToUndo: '元に戻すものなし',
  password: 'パスワード',
  playerName: '選手名…',
  plusToOpponent: '相手に+{n}',
  potBall: 'ボールをポット',
  potted: '{ball}ポット (+{n})',
  redsRemaining: '赤残り',
  registered: '登録済み',
  remaining: '残り',
  rounds: 'ラウンド',
  save: '保存',
  saving: '保存中…',
  secondHalf: '後半',

  selectFoulBall: 'ファウルしたボールを選択:',
  selectFoulType: 'ファウルの種類',
  shotClock: 'ショットクロック',
  shotsCount: 'ショット数',
  shotsPlayed: 'ショット数',
  signOut: 'サインアウト',
  startMatch: '試合開始',
  startTournament: 'トーナメント開始',
  statusActive: '● 進行中',
  statusComplete: '✓ 完了',
  superuser: 'スーパーユーザー',
  tapBallAbove: '上のファウルしたボールをタップ',
  tournamentStatus: 'トーナメントステータス',
  user: 'ユーザー',
  username: 'ユーザー名',
  viewDetails2: 'ブラケットと結果を見る',
  vsLabel: 'VS',
  wins: 'の勝利',
  roundFinal: '決勝',
  roundSemiFinals: '準決勝',
  roundQuarterFinals: '準々決勝',
  roundOf16: '16強',
  roundOf: 'ラウンド',
  owner: 'オーナー',
  timePlayed: '経過',
  matchesPlayed: '試合済',
  noPlayersRegistered: 'まだ選手が登録されていません',
  startTypingPlayers: '入力して過去のトーナメントの選手を表示',
  startTournamentConfirm: 'トーナメントを開始しますか？組み合わせが自動生成されます。',
  splashFeaturesHeading: 'シュートアウト運営に必要なすべて',
  splashFooterTagline: 'Shootout Comps — トーナメント管理',
  splashUpAndRunning: '数分で稼働開始',
  splashStep2Title: '選手を登録する',
  splashStep2Desc: '最大32名の選手を写真付きで追加',
  splashStep3Title: 'トーナメントを開始する',
  splashStep3Desc: '組み合わせが自動生成されます',
  splashStep4Title: '試合をライブ管理する',
  splashStep4Desc: 'すべてのショットをスコア、時計を追跡、結果を確認',
  splashReadyTitle: 'トーナメントの準備はできましたか？',
  splashGetStarted: '🏆 無料で始める',
  splashGetStartedPaid: '🏆 アカウント作成',
  splashPricingAllFree: 'すべてのトーナメントは無料です。',
  splashPricingPaidOnly: 'トーナメントは1回{price}です。',
  splashPricingOneFree: '最初のトーナメントは無料、以降{price}です。',
  splashPricingNFree: '最初の{n}回は無料、以降{price}です。',
  privacyPolicy: 'プライバシーポリシー',
  resend: '再送',
  resending: '送信中…',
  newLinkSent: '✓ 新しいリンクを送信しました — メールをご確認ください',
  didntGetIt: '届きませんでしたか？メールを再送する',
  sendResetCode: 'リセットコードを送る',
  verifyCode: 'コードを確認',
  verifying: '確認中…',
  resendCode: 'コードを再送',
  handicapStart: '🏅 ハンデスタート',
  noPlayersFound: 'トーナメントで選手が見つかりません。',
  noPlayersMatching: '一致する選手なし：',
  navContact: 'お問い合わせ',
  navPublic: '公開',
  navFaq: 'ヘルプとFAQ',
  navLeagues: 'リーグ',
  faqSubtitle: 'シュートアウト、スヌーカー900、またはスタンダードトーナメントの運営に必要な情報をまとめています。',
  faqSearch: '質問を検索…',
  faqNoResults: '検索に一致する質問がありません。',
  faqContact: 'まだ質問がありますか？',
  faqContactLink: 'お問い合わせページからご連絡ください',
  paymentsEnabled: '支払い有効',
  paymentsDisabled: '支払い無効',
  statusLabel: 'ステータス',
  fromLabel: '送信者',
  freeForLife: '♾ 無料',
  freeForLifeGranted: '♾ 無料 ✓',
  createAccount: '🏆 アカウント作成',
  splashSignIn: 'サインイン',
  splashSignUp: 'サインアップ',
  dontHaveAccount: 'アカウントをお持ちでないですか？',
  createFreeAccount: '無料アカウントを作成',
  signInNow: '🏆 今すぐサインイン',
  orContinueWith: 'または次で続ける',
  continueWithGoogle: 'Googleで続ける',
  continueWithFacebook: 'Facebookで続ける',
  oauthErrorTitle: 'サインインに失敗しました',
  oauthErrorGeneric: 'サインイン中に問題が発生しました。もう一度お試しください。',
  oauthErrorEmailNotVerified: 'このアカウントには確認済みのメールアドレスがないため、サインインできません。',
  oauthErrorAccountSuspended: 'このアカウントは停止されています。',
  oauthErrorDenied: 'サインインをキャンセルしました。',
  oauthErrorProviderDisabled: 'このプロバイダーでのサインインは現在無効になっています。',
  noPasswordSetError: 'このアカウントはGoogleまたはFacebookでサインインします。代わりにそちらのボタンをご利用ください。',
  navPlayersAdmin: '⚙ プレーヤー',
  allPlayersDesc: '作成したすべてのトーナメントのすべてのプレーヤー。写真をクリックして更新できます。ハンディキャップも編集可能です。',
  pwStrengthWeak: '弱い',
  pwStrengthFair: '普通',
  pwStrengthGood: '良い',
  pwStrengthStrong: '強い',
  pauseShotClock: '一時停止',
  resumeShotClock: '再開',
  newTournamentTitle: '🏆 新しいトーナメント',
  editTournamentTitle: '✎ トーナメントを編集',
  locationLabel: '📍 場所 / 会場',
  locationPlaceholder: '例：ザ・クラウン、東京',
  locationHint: 'オプション — トーナメントカードに表示されます。',
  entryFeeLabel: '💰 参加費',
  entryFeeHint: '参加費がない場合は空白のままにしてください。',
  prizePlacesLabel: '🏆 賞金獲得順位',
  prizePlacesNone: 'なし',
  prizePlacesHint: '賞金を受け取る順位数を選択してください。',
  prizePoolLabel: '総賞金',
  matchFormatLabel: '🔴 試合形式',
  shootoutDesc: 'シュートアウト：10分 · {r}レッド · 前半15秒 · 後半10秒',
  snooker900Desc: 'スヌーカー900：15分 · {r}レッド · 20秒',
  sixRedsLabel: '🔴 シックスレッド — 15球ではなく6球のみ使用',
  sixRedsDesc: 'シックスレッド',
  standardFormatHint: 'スタンダードスヌーカー：時間制限なし · 正式ルール · {r}レッド',
  bestOfDialogTitle: 'ラウンドごとのフレーム数',
  bestOfDialogDesc: '各ラウンドの勝利に必要なフレーム数を選択してください（必ず勝者が決まるよう奇数のみ）。',
  bestOfContinueBtn: '続ける',
  bestOfBackBtn: '戻る',
  handicapHint: '有効にすると、登録時に各プレーヤーのハンディキャップを入力します。',
  makePublicLabel: '公開トーナメント',
  makePublicHint: 'ログイン済みのユーザーなら誰でも組み合わせを見たり、試合をライブで観戦できるようになります。',
  cancelBtn: 'キャンセル',
  timedTournamentTitle: 'タイムドトーナメント',
  timedTournamentDesc: 'シュートアウトまたはスヌーカー900 · ショットクロックあり',
  standardTournamentTitle: 'スタンダードトーナメント',
  standardTournamentDesc: '標準ルール · 時間制限なし · シックスレッドオプション',
  chooseTournamentType: '作成するトーナメントの種類を選択してください。',
  completedTournamentsAppearHere: '完了したトーナメントがここに表示されます。',
  maxEntriesLabel: '最大{n}名',
  prizePlaceSingle: '賞金順位',
  prizePlacePlural: '賞金順位',
  prizePoolPrefix: '賞金総額',
  entryLabel: '参加費',
  handicapTournament: 'ハンディキャップトーナメント',
  scratchTournament: 'スクラッチトーナメント',
  highBreakPrizeDisplay: '最高ブレイク賞',
  noDateVenueWarning: '日付・会場・参加費・賞金が未設定です。より充実したポスターのためにトーナメントを編集してください。',
  additionalTextLabel: '追加テキスト（任意）',
  additionalTextPlaceholder: '例：どなたでも歓迎！参加申込は山田まで：07700 900000',
  additionalTextHint: 'ポスターの下部に印刷されます。',
  downloadPdfPoster: '⬇ PDFポスターをダウンロード',
  generatingPoster: '⏳ 生成中…',
  paymentGateTitle: '新しいトーナメント',
  paymentGateDesc: '無料トーナメントを使用しました。{amount}の一回払いが必要です。',
  editBtn: '✎ 編集',
  posterBtn: '🖨 ポスター',
  sharedBadge: '共有',
  publicBadge: '公開',
  privateBadge: '非公開',
  togglePublicHint: 'クリックして公開・非公開を切り替え',
  adminsBtn: '管理者',
  adminsDesc: '管理者はこのトーナメントの採点・管理に完全にアクセスできます(削除やこのリストの管理を除く)。',
  usernamePlaceholder: 'ユーザー名…',
  addBtn: '追加',
  removeBtn: '削除',
  noAdminsYet: 'まだ管理者が追加されていません。',
  statusRegistrationLabel: '登録中',
  statusActiveLabel: '進行中',
  statusCompleteLabel: '完了',
  emailAddress: 'Email',
  bracketWinner: '勝者',
  bracketChampionTitle: 'チャンピオン',
  bracketSavingLabel: '保存中…',
  bracketSaveResult: '結果を保存',
  bracketEntries: '参加者',
  bracketEntry: '参加者',
  bracketPrizePool: '賞金総額',
  bracketHighBreak: '最高ブレイク',
  bracketSixReds: 'シックスレッズ',
  bracketHandicap: 'ハンディキャップ',
  bracketShootoutLabel: 'シュートアウト',
  bracketSnooker900Label: 'スヌーカー900',
  bracketStandardLabel: 'スタンダード',
  bracketPlace: '位',
  bracketPlaces: '位まで',
  statsPlayersLabel: '参加者',
  statsHighBreakLabel: '最高ブレイク',
  statsDateLabel: '日付',
  statsVenueLabel: '会場',
  spectatorView: '観戦モード — 別のデバイスでスコアリング中',
  resetLinkInvalidTitle: 'リンク無効',
  resetLinkExpiredMsg: 'このリセットリンクは期限切れです。',
  resetLinkInvalidMsg: 'このリンクは無効または使用済みです。',
  emailUpdatedTitle: 'メール更新済み',
  emailChangeLinkInvalidTitle: 'リンク無効',
  emailAlreadyTaken: 'このメールアドレスは既に他のアカウントで使用されています。',
  emailChangeLinkInvalidMsg: 'このメール変更リンクは無効または使用済みです。',
  accountSuspendedTitle: 'アカウント停止',
  accountSuspendedMsg: 'アカウントが停止されました。',
  editMatchResult: '試合結果を編集',
  adminOnlineNow: '現在オンライン（5分）',
  adminTotalAccounts: '総アカウント数',
  adminAwaitingVerification: '確認待ち',
  adminNewThisWeek: '今週の新規',
  adminNewThisMonth: '今月の新規',
  adminMatchesInProgress: '進行中の試合',
  adminInProgress: '進行中',
  adminUniquePlayerEntries: 'ユニークプレイヤー数',
  adminTotalEver: '総計',
  adminLoadingStats: '統計を読み込み中…',
  settingsSavePrices: '価格を保存',
  settingsCurrentState: '現在の状態:',
  settingsTimedLabel: '時間制',
  settingsStandardLabel: 'スタンダード',
  settingsPerUserOverrides: 'ユーザー別設定',
  usersAccountStates: 'アカウント状態:',
  usersActiveState: 'アクティブ',
  usersPendingState: '保留中',
  usersSuspendedState: '停止',
  usersDeactivatedState: '無効',
  loadingLabel: '読み込み中…',
  leaguesEmptyDesc: 'シーズンを通して行うチーム制の大会を運営できます — ディビジョン、対戦カード、順位表。最初のリーグを作成して始めましょう。',
  createLeagueBtn: '+ リーグを作成',
  leagueNamePlaceholder: 'リーグ名',
  divisionTabTeams: '👥 チーム',
  divisionTabFixtures: '📅 対戦カード',
  divisionTabStandings: '🏆 順位表',
  standingsTeamCol: 'チーム',
  noTeamsInDivision: 'このディビジョンにはまだチームがありません。',
  fixtureStatusScheduled: '予定',
  fixtureStatusLineupSet: 'ラインナップ設定済み',
  fixtureStatusInProgress: '進行中',
  backToFixture: '← 対戦カードに戻る',
  publicLeaguesTitle: '🌐 公開リーグ',
  publicLeaguesDesc: '他の主催者が公開したリーグを閲覧・観戦できます。',
  noPublicLeaguesYet: 'まだ公開リーグはありません。',
  backToPublicLeagues: '← 公開リーグ',
  noFixturesYetLabel: 'まだ対戦カードはありません。',
  noTeamsYetLabel: 'まだチームはありません。',
  backToAllSeasons: '← すべてのシーズン',
  noPastSeasonsYet: 'まだ過去のシーズンはありません。',
  noPastSeasonsYetOwner: 'まだ過去のシーズンはありません — このディビジョンで最初に「シーズン終了」を行うとここに表示されます。',
  endedLabel: '終了',
  promotedLabel: '昇格',
  relegatedLabel: '降格',
  finalStandingsLabel: '最終順位表',
  fixturesLabel: '対戦カード',
  historyTabLabel: '📜 履歴',
  doubleRoundRobinLabel: 'ホーム&アウェイ（ダブルラウンドロビン）',
  pendingClaimApprovalLabel: '⏳ 承認待ち',
  approveBtn: '承認',
  rejectBtn: '却下',
  tierFieldLabel: '階層（1 = 最上位ディビジョン）',
  promotionSpotsFieldLabel: '昇格枠（デフォルト）',
  relegationSpotsFieldLabel: '降格枠（デフォルト）',
  seasonManagementHint: 'シーズン管理：このディビジョンの階層（1 = 最上位）と、次回のシーズン終了プレビューに初期値として設定される昇格/降格枠のデフォルト数。シーズンごとに上書き可能です。',
  togglePublicTooltip: 'ログイン済みの誰でもこのリーグを閲覧・観戦できるかどうかを切り替えます',
  toggleClaimApprovalTooltip: 'ロースターの自己申請にオーナー/管理者の承認が必要かどうかを切り替えます',
  publicChipLabel: '🌐 公開',
  privateChipLabel: '🔒 非公開',
  claimsApprovalChipLabel: '🛂 申請：承認制',
  claimsInstantChipLabel: '⚡ 申請：即時',
  endSeasonBtn: '🏁 シーズン終了',
  browsePublicLeaguesLink: '🌐 公開リーグを閲覧',
  myStatsTitle: '自分の成績',
  statsPlayedLabel: '対戦数',
  statsWonLabel: '勝利',
  statsLostLabel: '敗北',
  seasonLabelFieldLabel: 'シーズン名',
  seasonLabelPlaceholder: '例：2025/26',
  seasonCountsHint: '今シーズンの昇格/降格枠 — 各ディビジョンのデフォルト値が初期設定されますが、今回のみ編集できます。',
  tierLabel: '階層',
  previewBtn: 'プレビュー →',
  reviewMovesHint: '以下の提案された移動内容を確認してください — 現在のディビジョンに残したいチームはチェックを外してください。いずれにせよ、すべてのディビジョンの対戦カードはアーカイブされリセットされます。',
  noMovesThisSeason: '今シーズンは昇格/降格の移動はありません。',
  confirmEndSeasonBtn: '確認してシーズンを終了',
};

const zh: Translations = {
  langName: '中文',
  appName: 'Shootout Comps',
  signIn: '登录',
  signingIn: '登录中…',
  navBracket: '赛程',
  statusRegistration: '报名开放',
  players: '选手',
  removePlayer: '移除',
  slotsRemaining: '名额剩余',
  noPlayersYet: '暂无已注册选手',
  awaitingDraw: '等待抽签',
  champion: '冠军',
  clickToPlay: '→ 点击比赛',
  matchComplete: '比赛完成',
  notStarted: '未开始',
  startMatchDesc: '准备好了吗？将开始10分钟比赛时钟。',
  shotClockDesc: '击球时钟：前5分钟15秒·后5分钟10秒',
  atTheTable: '在台桌旁',
  nextLegalPot: '下一个合法进球：',
  miss: '未进',
  cancelFoul: '取消',
  noContact: '无接触',
  undo: '撤销',
  cueBallPotted: '母球进袋',
  endMatchEarly: '提前结束比赛',
  finishMatchBtn: '结束比赛',
  finishFrameBtn: '结束本局',
  enterFinalScore: '输入最终比分:',
  scoresInvalid: '请输入两个不同的比分',
  shotHistory: '击球记录',
  firstHalf: '上半场 — 15秒/击',
  backToBracket: '← 返回赛程',
  shotClockExpired: '击球时钟到时',
  matchClockExpired: '比赛时钟到时',
  dismiss: '关闭',
  foulToOpponent: '犯规 — 对手+{n}',
  noPotnPlayerChanged: '↩ 未进球 — 换人',
  cannotUndo: '无法撤销',
  adminDashboard: '管理控制台',
  registrationOpen: '报名开放',
  tournamentName: '锦标赛名称',
  newTournament: '🆕 新锦标赛',
  newTournamentDesc: '开始新锦标赛将归档当前锦标赛。',
  startNewTournament: '开始新锦标赛',
  tournamentHistory: '锦标赛历史',
  noHistoryDesc: '完成的锦标赛将显示在此处。',
  viewDetails: '→ 查看详情',
  participants: '参与者',
  userManagement: '用户管理',
  you: '你',
  resetPasswordBtn: '🔑 重置密码',
  passwordMinLength: '密码至少需要8个字符',
  userIsolationNote: '每个用户只能查看和管理自己的锦标赛。',
  voiceHalfTime: '10秒击球时钟现已启用',
  language: '语言',
  profile: 'My Profile',
  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  passwordChanged: 'Password changed successfully.',
  forgotPassword: 'Forgot password?',
  sendResetLink: 'Send Reset Link',
  resetLinkSent: 'Reset link sent — check your email.',
  resetPassword: 'Reset Password',
  resetPasswordDesc: "Enter your email and we'll send a reset link.",
  setNewPassword: 'Set New Password',
  accountDetails: 'Account Details',
  memberSince: 'Member since',
  tournamentsTitle: '比赛',
  newTournament2: '+ 新建比赛',
  currentTournament: '当前比赛',
  pastTournaments: '历史比赛',
  publicTournamentsHeading: '公开赛事',
  publicTournamentsSubtitle: '其他用户公开的赛事——任何已登录用户都可以查看对阵表并实时观看比赛。',
  noPublicTournaments: '目前没有公开赛事。',
  hostedByLabel: '主办方',
  watchLiveBtn: '观看直播',
  backToPublicList: '返回公开赛事',
  spectatingBadge: '👀 观战中',
  noHistoryYet: 'No past tournaments yet.',
  noHistoryYetDesc: 'Completed tournaments appear here.',
  createTournament: 'Create Tournament',
  nextBtn: '下一步',
  backBtn: '返回',
  editTournament: 'Edit Tournament',
  tournamentNameLabel: 'Tournament Name',
  dateTimeLabel: 'Date & Time',
  dateTimeHint: 'Shown on the tournaments list',
  maxPlayersLabel: 'Maximum Players',
  maxPlayersHint: 'Empty slots filled with BYEs',
  handicapLabel: 'Handicap Tournament',
  handicapOnDesc: 'Handicap ON',
  handicapOffDesc: 'Handicap OFF',
  pauseClocks: 'Pause Clocks',
  resumeClocks: 'Resume Clocks',
  saveChanges: 'Save Changes',
  confirmCreateTitle: 'Start New Tournament?',
  confirmCreateMsg: 'Current tournament will be archived.',
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  registrationLabel: 'Registration',
  activeLabel: 'In Progress',
  completeLabel: 'Complete',
  maxLabel: 'Max',
  handicapBadge: 'Handicap',
  playerManagement: 'Player Management',
  playerManagementDesc: 'Click photo to change',
  deletePlayerTitle: 'Delete Player',
  deletePlayerMsg: 'This player will be removed.',
  changePhoto: 'Photo',
  deletePlayer: 'Delete',
  newPhotoSelected: 'New photo selected',
  handicapEditHint: 'Handicap',
  handicapValue: '让分',
  clickToEditHandicap: '点击编辑让分',
  playerCountAll: '所有赛事共{n}名球员',
  playerCountMatch: '匹配"{q}"的{n}名球员',
  clickToChangePhoto: 'Click to change photo',
  photoFromPrevious: 'Photo from previous tournament',
  handicapStartTitle: 'Handicap Start',
  handicapStartDesc: 'Points advantage applied',
  debugJumpBtn: 'Debug: Jump to 5:30',
  pointsAdvantageApplied: 'Points advantage applied',
  handicapPts: '分 — 越高越弱 = 更多积分起步',
  passwordWeak: '弱',
  passwordFair: '一般',
  passwordGood: '好',
  passwordStrong: '强',
  passwordsNoMatch: '密码不匹配',
  repeatPassword: '重复密码',
  creatingAccount: '正在创建账户…',
  minChars: '最少8个字符',
  usernameHint: '可包含字母、数字、空格、下划线和连字符',
  deactivateAccount: '停用账户',
  newPasswordMin: '新密码 (最少8位)',
  suspensionReason: '暂停原因（可选）',
  confirmSuspend: '确认暂停',
  passwordUpdated: '密码已更新 ✓',
  addNewUser: '添加用户',
  addPlayer: '添加选手',
  allUsers: '所有用户',
  awaitingDrawDesc: '注册选手后开始比赛以生成对阵表。',
  ballOffTable: '球出界',
  byesAdded: '已添加{n}个BYE',
  cancel: '取消',
  complete: '完成',
  connecting: '连接中…',
  createUser: '+ 添加',
  creating: '创建中…',
  declareWinner: '宣布胜者：',
  deleteUser: '删除',
  dir: 'ltr',
  elapsed: '已用时',
  endMatchToDeclare: '结束比赛以宣布胜者',
  foul: '犯规',
  inProgress: '进行中',
  inProgressStatus: '比赛进行中',
  joined: '加入',
  splashTagline: '像专业人士一样组织您的斯诺克射击赛。',
  splashSubtitle: '实时计分、击球时钟、球员档案和完整比赛历史 — 支持射击赛或斯诺克900规则。首个锦标赛免费。',
  splashSubtitleAllFree: '实时计分、击球时钟、球员档案和完整比赛历史。所有锦标赛免费。',
  splashSubtitlePaid: '实时计分、击球时钟、球员档案和完整比赛历史。',
  splashSubtitleNFree: '实时计分、击球时钟、球员档案和完整比赛历史。前{n}个锦标赛免费。',
  splashNoCreditCard: '无需信用卡 · 首个锦标赛免费',
  splashNoCreditCardAllFree: '无需信用卡 · 所有锦标赛免费',
  splashNoCreditCardPaid: '无需信用卡',
  splashNoCreditCardNFree: '无需信用卡 · 前{n}个锦标赛免费',
  splashStep1Title: '创建账户',
  splashStep1Desc: '用电子邮件注册。首个锦标赛免费。',
  splashStep1DescAllFree: '用电子邮件注册。所有锦标赛免费。',
  splashStep1DescPaid: '用电子邮件注册。',
  splashStep1DescNFree: '用电子邮件注册。前{n}个锦标赛免费。',
  whoBreaks: '谁来开球？',
  whoBreaksDesc: '选择将要开球的球员。确认后比赛时钟开始计时。',
  breakOffBtn: '开球',
  breaksOff: '开球',
  selectPlayerFirst: '请先选择一位球员',
  matchClockStartsOnBreak: '确认开球后比赛时钟开始。',
  foulCueBallInHand: '犯规 — 主球在手',
  pointsAwardedToOpponent: '分奖励给对手。',
  toPlayFromHand: '持球上手。',
  clocksPausedMsg: '两个时钟均已暂停。',
  resumeMatch: '▶ 继续比赛',
  freeBallLabel: '自由球',
  freeBallSnookeredMsg: '被斯诺克，无法直接击打任何一颗应打球。下一杆可指定任意一颗球代替，得分按应打球计算。',
  freeBallActiveBanner: '🔴 自由球 — 本杆可指定任意球',
  respotBlackBanner: '🎱 黑球重新置球 — 比分持平，掷币决定谁先击球？',
  higherValueFoul: '高分犯规',
  selectHighestBallTouched: '选择触碰的最高分球',
  highestBreakLabel: '最高连击',
  highBreakPrizeLabel: '🔴 最高连击奖',
  highBreakPrizeHint: '可选的最高连击奖励。将显示在海报上。',
  contactTitle: '联系我们',
  contactSubtitle: '有问题吗？发送消息给我们。',
  contactSubjectLabel: '主题',
  contactMessageLabel: '消息',
  contactSendBtn: '✉ 发送消息',
  contactSentTitle: '消息已发送',
  contactSentDesc: '感谢联系！我们将尽快回复您。',
  contactSendAnother: '发送另一条消息',
  contactAimToRespond: '我们将在1–2个工作日内回复。',
  changeEmailTitle: '更改电子邮件',
  changeEmailNewLabel: '新电子邮件地址',
  changeEmailSendBtn: '发送验证邮件',
  sendPasswordResetLink: '发送密码重置链接至',
  backToSignIn: '← 返回登录',
  viewDraw: '查看对阵 →',
  loadingTournament: '正在加载锦标赛…',
  loadingMatch: '正在加载比赛…',
  tournamentNotFound: '未找到锦标赛',
  matchNotFound: '未找到比赛',
  backToHistory: '← 返回历史',
  backToDraw: '← 返回对阵',
  backToUsers: '← 返回用户',
  deleteTournamentTitle: '删除锦标赛',
  deleteTournamentConfirm: '这将永久删除锦标赛及其所有比赛数据。',
  tournamentsHeading: '锦标赛',
  loadingTournaments: '正在加载锦标赛…',
  noTournamentsYet: '该用户尚未创建任何锦标赛。',
  viewThisUsersTournaments: '查看此用户的锦标赛',
  grantFreeForLife: '授予终身免费锦标赛',
  revokeFreeForLife: '撤销免费锦标赛',
    langFlag: '🇨🇳',
  lastShotUndone: '↩ 最后一杆已撤销',
  live: '直播',
  losesTheFrame: '输掉局',
  matchesDone: '已完成场次',
  navAdmin: '管理',
  navHistory: '比赛',
  navPlayers: '添加球员',
  navUsers: '用户',
  noHistory: '暂无历史比赛。',
  noPot: '未入袋',
  nothingToUndo: '没有可撤销的操作',
  password: '密码',
  playerName: '选手姓名…',
  plusToOpponent: '+{n}给对手',
  potBall: '入袋',
  potted: '{ball}入袋 (+{n})',
  redsRemaining: '剩余红球',
  registered: '已注册',
  remaining: '剩余',
  rounds: '轮次',
  save: '保存',
  saving: '保存中…',
  secondHalf: '下半场',

  selectFoulBall: '选择犯规球：',
  selectFoulType: '犯规类型',
  shotClock: '击球计时',
  shotsCount: '击球数',
  shotsPlayed: '击球次数',
  signOut: '退出',
  startMatch: '开始比赛',
  startTournament: '开始比赛',
  statusActive: '● 进行中',
  statusComplete: '✓ 完成',
  superuser: '超级用户',
  tapBallAbove: '点击上方犯规球',
  tournamentStatus: '比赛状态',
  user: '用户',
  username: '用户名',
  viewDetails2: '查看对阵表和结果',
  vsLabel: 'VS',
  wins: '获胜',
  roundFinal: '决赛',
  roundSemiFinals: '半决赛',
  roundQuarterFinals: '四分之一决赛',
  roundOf16: '16强赛',
  roundOf: '轮次',
  owner: '创建者',
  timePlayed: '已完成',
  matchesPlayed: '已完成',
  noPlayersRegistered: '尚未注册球员',
  startTypingPlayers: '开始输入以查看往届锦标赛球员',
  startTournamentConfirm: '开始锦标赛？对阵表将自动生成。',
  splashFeaturesHeading: '举办 Shootout 赛事所需的一切',
  splashFooterTagline: 'Shootout Comps — 赛事管理',
  splashUpAndRunning: '几分钟内即可运行',
  splashStep2Title: '注册球员',
  splashStep2Desc: '最多可添加32名带照片的球员',
  splashStep3Title: '开始锦标赛',
  splashStep3Desc: '对阵表自动生成',
  splashStep4Title: '实时管理比赛',
  splashStep4Desc: '记录每一杆，跟踪时钟，查看结果',
  splashReadyTitle: '准备好开始了吗？',
  splashGetStarted: '🏆 免费开始',
  splashGetStartedPaid: '🏆 创建账户',
  splashPricingAllFree: '所有赛事均免费，无需付款。',
  splashPricingPaidOnly: '每场赛事费用为{price}。',
  splashPricingOneFree: '首场赛事免费，之后每场{price}。',
  splashPricingNFree: '前{n}场赛事免费，之后每场{price}。',
  privacyPolicy: '隐私政策',
  resend: '重新发送',
  resending: '发送中…',
  newLinkSent: '✓ 新链接已发送 — 请查看收件箱',
  didntGetIt: '没收到？重新发送邮件',
  sendResetCode: '发送重置码',
  verifyCode: '验证码',
  verifying: '验证中…',
  resendCode: '重新发送验证码',
  handicapStart: '🏅 让分开局',
  noPlayersFound: '您的锦标赛中未找到球员。',
  noPlayersMatching: '没有匹配的球员：',
  navContact: '联系我们',
  navPublic: '公开',
  navFaq: '帮助与常见问题',
  navLeagues: '联赛',
  faqSubtitle: '关于举办射击赛、斯诺克900赛事或标准赛事所需了解的一切。',
  faqSearch: '搜索问题…',
  faqNoResults: '没有问题与您的搜索匹配。',
  faqContact: '还有问题？',
  faqContactLink: '通过联系页面与我们联系',
  paymentsEnabled: '支付已启用',
  paymentsDisabled: '支付已禁用',
  statusLabel: '状态',
  fromLabel: '发件人',
  freeForLife: '♾ 免费',
  freeForLifeGranted: '♾ 免费 ✓',
  createAccount: '🏆 创建账户',
  splashSignIn: '登录',
  splashSignUp: '注册',
  dontHaveAccount: '还没有账户？',
  createFreeAccount: '免费创建账户',
  signInNow: '🏆 立即登录',
  orContinueWith: '或使用以下方式继续',
  continueWithGoogle: '使用 Google 继续',
  continueWithFacebook: '使用 Facebook 继续',
  oauthErrorTitle: '登录失败',
  oauthErrorGeneric: '登录时出错，请重试。',
  oauthErrorEmailNotVerified: '该账户没有已验证的电子邮件地址，因此我们无法用它登录。',
  oauthErrorAccountSuspended: '该账户已被暂停。',
  oauthErrorDenied: '您已取消登录。',
  oauthErrorProviderDisabled: '目前已停用此登录方式。',
  noPasswordSetError: '此账户使用 Google 或 Facebook 登录 —— 请改用其中一个按钮。',
  navPlayersAdmin: '⚙ 球员',
  allPlayersDesc: '您创建的所有比赛中的所有球员。点击照片可更新；残差可编辑。',
  pwStrengthWeak: '弱',
  pwStrengthFair: '一般',
  pwStrengthGood: '良好',
  pwStrengthStrong: '强',
  pauseShotClock: '暂停',
  resumeShotClock: '继续',
  newTournamentTitle: '🏆 新建比赛',
  editTournamentTitle: '✎ 编辑比赛',
  locationLabel: '📍 地点 / 场馆',
  locationPlaceholder: '例：皇冠酒吧，北京',
  locationHint: '可选 — 显示在赛事卡片上。',
  entryFeeLabel: '💰 报名费',
  entryFeeHint: '如无报名费请留空。',
  prizePlacesLabel: '🏆 奖励名次',
  prizePlacesNone: '无',
  prizePlacesHint: '选择获得奖励的名次数量。',
  prizePoolLabel: '奖金总额',
  matchFormatLabel: '🔴 比赛格式',
  shootoutDesc: '淘汰赛：10分钟 · {r}颗红球 · 前5分钟15秒 · 后5分钟10秒',
  snooker900Desc: '斯诺克900：15分钟 · {r}颗红球 · 20秒',
  sixRedsLabel: '🔴 六红球 — 只使用6颗红球而非15颗',
  sixRedsDesc: '六红球',
  standardFormatHint: '标准斯诺克：无时间限制 · 完整规则 · {r}颗红球',
  bestOfDialogTitle: '每轮局数',
  bestOfDialogDesc: '选择每轮获胜所需的局数（仅限奇数，以确保总有一方获胜）。',
  bestOfContinueBtn: '继续',
  bestOfBackBtn: '返回',
  handicapHint: '启用后，在注册时输入每位选手的让分。较弱的选手获得差值的优势。',
  makePublicLabel: '公开赛事',
  makePublicHint: '任何已登录用户都可以查看对阵表并实时观看比赛。',
  cancelBtn: '取消',
  timedTournamentTitle: '计时赛',
  timedTournamentDesc: '淘汰赛或斯诺克900 · 击球时钟',
  standardTournamentTitle: '标准赛',
  standardTournamentDesc: '标准规则 · 无时间限制 · 可选六红球',
  chooseTournamentType: '选择要创建的比赛类型。',
  completedTournamentsAppearHere: '已完成的比赛显示在这里。',
  maxEntriesLabel: '最多{n}人',
  prizePlaceSingle: '个奖励名次',
  prizePlacePlural: '个奖励名次',
  prizePoolPrefix: '奖池',
  entryLabel: '报名费',
  handicapTournament: '让分比赛',
  scratchTournament: '公平比赛',
  highBreakPrizeDisplay: '最高单杆奖',
  noDateVenueWarning: '未设置日期、场馆、报名费或奖励。请先编辑比赛以获得更丰富的海报。',
  additionalTextLabel: '附加文字（可选）',
  additionalTextPlaceholder: '例：欢迎所有人！联系张三：07700 900000',
  additionalTextHint: '打印在海报底部。',
  downloadPdfPoster: '⬇ 下载PDF海报',
  generatingPoster: '⏳ 生成中…',
  paymentGateTitle: '新建比赛',
  paymentGateDesc: '您已使用免费比赛名额。创建另一个比赛需要{amount}的一次性付款。',
  editBtn: '✎ 编辑',
  posterBtn: '🖨 海报',
  sharedBadge: '共享',
  publicBadge: '公开',
  privateBadge: '私密',
  togglePublicHint: '点击切换公开/私密状态',
  adminsBtn: '管理员',
  adminsDesc: '管理员拥有对本次锦标赛计分和管理的完全权限,但不能删除锦标赛或管理此列表。',
  usernamePlaceholder: '用户名…',
  addBtn: '添加',
  removeBtn: '移除',
  noAdminsYet: '尚未添加管理员。',
  statusRegistrationLabel: '报名中',
  statusActiveLabel: '进行中',
  statusCompleteLabel: '已完成',
  emailAddress: 'Email',
  bracketWinner: '胜者',
  bracketChampionTitle: '冠军',
  bracketSavingLabel: '保存中…',
  bracketSaveResult: '保存结果',
  bracketEntries: '参赛者',
  bracketEntry: '参赛者',
  bracketPrizePool: '奖金池',
  bracketHighBreak: '最高单杆',
  bracketSixReds: '六红球',
  bracketHandicap: '让分',
  bracketShootoutLabel: '淘汰赛',
  bracketSnooker900Label: '斯诺克900',
  bracketStandardLabel: '标准',
  bracketPlace: '名',
  bracketPlaces: '名',
  statsPlayersLabel: '参赛者',
  statsHighBreakLabel: '最高单杆',
  statsDateLabel: '日期',
  statsVenueLabel: '场馆',
  spectatorView: '观众模式 — 另一设备正在记分',
  resetLinkInvalidTitle: '链接无效',
  resetLinkExpiredMsg: '此重置链接已过期。',
  resetLinkInvalidMsg: '此链接无效或已被使用。',
  emailUpdatedTitle: '邮箱已更新',
  emailChangeLinkInvalidTitle: '链接无效',
  emailAlreadyTaken: '该邮箱地址已被其他账户使用。',
  emailChangeLinkInvalidMsg: '此邮箱更改链接无效或已被使用。',
  accountSuspendedTitle: '账户已暂停',
  accountSuspendedMsg: '您的账户已被暂停。',
  editMatchResult: '编辑比赛结果',
  adminOnlineNow: '当前在线（5分钟）',
  adminTotalAccounts: '总账户数',
  adminAwaitingVerification: '等待验证',
  adminNewThisWeek: '本周新增',
  adminNewThisMonth: '本月新增',
  adminMatchesInProgress: '进行中的比赛',
  adminInProgress: '进行中',
  adminUniquePlayerEntries: '独立玩家数',
  adminTotalEver: '历史总计',
  adminLoadingStats: '加载统计中…',
  settingsSavePrices: '保存价格',
  settingsCurrentState: '当前状态:',
  settingsTimedLabel: '计时制',
  settingsStandardLabel: '标准',
  settingsPerUserOverrides: '用户单独设置',
  usersAccountStates: '账户状态:',
  usersActiveState: '活跃',
  usersPendingState: '待定',
  usersSuspendedState: '已暂停',
  usersDeactivatedState: '已停用',
  loadingLabel: '加载中…',
  leaguesEmptyDesc: '组织一个持续整个赛季的团体赛事——设有分组、赛程和积分榜。创建您的第一个联赛开始使用。',
  createLeagueBtn: '+ 创建联赛',
  leagueNamePlaceholder: '联赛名称',
  divisionTabTeams: '👥 队伍',
  divisionTabFixtures: '📅 赛程',
  divisionTabStandings: '🏆 积分榜',
  standingsTeamCol: '队伍',
  noTeamsInDivision: '该分组暂无队伍。',
  fixtureStatusScheduled: '已排期',
  fixtureStatusLineupSet: '阵容已设定',
  fixtureStatusInProgress: '进行中',
  backToFixture: '← 返回赛事',
  publicLeaguesTitle: '🌐 公开联赛',
  publicLeaguesDesc: '浏览并观看其他组织者公开的联赛。',
  noPublicLeaguesYet: '暂无公开联赛。',
  backToPublicLeagues: '← 公开联赛',
  noFixturesYetLabel: '暂无赛程。',
  noTeamsYetLabel: '暂无队伍。',
  backToAllSeasons: '← 所有赛季',
  noPastSeasonsYet: '暂无往季记录。',
  noPastSeasonsYetOwner: '暂无往季记录 — 该分组首次"结束赛季"后将显示在此处。',
  endedLabel: '已结束',
  promotedLabel: '升级',
  relegatedLabel: '降级',
  finalStandingsLabel: '最终积分榜',
  fixturesLabel: '赛程',
  historyTabLabel: '📜 历史',
  doubleRoundRobinLabel: '主客场（双循环赛）',
  pendingClaimApprovalLabel: '⏳ 待审批',
  approveBtn: '批准',
  rejectBtn: '拒绝',
  tierFieldLabel: '等级（1 = 最高分组）',
  promotionSpotsFieldLabel: '升级名额（默认）',
  relegationSpotsFieldLabel: '降级名额（默认）',
  seasonManagementHint: '赛季管理：该分组的等级（1 = 最高）以及预填入下次赛季结束预览的默认升降级名额。每个赛季均可覆盖。',
  togglePublicTooltip: '切换是否允许任何已登录用户浏览并观看此联赛',
  toggleClaimApprovalTooltip: '切换名单自助认领是否需要拥有者/管理员批准',
  publicChipLabel: '🌐 公开',
  privateChipLabel: '🔒 私密',
  claimsApprovalChipLabel: '🛂 认领：需审批',
  claimsInstantChipLabel: '⚡ 认领：即时',
  endSeasonBtn: '🏁 结束赛季',
  browsePublicLeaguesLink: '🌐 浏览公开联赛',
  myStatsTitle: '我的数据',
  statsPlayedLabel: '已赛',
  statsWonLabel: '胜',
  statsLostLabel: '负',
  seasonLabelFieldLabel: '赛季名称',
  seasonLabelPlaceholder: '例如 2025/26',
  seasonCountsHint: '本赛季的升降级名额 — 预填入各分组的默认值，仅本次可编辑。',
  tierLabel: '等级',
  previewBtn: '预览 →',
  reviewMovesHint: '请查看下方提议的调整 — 取消勾选任何想留在当前分组的队伍。无论如何，所有分组的赛程都将被归档并重置。',
  noMovesThisSeason: '本赛季没有升降级调整。',
  confirmEndSeasonBtn: '确认并结束赛季',
};

const ar: Translations = {
  langName: 'العربية',
  appName: 'Shootout Comps',
  signIn: 'تسجيل الدخول',
  signingIn: 'جارٍ تسجيل الدخول…',
  navBracket: 'البطولة',
  statusRegistration: 'التسجيل مفتوح',
  players: 'اللاعبون',
  removePlayer: 'إزالة',
  slotsRemaining: 'مقاعد متبقية',
  noPlayersYet: 'لم يتم تسجيل لاعبين بعد',
  awaitingDraw: 'انتظار القرعة',
  champion: 'البطل',
  clickToPlay: '← انقر للعب',
  matchComplete: 'انتهت المباراة',
  notStarted: 'لم تبدأ',
  startMatchDesc: 'هل أنت مستعد؟ سيبدأ ساعة المباراة لمدة 10 دقائق.',
  shotClockDesc: 'ساعة الضربة: 15 ثانية في أول 5 دقائق · 10 ثوانٍ في آخر 5 دقائق',
  atTheTable: 'على الطاولة',
  nextLegalPot: 'الضربة القانونية التالية:',
  miss: 'فاتت',
  cancelFoul: 'إلغاء',
  noContact: 'بدون تلامس',
  undo: 'تراجع',
  cueBallPotted: 'الكرة البيضاء صُوِّبت',
  endMatchEarly: 'إنهاء المباراة مبكرًا',
  finishMatchBtn: 'إنهاء المباراة',
  finishFrameBtn: 'إنهاء الشوط',
  enterFinalScore: 'أدخل النتيجة النهائية:',
  scoresInvalid: 'أدخل نتيجتين مختلفتين',
  shotHistory: 'سجل الضربات',
  firstHalf: 'الشوط الأول — 15 ث/ضربة',
  backToBracket: '→ العودة للبطولة',
  shotClockExpired: 'انتهت ساعة الضربة',
  matchClockExpired: 'انتهى وقت المباراة',
  dismiss: 'إغلاق',
  foulToOpponent: 'مخالفة — +{n} للمنافس',
  noPotnPlayerChanged: '↩ لا تصويب — تغيير اللاعب',
  cannotUndo: 'لا يمكن التراجع',
  adminDashboard: 'لوحة الإدارة',
  registrationOpen: 'التسجيل مفتوح',
  tournamentName: 'اسم البطولة',
  newTournament: '🆕 بطولة جديدة',
  newTournamentDesc: 'بدء بطولة جديدة سيؤرشف البطولة الحالية.',
  startNewTournament: 'بطولة جديدة',
  tournamentHistory: 'تاريخ البطولات',
  noHistoryDesc: 'ستظهر البطولات المكتملة هنا.',
  viewDetails: '← عرض التفاصيل',
  participants: 'المشاركون',
  userManagement: 'إدارة المستخدمين',
  you: 'أنت',
  resetPasswordBtn: '🔑 إعادة تعيين',
  passwordMinLength: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
  userIsolationNote: 'يمكن لكل مستخدم رؤية بطولاته الخاصة فقط.',
  voiceHalfTime: 'ساعة ضربة 10 ثوانٍ باتت سارية الآن',
  language: 'اللغة',
  profile: 'My Profile',
  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  passwordChanged: 'Password changed successfully.',
  forgotPassword: 'Forgot password?',
  sendResetLink: 'Send Reset Link',
  resetLinkSent: 'Reset link sent — check your email.',
  resetPassword: 'Reset Password',
  resetPasswordDesc: "Enter your email and we'll send a reset link.",
  setNewPassword: 'Set New Password',
  accountDetails: 'Account Details',
  memberSince: 'Member since',
  tournamentsTitle: 'البطولات',
  newTournament2: '+ بطولة جديدة',
  currentTournament: 'البطولة الحالية',
  pastTournaments: 'البطولات السابقة',
  publicTournamentsHeading: 'البطولات العامة',
  publicTournamentsSubtitle: 'بطولات جعلها مستخدمون آخرون عامة — يمكن لأي مستخدم مسجل الدخول مشاهدة القرعة ومتابعة المباريات مباشرة.',
  noPublicTournaments: 'لا توجد بطولات عامة حاليًا.',
  hostedByLabel: 'استضافها',
  watchLiveBtn: 'مشاهدة مباشرة',
  backToPublicList: 'العودة إلى البطولات العامة',
  spectatingBadge: '👀 مشاهدة',
  noHistoryYet: 'No past tournaments yet.',
  noHistoryYetDesc: 'Completed tournaments appear here.',
  createTournament: 'Create Tournament',
  nextBtn: 'التالي',
  backBtn: 'رجوع',
  editTournament: 'Edit Tournament',
  tournamentNameLabel: 'Tournament Name',
  dateTimeLabel: 'Date & Time',
  dateTimeHint: 'Shown on the tournaments list',
  maxPlayersLabel: 'Maximum Players',
  maxPlayersHint: 'Empty slots filled with BYEs',
  handicapLabel: 'Handicap Tournament',
  handicapOnDesc: 'Handicap ON',
  handicapOffDesc: 'Handicap OFF',
  pauseClocks: 'Pause Clocks',
  resumeClocks: 'Resume Clocks',
  saveChanges: 'Save Changes',
  confirmCreateTitle: 'Start New Tournament?',
  confirmCreateMsg: 'Current tournament will be archived.',
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  registrationLabel: 'Registration',
  activeLabel: 'In Progress',
  completeLabel: 'Complete',
  maxLabel: 'Max',
  handicapBadge: 'Handicap',
  playerManagement: 'Player Management',
  playerManagementDesc: 'Click photo to change',
  deletePlayerTitle: 'Delete Player',
  deletePlayerMsg: 'This player will be removed.',
  changePhoto: 'Photo',
  deletePlayer: 'Delete',
  newPhotoSelected: 'New photo selected',
  handicapEditHint: 'Handicap',
  handicapValue: 'هانديكاب',
  clickToEditHandicap: 'انقر لتعديل الهانديكاب',
  playerCountAll: '{n} لاعب في جميع البطولات',
  playerCountMatch: '{n} لاعب مطابق لـ "{q}"',
  clickToChangePhoto: 'Click to change photo',
  photoFromPrevious: 'Photo from previous tournament',
  handicapStartTitle: 'Handicap Start',
  handicapStartDesc: 'Points advantage applied',
  debugJumpBtn: 'Debug: Jump to 5:30',
  pointsAdvantageApplied: 'Points advantage applied',
  handicapPts: 'نقطة — أعلى = لاعب أضعف = بداية بنقاط أكثر',
  passwordWeak: 'ضعيف',
  passwordFair: 'معقول',
  passwordGood: 'جيد',
  passwordStrong: 'قوي',
  passwordsNoMatch: 'كلمتا المرور غير متطابقتين',
  repeatPassword: 'أعد إدخال كلمة المرور',
  creatingAccount: 'جارٍ إنشاء الحساب…',
  minChars: '8 أحرف على الأقل',
  usernameHint: 'أحرف وأرقام ومسافات وشرطات سفلية وشرطات',
  deactivateAccount: 'إلغاء تفعيل الحساب',
  newPasswordMin: 'كلمة مرور جديدة (8 على الأقل)',
  suspensionReason: 'سبب الإيقاف (اختياري)',
  confirmSuspend: 'تأكيد الإيقاف',
  passwordUpdated: 'تم تحديث كلمة المرور ✓',
  addNewUser: 'إضافة مستخدم',
  addPlayer: 'إضافة لاعب',
  allUsers: 'جميع المستخدمين',
  awaitingDrawDesc: 'سجّل اللاعبين ثم ابدأ البطولة.',
  ballOffTable: 'الكرة خارج الطاولة',
  byesAdded: 'تمت إضافة {n} BYE',
  cancel: 'إلغاء',
  complete: 'مكتمل',
  connecting: 'جارٍ الاتصال…',
  createUser: '+ إضافة',
  creating: 'جارٍ الإنشاء…',
  declareWinner: 'إعلان الفائز:',
  deleteUser: 'حذف',
  dir: 'rtl',
  elapsed: 'منقضي',
  endMatchToDeclare: 'أنهِ المباراة لإعلان الفائز',
  foul: 'خطأ',
  inProgress: 'جارٍ',
  inProgressStatus: 'البطولة جارية',
  joined: 'انضم',
  splashTagline: 'أدِر بطولتك في السنوكر باحترافية.',
  splashSubtitle: 'تسجيل نقاط مباشر، ساعة اللقطة، ملفات اللاعبين وسجل كامل للمباريات. أول بطولة مجانية.',
  splashSubtitleAllFree: 'تسجيل نقاط مباشر، ساعة اللقطة، ملفات اللاعبين وسجل كامل للمباريات. جميع البطولات مجانية.',
  splashSubtitlePaid: 'تسجيل نقاط مباشر، ساعة اللقطة، ملفات اللاعبين وسجل كامل للمباريات.',
  splashSubtitleNFree: 'تسجيل نقاط مباشر، ساعة اللقطة، ملفات اللاعبين وسجل كامل للمباريات. أول {n} بطولات مجانية.',
  splashNoCreditCard: 'لا حاجة لبطاقة ائتمان · أول بطولة مجانية',
  splashNoCreditCardAllFree: 'لا حاجة لبطاقة ائتمان · جميع البطولات مجانية',
  splashNoCreditCardPaid: 'لا حاجة لبطاقة ائتمان',
  splashNoCreditCardNFree: 'لا حاجة لبطاقة ائتمان · أول {n} بطولات مجانية',
  splashStep1Title: 'إنشاء حسابك',
  splashStep1Desc: 'سجّل بالبريد الإلكتروني. أول بطولة مجانية.',
  splashStep1DescAllFree: 'سجّل بالبريد الإلكتروني. جميع البطولات مجانية.',
  splashStep1DescPaid: 'سجّل بالبريد الإلكتروني.',
  splashStep1DescNFree: 'سجّل بالبريد الإلكتروني. أول {n} بطولات مجانية.',
  whoBreaks: 'من يفتتح؟',
  whoBreaksDesc: 'اختر اللاعب الذي سيفتتح. ستبدأ ساعة المباراة عند التأكيد.',
  breakOffBtn: 'افتتاح',
  breaksOff: 'يفتتح',
  selectPlayerFirst: 'اختر لاعباً أولاً',
  matchClockStartsOnBreak: 'تبدأ ساعة المباراة عند تأكيد الافتتاح.',
  foulCueBallInHand: 'مخالفة — الكرة في اليد',
  pointsAwardedToOpponent: 'نقطة منحت للخصم.',
  toPlayFromHand: 'يلعب بالكرة في اليد.',
  clocksPausedMsg: 'كلا الساعتين متوقفتان.',
  resumeMatch: '▶ استئناف المباراة',
  freeBallLabel: 'Free ball',
  freeBallSnookeredMsg: 'محجوب (Snookered) عن كل الكرات. يمكنه في الضربة التالية اختيار أي كرة بديلة، وتُحتسب نقاطها كأنها الكرة الأصلية المطلوبة.',
  freeBallActiveBanner: '🔴 Free ball — اختر أي كرة لهذه الضربة',
  respotBlackBanner: '🎱 إعادة وضع الكرة السوداء — التعادل في الشوط، من فاز بالقرعة؟',
  higherValueFoul: 'مخالفة بقيمة أعلى',
  selectHighestBallTouched: 'اختر الكرة الأعلى قيمة التي تم لمسها',
  highestBreakLabel: 'أعلى سلسلة',
  highBreakPrizeLabel: '🔴 جائزة أعلى سلسلة',
  highBreakPrizeHint: 'جائزة اختيارية لأعلى سلسلة. ستظهر على الملصق.',
  contactTitle: 'اتصل بنا',
  contactSubtitle: 'هل لديك سؤال؟ أرسل لنا رسالة.',
  contactSubjectLabel: 'الموضوع',
  contactMessageLabel: 'الرسالة',
  contactSendBtn: '✉ إرسال الرسالة',
  contactSentTitle: 'تم إرسال الرسالة',
  contactSentDesc: 'شكراً للتواصل! سنرد في أقرب وقت ممكن.',
  contactSendAnother: 'إرسال رسالة أخرى',
  contactAimToRespond: 'نهدف إلى الرد خلال 1–2 أيام عمل.',
  changeEmailTitle: 'تغيير البريد الإلكتروني',
  changeEmailNewLabel: 'عنوان البريد الإلكتروني الجديد',
  changeEmailSendBtn: 'إرسال بريد التحقق',
  sendPasswordResetLink: 'إرسال رابط إعادة التعيين إلى',
  backToSignIn: '← العودة لتسجيل الدخول',
  viewDraw: 'عرض القرعة →',
  loadingTournament: 'جارٍ تحميل البطولة…',
  loadingMatch: 'جارٍ تحميل المباراة…',
  tournamentNotFound: 'البطولة غير موجودة',
  matchNotFound: 'المباراة غير موجودة',
  backToHistory: '← العودة للتاريخ',
  backToDraw: '← العودة للقرعة',
  backToUsers: '← العودة للمستخدمين',
  deleteTournamentTitle: 'حذف البطولة',
  deleteTournamentConfirm: 'سيتم حذف البطولة وجميع بيانات المباريات نهائياً.',
  tournamentsHeading: 'البطولات',
  loadingTournaments: 'جارٍ تحميل البطولات…',
  noTournamentsYet: 'لم يُنشئ هذا المستخدم أي بطولات بعد.',
  viewThisUsersTournaments: 'عرض بطولات هذا المستخدم',
  grantFreeForLife: 'منح بطولات مجانية مدى الحياة',
  revokeFreeForLife: 'إلغاء البطولات المجانية',
    langFlag: '🇸🇦',
  lastShotUndone: '↩ تم التراجع عن آخر ضربة',
  live: 'مباشر',
  losesTheFrame: 'يخسر الإطار',
  matchesDone: 'المباريات المنتهية',
  navAdmin: 'الإدارة',
  navHistory: 'البطولات',
  navPlayers: 'إضافة لاعبين',
  navUsers: 'المستخدمون',
  noHistory: 'لا توجد بطولات سابقة.',
  noPot: 'بدون إدخال',
  nothingToUndo: 'لا شيء للتراجع عنه',
  password: 'كلمة المرور',
  playerName: 'اسم اللاعب…',
  plusToOpponent: '+{n} للخصم',
  potBall: 'إدخال الكرة',
  potted: '{ball} مُدخَل (+{n})',
  redsRemaining: 'أحمر متبقي',
  registered: 'مسجّل',
  remaining: 'متبقي',
  rounds: 'الجولات',
  save: 'حفظ',
  saving: 'جارٍ الحفظ…',
  secondHalf: 'الشوط الثاني',

  selectFoulBall: 'اختر كرة الخطأ:',
  selectFoulType: 'نوع الخطأ',
  shotClock: 'ساعة الضربة',
  shotsCount: 'ضربات',
  shotsPlayed: 'الضربات المُلعَبة',
  signOut: 'تسجيل الخروج',
  startMatch: 'بدء المباراة',
  startTournament: 'بدء البطولة',
  statusActive: '● جارٍ',
  statusComplete: '✓ مكتمل',
  superuser: 'مستخدم متميز',
  tapBallAbove: 'انقر على كرة الخطأ أعلاه',
  tournamentStatus: 'حالة البطولة',
  user: 'مستخدم',
  username: 'اسم المستخدم',
  viewDetails2: 'عرض الجدول والنتائج',
  vsLabel: 'ضد',
  wins: 'يفوز',
  roundFinal: 'النهائي',
  roundSemiFinals: 'نصف النهائي',
  roundQuarterFinals: 'ربع النهائي',
  roundOf16: 'دور الـ16',
  roundOf: 'جولة',
  owner: 'المالك',
  timePlayed: 'مُلعَب',
  matchesPlayed: 'مُلعَبة',
  noPlayersRegistered: 'لا يوجد لاعبون مسجلون بعد',
  startTypingPlayers: 'ابدأ الكتابة لرؤية لاعبي البطولات السابقة',
  startTournamentConfirm: 'هل تريد بدء البطولة؟ سيتم إنشاء جدول المباريات تلقائيًا.',
  splashFeaturesHeading: 'كل ما تحتاجه لإدارة بطولة Shootout',
  splashFooterTagline: 'Shootout Comps — إدارة البطولات',
  splashUpAndRunning: 'جاهز للعمل في دقائق',
  splashStep2Title: 'سجّل لاعبيك',
  splashStep2Desc: 'أضف ما يصل إلى 32 لاعبًا مع صور',
  splashStep3Title: 'ابدأ البطولة',
  splashStep3Desc: 'يتم إنشاء جدول المباريات تلقائيًا',
  splashStep4Title: 'أدر المباريات مباشرة',
  splashStep4Desc: 'سجّل كل ضربة، تابع الساعة، شاهد النتائج',
  splashReadyTitle: 'مستعد لبطولتك؟',
  splashGetStarted: '🏆 ابدأ مجانًا',
  splashGetStartedPaid: '🏆 إنشاء حساب',
  splashPricingAllFree: 'جميع البطولات مجانية — لا يلزم دفع.',
  splashPricingPaidOnly: 'تكلف البطولات {price} لكل منها.',
  splashPricingOneFree: 'البطولة الأولى مجانية، ثم {price} لكل منها.',
  splashPricingNFree: 'أول {n} بطولات مجانية، ثم {price} لكل منها.',
  privacyPolicy: 'سياسة الخصوصية',
  resend: 'إعادة الإرسال',
  resending: 'إرسال…',
  newLinkSent: '✓ تم إرسال رابط جديد — تحقق من بريدك',
  didntGetIt: 'لم تستلمه؟ أعد إرسال البريد',
  sendResetCode: 'إرسال رمز الاستعادة',
  verifyCode: 'التحقق من الرمز',
  verifying: 'جارٍ التحقق…',
  resendCode: 'إعادة إرسال الرمز',
  handicapStart: '🏅 بداية بهانديكاب',
  noPlayersFound: 'لم يُعثر على لاعبين في بطولاتك.',
  noPlayersMatching: 'لا لاعبين مطابقين لـ',
  navContact: 'اتصل بنا',
  navPublic: 'عام',
  navFaq: 'المساعدة والأسئلة الشائعة',
  navLeagues: 'الدوريات',
  faqSubtitle: 'كل ما تحتاج معرفته لتنظيم بطولة Shootout أو Snooker 900 أو بطولة قياسية.',
  faqSearch: 'البحث في الأسئلة…',
  faqNoResults: 'لا توجد أسئلة تطابق بحثك.',
  faqContact: 'هل لديك سؤال آخر؟',
  faqContactLink: 'تواصل معنا عبر صفحة الاتصال',
  paymentsEnabled: 'المدفوعات مفعّلة',
  paymentsDisabled: 'المدفوعات معطّلة',
  statusLabel: 'الحالة',
  fromLabel: 'من',
  freeForLife: '♾ مجاني',
  freeForLifeGranted: '♾ مجاني ✓',
  createAccount: '🏆 إنشاء حساب',
  splashSignIn: 'تسجيل الدخول',
  splashSignUp: 'التسجيل',
  dontHaveAccount: 'ليس لديك حساب؟',
  createFreeAccount: 'إنشاء حساب مجاني',
  signInNow: '🏆 تسجيل الدخول الآن',
  orContinueWith: 'أو تابع باستخدام',
  continueWithGoogle: 'متابعة باستخدام Google',
  continueWithFacebook: 'متابعة باستخدام Facebook',
  oauthErrorTitle: 'فشل تسجيل الدخول',
  oauthErrorGeneric: 'حدث خطأ أثناء تسجيل الدخول. يرجى المحاولة مرة أخرى.',
  oauthErrorEmailNotVerified: 'هذا الحساب لا يملك بريدًا إلكترونيًا موثقًا، لذا لا يمكننا تسجيل الدخول به.',
  oauthErrorAccountSuspended: 'تم تعليق هذا الحساب.',
  oauthErrorDenied: 'لقد ألغيت تسجيل الدخول.',
  oauthErrorProviderDisabled: 'تسجيل الدخول عبر هذا المزود معطل حاليًا.',
  noPasswordSetError: 'يسجل هذا الحساب الدخول عبر Google أو Facebook — استخدم أحد هذين الزرين بدلاً من ذلك.',
  navPlayersAdmin: '⚙ اللاعبون',
  allPlayersDesc: 'جميع اللاعبين في كل البطولات التي أنشأتها. انقر على الصورة لتحديثها؛ يمكن تعديل نقاط الهانديكاب.',
  pwStrengthWeak: 'ضعيف',
  pwStrengthFair: 'مقبول',
  pwStrengthGood: 'جيد',
  pwStrengthStrong: 'قوي',
  pauseShotClock: 'إيقاف مؤقت',
  resumeShotClock: 'استئناف',
  newTournamentTitle: '🏆 بطولة جديدة',
  editTournamentTitle: '✎ تعديل البطولة',
  locationLabel: '📍 الموقع / القاعة',
  locationPlaceholder: 'مثال: نادي كراون، الرياض',
  locationHint: 'اختياري — يظهر على بطاقة البطولة.',
  entryFeeLabel: '💰 رسوم الاشتراك',
  entryFeeHint: 'اتركه فارغاً إذا لم تكن هناك رسوم.',
  prizePlacesLabel: '🏆 المراكز الفائزة',
  prizePlacesNone: 'بلا',
  prizePlacesHint: 'اختر كم مركزاً يحصل على جائزة.',
  prizePoolLabel: 'إجمالي الجوائز',
  matchFormatLabel: '🔴 تنسيق المباراة',
  shootoutDesc: 'شوتاوت: 10 دقائق · {r} أحمر · 15 ثانية (5 دقائق) · 10 ثانية',
  snooker900Desc: 'سنوكر 900: 15 دقيقة · {r} أحمر · 20 ثانية',
  sixRedsLabel: '🔴 ستة أحمر — 6 كرات فقط بدلاً من 15',
  sixRedsDesc: 'ستة أحمر',
  standardFormatHint: 'سنوكر قياسي: بلا حد زمني · قواعد كاملة · {r} أحمر',
  bestOfDialogTitle: 'عدد الأشواط لكل جولة',
  bestOfDialogDesc: 'اختر عدد الأشواط اللازمة للفوز بكل جولة (أرقام فردية فقط، لضمان وجود فائز دائمًا).',
  bestOfContinueBtn: 'متابعة',
  bestOfBackBtn: 'رجوع',
  handicapHint: 'عند التفعيل، أدخل هانديكاب كل لاعب عند التسجيل.',
  makePublicLabel: 'بطولة عامة',
  makePublicHint: 'سيتمكن أي مستخدم مسجل الدخول من مشاهدة القرعة ومتابعة المباريات مباشرة.',
  cancelBtn: 'إلغاء',
  timedTournamentTitle: 'بطولة بتوقيت',
  timedTournamentDesc: 'شوتاوت أو سنوكر 900 · ساعة الضربة',
  standardTournamentTitle: 'بطولة قياسية',
  standardTournamentDesc: 'قواعد قياسية · بلا حد زمني · ستة أحمر اختياري',
  chooseTournamentType: 'اختر نوع البطولة التي تريد إنشاءها.',
  completedTournamentsAppearHere: 'تظهر البطولات المكتملة هنا.',
  maxEntriesLabel: 'الحد الأقصى {n} مشارك',
  prizePlaceSingle: 'مركز فائز',
  prizePlacePlural: 'مراكز فائزة',
  prizePoolPrefix: 'مجموع الجوائز',
  entryLabel: 'رسوم',
  handicapTournament: 'بطولة هانديكاب',
  scratchTournament: 'بطولة سكراتش',
  highBreakPrizeDisplay: 'جائزة أعلى سلسلة',
  noDateVenueWarning: 'لم يُحدد تاريخ أو مكان أو رسوم أو جوائز. عدّل البطولة لملصق أكثر ثراءً.',
  additionalTextLabel: 'نص إضافي (اختياري)',
  additionalTextPlaceholder: 'مثال: الجميع مرحب بهم! تواصل مع أحمد: 07700 900000',
  additionalTextHint: 'يُطبع في أسفل الملصق.',
  downloadPdfPoster: '⬇ تحميل ملصق PDF',
  generatingPoster: '⏳ جارٍ الإنشاء…',
  paymentGateTitle: 'بطولة جديدة',
  paymentGateDesc: 'لقد استخدمت بطولتك المجانية. مطلوب دفع {amount} لإنشاء بطولة أخرى.',
  editBtn: '✎ تعديل',
  posterBtn: '🖨 ملصق',
  sharedBadge: 'مشترك',
  publicBadge: 'عام',
  privateBadge: 'خاص',
  togglePublicHint: 'انقر للتبديل بين عام وخاص',
  adminsBtn: 'المشرفون',
  adminsDesc: 'يتمتع المشرفون بصلاحية كاملة لتسجيل النقاط وإدارة هذه البطولة، باستثناء حذفها أو إدارة هذه القائمة.',
  usernamePlaceholder: 'اسم المستخدم…',
  addBtn: 'إضافة',
  removeBtn: 'إزالة',
  noAdminsYet: 'لم تتم إضافة أي مشرف بعد.',
  statusRegistrationLabel: 'التسجيل',
  statusActiveLabel: 'جارٍ',
  statusCompleteLabel: 'مكتمل',
  emailAddress: 'Email',
  bracketWinner: 'الفائز',
  bracketChampionTitle: 'البطل',
  bracketSavingLabel: 'جارٍ الحفظ…',
  bracketSaveResult: 'حفظ النتيجة',
  bracketEntries: 'مشاركين',
  bracketEntry: 'مشارك',
  bracketPrizePool: 'إجمالي الجوائز',
  bracketHighBreak: 'أعلى سلسلة',
  bracketSixReds: 'ستة حمر',
  bracketHandicap: 'هانديكاب',
  bracketShootoutLabel: 'شوت أوت',
  bracketSnooker900Label: 'سنوكر 900',
  bracketStandardLabel: 'قياسي',
  bracketPlace: 'مركز',
  bracketPlaces: 'مراكز',
  statsPlayersLabel: 'اللاعبون',
  statsHighBreakLabel: 'أعلى سلسلة',
  statsDateLabel: 'التاريخ',
  statsVenueLabel: 'المكان',
  spectatorView: 'وضع المشاهد — جهاز آخر يسجّل هذه المباراة',
  resetLinkInvalidTitle: 'رابط غير صالح',
  resetLinkExpiredMsg: 'انتهت صلاحية رابط إعادة التعيين.',
  resetLinkInvalidMsg: 'هذا الرابط غير صالح أو تم استخدامه مسبقًا.',
  emailUpdatedTitle: 'تم تحديث البريد الإلكتروني',
  emailChangeLinkInvalidTitle: 'رابط غير صالح',
  emailAlreadyTaken: 'هذا البريد الإلكتروني مستخدم بالفعل من قِبل حساب آخر.',
  emailChangeLinkInvalidMsg: 'رابط تغيير البريد الإلكتروني غير صالح أو تم استخدامه.',
  accountSuspendedTitle: 'الحساب موقوف',
  accountSuspendedMsg: 'تم تعليق حسابك.',
  editMatchResult: 'تعديل نتيجة المباراة',
  adminOnlineNow: 'متصل الآن (5 دق)',
  adminTotalAccounts: 'إجمالي الحسابات',
  adminAwaitingVerification: 'في انتظار التحقق',
  adminNewThisWeek: 'جديد هذا الأسبوع',
  adminNewThisMonth: 'جديد هذا الشهر',
  adminMatchesInProgress: 'مباريات جارية',
  adminInProgress: 'قيد التنفيذ',
  adminUniquePlayerEntries: 'دخولات لاعبين فريدة',
  adminTotalEver: 'الإجمالي التاريخي',
  adminLoadingStats: 'جارٍ تحميل الإحصائيات…',
  settingsSavePrices: 'حفظ الأسعار',
  settingsCurrentState: 'الحالة الحالية:',
  settingsTimedLabel: 'موقّت',
  settingsStandardLabel: 'قياسي',
  settingsPerUserOverrides: 'إعدادات خاصة بكل مستخدم',
  usersAccountStates: 'حالات الحساب:',
  usersActiveState: 'نشط',
  usersPendingState: 'معلّق',
  usersSuspendedState: 'موقوف',
  usersDeactivatedState: 'معطّل',
  loadingLabel: 'جارٍ التحميل…',
  leaguesEmptyDesc: 'نظّم بطولة جماعية تمتد على مدار موسم كامل — أقسام ومباريات وجدول ترتيب. أنشئ دورتك الأولى للبدء.',
  createLeagueBtn: '+ إنشاء دوري',
  leagueNamePlaceholder: 'اسم الدوري',
  divisionTabTeams: '👥 الفرق',
  divisionTabFixtures: '📅 المباريات',
  divisionTabStandings: '🏆 جدول الترتيب',
  standingsTeamCol: 'الفريق',
  noTeamsInDivision: 'لا توجد فرق في هذا القسم بعد.',
  fixtureStatusScheduled: 'مجدولة',
  fixtureStatusLineupSet: 'تم تحديد التشكيلة',
  fixtureStatusInProgress: 'جارية',
  backToFixture: '← العودة إلى المباراة',
  publicLeaguesTitle: '🌐 الدورات العامة',
  publicLeaguesDesc: 'تصفّح وشاهد الدورات التي جعلها منظمون آخرون عامة.',
  noPublicLeaguesYet: 'لا توجد دورات عامة بعد.',
  backToPublicLeagues: '← الدورات العامة',
  noFixturesYetLabel: 'لا توجد مباريات بعد.',
  noTeamsYetLabel: 'لا توجد فرق بعد.',
  backToAllSeasons: '← جميع المواسم',
  noPastSeasonsYet: 'لا توجد مواسم سابقة بعد.',
  noPastSeasonsYetOwner: 'لا توجد مواسم سابقة بعد — ستظهر هنا بعد أول "إنهاء موسم" لهذا القسم.',
  endedLabel: 'انتهى',
  promotedLabel: 'ترقية',
  relegatedLabel: 'هبوط',
  finalStandingsLabel: 'الترتيب النهائي',
  fixturesLabel: 'المباريات',
  historyTabLabel: '📜 السجل',
  doubleRoundRobinLabel: 'ذهاب وإياب (دوري مزدوج)',
  pendingClaimApprovalLabel: '⏳ بانتظار الموافقة',
  approveBtn: 'موافقة',
  rejectBtn: 'رفض',
  tierFieldLabel: 'المستوى (1 = القسم الأعلى)',
  promotionSpotsFieldLabel: 'مقاعد الترقية (افتراضي)',
  relegationSpotsFieldLabel: 'مقاعد الهبوط (افتراضي)',
  seasonManagementHint: 'إدارة الموسم: مستوى هذا القسم (1 = الأعلى) وعدد مقاعد الترقية/الهبوط الافتراضي الذي يُعبأ مسبقًا في معاينة إنهاء الموسم القادم. يمكن تجاوزه في كل موسم.',
  togglePublicTooltip: 'تبديل ما إذا كان بإمكان أي مستخدم مسجّل تصفح ومشاهدة هذه الدورة',
  toggleClaimApprovalTooltip: 'تبديل ما إذا كانت مطالبات القائمة الذاتية تحتاج إلى موافقة المالك/المشرف',
  publicChipLabel: '🌐 عامة',
  privateChipLabel: '🔒 خاصة',
  claimsApprovalChipLabel: '🛂 المطالبات: موافقة',
  claimsInstantChipLabel: '⚡ المطالبات: فورية',
  endSeasonBtn: '🏁 إنهاء الموسم',
  browsePublicLeaguesLink: '🌐 تصفح الدورات العامة',
  myStatsTitle: 'إحصائياتي',
  statsPlayedLabel: 'لعب',
  statsWonLabel: 'فاز',
  statsLostLabel: 'خسر',
  seasonLabelFieldLabel: 'اسم الموسم',
  seasonLabelPlaceholder: 'مثال 2025/26',
  seasonCountsHint: 'مقاعد الترقية/الهبوط لهذا الموسم — مُعبأة مسبقًا من القيم الافتراضية لكل قسم، قابلة للتعديل لهذه المرة فقط.',
  tierLabel: 'المستوى',
  previewBtn: 'معاينة ←',
  reviewMovesHint: 'راجع الحركات المقترحة أدناه — ألغِ تحديد أي فريق تريد إبقاءه في قسمه الحالي. سيتم أرشفة وإعادة ضبط مباريات جميع الأقسام على أي حال.',
  noMovesThisSeason: 'لا توجد حركات ترقية/هبوط هذا الموسم.',
  confirmEndSeasonBtn: 'تأكيد وإنهاء الموسم',
};

const hi: Translations = {
  langName: 'हिन्दी',
  appName: 'Shootout Comps',
  signIn: 'साइन इन',
  signingIn: 'साइन इन हो रहा है…',
  navBracket: 'टूर्नामेंट',
  statusRegistration: 'पंजीकरण खुला',
  players: 'खिलाड़ी',
  removePlayer: 'हटाएं',
  slotsRemaining: 'स्लॉट शेष',
  noPlayersYet: 'अभी तक कोई खिलाड़ी पंजीकृत नहीं',
  awaitingDraw: 'ड्रॉ की प्रतीक्षा',
  champion: 'चैंपियन',
  clickToPlay: '→ खेलने के लिए क्लिक करें',
  matchComplete: 'मैच पूर्ण',
  notStarted: 'शुरू नहीं हुआ',
  startMatchDesc: 'तैयार हैं? 10 मिनट का मैच क्लॉक शुरू होगा।',
  shotClockDesc: 'शॉट क्लॉक: पहले 5 मिनट 15 सेकंड · आखिरी 5 मिनट 10 सेकंड',
  atTheTable: 'टेबल पर',
  nextLegalPot: 'अगला वैध पॉट:',
  miss: 'मिस',
  cancelFoul: 'रद्द करें',
  noContact: 'कोई संपर्क नहीं',
  undo: 'पूर्ववत',
  cueBallPotted: 'क्यू बॉल पॉट',
  endMatchEarly: 'मैच जल्दी समाप्त करें',
  finishMatchBtn: 'मैच समाप्त करें',
  finishFrameBtn: 'फ्रेम समाप्त करें',
  enterFinalScore: 'अंतिम स्कोर दर्ज करें:',
  scoresInvalid: 'दो अलग-अलग स्कोर दर्ज करें',
  shotHistory: 'शॉट इतिहास',
  firstHalf: 'पहला आधा — 15 सेकंड/शॉट',
  backToBracket: '← टूर्नामेंट पर वापस',
  shotClockExpired: 'शॉट क्लॉक समाप्त',
  matchClockExpired: 'मैच क्लॉक समाप्त',
  dismiss: 'बंद करें',
  foulToOpponent: 'फाउल — विरोधी को +{n}',
  noPotnPlayerChanged: '↩ कोई पॉट नहीं — खिलाड़ी बदला',
  cannotUndo: 'पूर्ववत नहीं किया जा सकता',
  adminDashboard: 'एडमिन डैशबोर्ड',
  registrationOpen: 'पंजीकरण खुला',
  tournamentName: 'टूर्नामेंट नाम',
  newTournament: '🆕 नया टूर्नामेंट',
  newTournamentDesc: 'नया टूर्नामेंट शुरू करने से वर्तमान संग्रहीत होगा।',
  startNewTournament: 'नया टूर्नामेंट',
  tournamentHistory: 'टूर्नामेंट इतिहास',
  noHistoryDesc: 'पूर्ण टूर्नामेंट यहाँ दिखाई देंगे।',
  viewDetails: '→ विवरण देखें',
  participants: 'प्रतिभागी',
  userManagement: 'उपयोगकर्ता प्रबंधन',
  you: 'आप',
  resetPasswordBtn: '🔑 PW रीसेट',
  passwordMinLength: 'पासवर्ड कम से कम 8 अक्षर का होना चाहिए',
  userIsolationNote: 'प्रत्येक उपयोगकर्ता केवल अपने टूर्नामेंट देख सकता है।',
  voiceHalfTime: '10 सेकंड शॉट क्लॉक अब लागू है',
  language: 'भाषा',
  profile: 'My Profile',
  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  passwordChanged: 'Password changed successfully.',
  forgotPassword: 'Forgot password?',
  sendResetLink: 'Send Reset Link',
  resetLinkSent: 'Reset link sent — check your email.',
  resetPassword: 'Reset Password',
  resetPasswordDesc: "Enter your email and we'll send a reset link.",
  setNewPassword: 'Set New Password',
  accountDetails: 'Account Details',
  memberSince: 'Member since',
  tournamentsTitle: 'टूर्नामेंट',
  newTournament2: '+ नया टूर्नामेंट',
  currentTournament: 'वर्तमान टूर्नामेंट',
  pastTournaments: 'पिछले टूर्नामेंट',
  publicTournamentsHeading: 'सार्वजनिक टूर्नामेंट',
  publicTournamentsSubtitle: 'अन्य उपयोगकर्ताओं द्वारा सार्वजनिक किए गए टूर्नामेंट — कोई भी साइन-इन उपयोगकर्ता ड्रॉ देख सकता है और मैच लाइव देख सकता है।',
  noPublicTournaments: 'अभी कोई सार्वजनिक टूर्नामेंट नहीं है।',
  hostedByLabel: 'आयोजक',
  watchLiveBtn: 'लाइव देखें',
  backToPublicList: 'सार्वजनिक टूर्नामेंट पर वापस जाएं',
  spectatingBadge: '👀 देख रहे हैं',
  noHistoryYet: 'No past tournaments yet.',
  noHistoryYetDesc: 'Completed tournaments appear here.',
  createTournament: 'Create Tournament',
  nextBtn: 'अगला',
  backBtn: 'वापस',
  editTournament: 'Edit Tournament',
  tournamentNameLabel: 'Tournament Name',
  dateTimeLabel: 'Date & Time',
  dateTimeHint: 'Shown on the tournaments list',
  maxPlayersLabel: 'Maximum Players',
  maxPlayersHint: 'Empty slots filled with BYEs',
  handicapLabel: 'Handicap Tournament',
  handicapOnDesc: 'Handicap ON',
  handicapOffDesc: 'Handicap OFF',
  pauseClocks: 'Pause Clocks',
  resumeClocks: 'Resume Clocks',
  saveChanges: 'Save Changes',
  confirmCreateTitle: 'Start New Tournament?',
  confirmCreateMsg: 'Current tournament will be archived.',
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  registrationLabel: 'Registration',
  activeLabel: 'In Progress',
  completeLabel: 'Complete',
  maxLabel: 'Max',
  handicapBadge: 'Handicap',
  playerManagement: 'Player Management',
  playerManagementDesc: 'Click photo to change',
  deletePlayerTitle: 'Delete Player',
  deletePlayerMsg: 'This player will be removed.',
  changePhoto: 'Photo',
  deletePlayer: 'Delete',
  newPhotoSelected: 'New photo selected',
  handicapEditHint: 'Handicap',
  handicapValue: 'हैंडीकैप',
  clickToEditHandicap: 'हैंडीकैप संपादित करने के लिए क्लिक करें',
  playerCountAll: 'सभी टूर्नामेंट में {n} खिलाड़ी',
  playerCountMatch: '"{q}" से मेल खाते {n} खिलाड़ी',
  clickToChangePhoto: 'Click to change photo',
  photoFromPrevious: 'Photo from previous tournament',
  handicapStartTitle: 'Handicap Start',
  handicapStartDesc: 'Points advantage applied',
  debugJumpBtn: 'Debug: Jump to 5:30',
  pointsAdvantageApplied: 'Points advantage applied',
  handicapPts: 'अंक — अधिक = कमज़ोर खिलाड़ी = अधिक अंक शुरुआत',
  passwordWeak: 'कमज़ोर',
  passwordFair: 'ठीक है',
  passwordGood: 'अच्छा',
  passwordStrong: 'मज़बूत',
  passwordsNoMatch: 'पासवर्ड मेल नहीं खाते',
  repeatPassword: 'पासवर्ड दोहराएं',
  creatingAccount: 'खाता बनाया जा रहा है…',
  minChars: 'न्यूनतम 8 अक्षर',
  usernameHint: 'अक्षर, संख्याएं, रिक्त स्थान, अंडरस्कोर और हाइफ़न',
  deactivateAccount: 'खाता निष्क्रिय करें',
  newPasswordMin: 'नया पासवर्ड (न्यूनतम 8)',
  suspensionReason: 'निलंबन का कारण (वैकल्पिक)',
  confirmSuspend: 'निलंबन की पुष्टि करें',
  passwordUpdated: 'पासवर्ड अपडेट किया गया ✓',
  addNewUser: 'नया उपयोगकर्ता जोड़ें',
  addPlayer: 'खिलाड़ी जोड़ें',
  allUsers: 'सभी उपयोगकर्ता',
  awaitingDrawDesc: 'खिलाड़ी पंजीकृत करें फिर टूर्नामेंट शुरू करें।',
  ballOffTable: 'गेंद टेबल से बाहर',
  byesAdded: '{n} BYE जोड़े गए',
  cancel: 'रद्द करें',
  complete: 'पूर्ण',
  connecting: 'कनेक्ट हो रहा है…',
  createUser: '+ जोड़ें',
  creating: 'बना रहे हैं…',
  declareWinner: 'विजेता घोषित करें:',
  deleteUser: 'हटाएं',
  dir: 'ltr',
  elapsed: 'बीता',
  endMatchToDeclare: 'विजेता घोषित करने के लिए मैच समाप्त करें',
  foul: 'फ़ाउल',
  inProgress: 'प्रगति में',
  inProgressStatus: 'टूर्नामेंट प्रगति में',
  joined: 'शामिल हुए',
  splashTagline: 'अपना स्नूकर टूर्नामेंट एक प्रो की तरह चलाएं।',
  splashSubtitle: 'लाइव स्कोरिंग, शॉट क्लॉक, खिलाड़ी प्रोफाइल और पूरा मैच इतिहास — शूटआउट या स्नूकर 900 नियमों के तहत। पहला टूर्नामेंट मुफ्त।',
  splashSubtitleAllFree: 'लाइव स्कोरिंग, शॉट क्लॉक, खिलाड़ी प्रोफाइल और पूरा मैच इतिहास। सभी टूर्नामेंट मुफ्त।',
  splashSubtitlePaid: 'लाइव स्कोरिंग, शॉट क्लॉक, खिलाड़ी प्रोफाइल और पूरा मैच इतिहास।',
  splashSubtitleNFree: 'लाइव स्कोरिंग, शॉट क्लॉक, खिलाड़ी प्रोफाइल और पूरा मैच इतिहास। पहले {n} टूर्नामेंट मुफ्त।',
  splashNoCreditCard: 'क्रेडिट कार्ड जरूरी नहीं · पहला टूर्नामेंट मुफ्त',
  splashNoCreditCardAllFree: 'क्रेडिट कार्ड जरूरी नहीं · सभी टूर्नामेंट मुफ्त',
  splashNoCreditCardPaid: 'क्रेडिट कार्ड जरूरी नहीं',
  splashNoCreditCardNFree: 'क्रेडिट कार्ड जरूरी नहीं · पहले {n} टूर्नामेंट मुफ्त',
  splashStep1Title: 'अकाउंट बनाएं',
  splashStep1Desc: 'ईमेल से साइन अप करें। पहला टूर्नामेंट मुफ्त।',
  splashStep1DescAllFree: 'ईमेल से साइन अप करें। सभी टूर्नामेंट मुफ्त।',
  splashStep1DescPaid: 'ईमेल से साइन अप करें।',
  splashStep1DescNFree: 'ईमेल से साइन अप करें। पहले {n} टूर्नामेंट मुफ्त।',
  whoBreaks: 'कौन ब्रेक करेगा?',
  whoBreaksDesc: 'वह खिलाड़ी चुनें जो ब्रेक करेगा। पुष्टि करने पर मैच घड़ी शुरू होगी।',
  breakOffBtn: 'ब्रेक ऑफ',
  breaksOff: 'ब्रेक करेगा',
  selectPlayerFirst: 'पहले एक खिलाड़ी चुनें',
  matchClockStartsOnBreak: 'ब्रेक ऑफ की पुष्टि पर मैच घड़ी शुरू होती है।',
  foulCueBallInHand: 'फाउल — क्यू बॉल हाथ में',
  pointsAwardedToOpponent: 'अंक प्रतिद्वंद्वी को दिए गए।',
  toPlayFromHand: 'हाथ से खेलेगा।',
  clocksPausedMsg: 'दोनों घड़ियां रुकी हुई हैं।',
  resumeMatch: '▶ मैच फिर से शुरू करें',
  freeBallLabel: 'फ्री बॉल',
  freeBallSnookeredMsg: 'हर गेंद पर स्नूकर्ड है। उनका अगला शॉट किसी भी गेंद को नामांकित कर सकता है; यह असली गेंद के रूप में अंक देगा।',
  freeBallActiveBanner: '🔴 फ्री बॉल — इस शॉट के लिए कोई भी गेंद चुनें',
  respotBlackBanner: '🎱 ब्लैक फिर से स्पॉट हुई — फ्रेम बराबर है, टॉस किसने जीता?',
  higherValueFoul: 'अधिक मूल्य का फाउल',
  selectHighestBallTouched: 'छुई गई सबसे अधिक मूल्य की बॉल चुनें',
  highestBreakLabel: 'सर्वोच्च ब्रेक',
  highBreakPrizeLabel: '🔴 सर्वोच्च ब्रेक पुरस्कार',
  highBreakPrizeHint: 'सर्वोच्च ब्रेक के खिलाड़ी के लिए वैकल्पिक पुरस्कार। पोस्टर पर दिखाई देगा।',
  contactTitle: 'संपर्क करें',
  contactSubtitle: 'कोई सवाल है? हमें संदेश भेजें।',
  contactSubjectLabel: 'विषय',
  contactMessageLabel: 'संदेश',
  contactSendBtn: '✉ संदेश भेजें',
  contactSentTitle: 'संदेश भेजा गया',
  contactSentDesc: 'संपर्क करने के लिए धन्यवाद! हम जल्द से जल्द जवाब देंगे।',
  contactSendAnother: 'एक और संदेश भेजें',
  contactAimToRespond: 'हम 1–2 कार्य दिवसों में जवाब देते हैं।',
  changeEmailTitle: 'ईमेल बदलें',
  changeEmailNewLabel: 'नया ईमेल पता',
  changeEmailSendBtn: 'सत्यापन ईमेल भेजें',
  sendPasswordResetLink: 'पासवर्ड रीसेट लिंक भेजें',
  backToSignIn: '← साइन इन पर वापस जाएं',
  viewDraw: 'ड्रॉ देखें →',
  loadingTournament: 'टूर्नामेंट लोड हो रहा है…',
  loadingMatch: 'मैच लोड हो रहा है…',
  tournamentNotFound: 'टूर्नामेंट नहीं मिला',
  matchNotFound: 'मैच नहीं मिला',
  backToHistory: '← इतिहास पर वापस',
  backToDraw: '← ड्रॉ पर वापस',
  backToUsers: '← उपयोगकर्ताओं पर वापस',
  deleteTournamentTitle: 'टूर्नामेंट हटाएं',
  deleteTournamentConfirm: 'यह टूर्नामेंट और सभी मैच डेटा स्थायी रूप से हटा दिए जाएंगे।',
  tournamentsHeading: 'टूर्नामेंट',
  loadingTournaments: 'टूर्नामेंट लोड हो रहे हैं…',
  noTournamentsYet: 'इस उपयोगकर्ता ने अभी तक कोई टूर्नामेंट नहीं बनाया है।',
  viewThisUsersTournaments: 'इस उपयोगकर्ता के टूर्नामेंट देखें',
  grantFreeForLife: 'आजीवन मुफ्त टूर्नामेंट दें',
  revokeFreeForLife: 'मुफ्त टूर्नामेंट वापस लें',
    langFlag: '🇮🇳',
  lastShotUndone: '↩ अंतिम शॉट पूर्ववत किया',
  live: 'लाइव',
  losesTheFrame: 'फ्रेम हार गए',
  matchesDone: 'मैच पूर्ण',
  navAdmin: 'व्यवस्थापक',
  navHistory: 'टूर्नामेंट',
  navPlayers: 'खिलाड़ी जोड़ें',
  navUsers: 'उपयोगकर्ता',
  noHistory: 'कोई पिछला टूर्नामेंट नहीं।',
  noPot: 'कोई पॉट नहीं',
  nothingToUndo: 'पूर्ववत करने के लिए कुछ नहीं',
  password: 'पासवर्ड',
  playerName: 'खिलाड़ी का नाम…',
  plusToOpponent: 'प्रतिद्वंद्वी को +{n}',
  potBall: 'गेंद पॉट करें',
  potted: '{ball} पॉट (+{n})',
  redsRemaining: 'लाल शेष',
  registered: 'पंजीकृत',
  remaining: 'शेष',
  rounds: 'दौर',
  save: 'सहेजें',
  saving: 'सहेज रहे हैं…',
  secondHalf: 'दूसरा हाफ',

  selectFoulBall: 'फ़ाउल की गेंद चुनें:',
  selectFoulType: 'फ़ाउल का प्रकार',
  shotClock: 'शॉट क्लॉक',
  shotsCount: 'शॉट',
  shotsPlayed: 'खेले गए शॉट',
  signOut: 'साइन आउट',
  startMatch: 'मैच शुरू करें',
  startTournament: 'टूर्नामेंट शुरू करें',
  statusActive: '● प्रगति में',
  statusComplete: '✓ पूर्ण',
  superuser: 'सुपरयूज़र',
  tapBallAbove: 'ऊपर फ़ाउल की गेंद पर टैप करें',
  tournamentStatus: 'टूर्नामेंट स्थिति',
  user: 'उपयोगकर्ता',
  username: 'उपयोगकर्ता नाम',
  viewDetails2: 'ब्रैकेट और परिणाम देखें',
  vsLabel: 'बनाम',
  wins: 'जीते',
  roundFinal: 'फाइनल',
  roundSemiFinals: 'सेमी-फाइनल',
  roundQuarterFinals: 'क्वार्टर-फाइनल',
  roundOf16: '16 का राउंड',
  roundOf: 'राउंड ऑफ',
  owner: 'मालिक',
  timePlayed: 'खेला गया',
  matchesPlayed: 'खेले गए',
  noPlayersRegistered: 'अभी तक कोई खिलाड़ी पंजीकृत नहीं है',
  startTypingPlayers: 'पिछले टूर्नामेंट के खिलाड़ी देखने के लिए टाइप करें',
  startTournamentConfirm: 'टूर्नामेंट शुरू करें? ब्रैकेट स्वचालित रूप से बनाया जाएगा।',
  splashFeaturesHeading: 'Shootout चलाने के लिए आपको जो कुछ भी चाहिए',
  splashFooterTagline: 'Shootout Comps — टूर्नामेंट प्रबंधन',
  splashUpAndRunning: 'मिनटों में चालू',
  splashStep2Title: 'अपने खिलाड़ी पंजीकृत करें',
  splashStep2Desc: 'फोटो के साथ 32 खिलाड़ी तक जोड़ें',
  splashStep3Title: 'टूर्नामेंट शुरू करें',
  splashStep3Desc: 'ब्रैकेट स्वचालित रूप से बनाया जाता है',
  splashStep4Title: 'लाइव मैच प्रबंधित करें',
  splashStep4Desc: 'हर शॉट स्कोर करें, घड़ी ट्रैक करें, परिणाम देखें',
  splashReadyTitle: 'अपना टूर्नामेंट चलाने के लिए तैयार?',
  splashGetStarted: '🏆 मुफ्त में शुरू करें',
  splashGetStartedPaid: '🏆 खाता बनाएं',
  splashPricingAllFree: 'सभी टूर्नामेंट मुफ्त हैं — कोई भुगतान आवश्यक नहीं।',
  splashPricingPaidOnly: 'प्रत्येक टूर्नामेंट की कीमत {price} है।',
  splashPricingOneFree: 'पहला टूर्नामेंट मुफ्त, फिर प्रत्येक {price}।',
  splashPricingNFree: 'पहले {n} टूर्नामेंट मुफ्त, फिर प्रत्येक {price}।',
  privacyPolicy: 'गोपनीयता नीति',
  resend: 'पुनः भेजें',
  resending: 'भेज रहे हैं…',
  newLinkSent: '✓ नया लिंक भेजा गया — अपना इनबॉक्स जांचें',
  didntGetIt: 'नहीं मिला? ईमेल पुनः भेजें',
  sendResetCode: 'रीसेट कोड भेजें',
  verifyCode: 'कोड सत्यापित करें',
  verifying: 'सत्यापन…',
  resendCode: 'कोड पुनः भेजें',
  handicapStart: '🏅 हैंडीकैप स्टार्ट',
  noPlayersFound: 'आपके टूर्नामेंट में कोई खिलाड़ी नहीं मिला।',
  noPlayersMatching: 'कोई मिलान नहीं:',
  navContact: 'संपर्क',
  navPublic: 'सार्वजनिक',
  navFaq: 'सहायता और FAQ',
  navLeagues: 'लीग',
  faqSubtitle: 'शूटआउट, स्नूकर 900, या मानक टूर्नामेंट चलाने के लिए आपको जो कुछ भी जानना चाहिए।',
  faqSearch: 'प्रश्न खोजें…',
  faqNoResults: 'आपकी खोज से मेल खाने वाला कोई प्रश्न नहीं।',
  faqContact: 'अभी भी कोई प्रश्न है?',
  faqContactLink: 'संपर्क पृष्ठ के माध्यम से हमसे संपर्क करें',
  paymentsEnabled: 'भुगतान सक्षम',
  paymentsDisabled: 'भुगतान अक्षम',
  statusLabel: 'स्थिति',
  fromLabel: 'से',
  freeForLife: '♾ मुफ्त',
  freeForLifeGranted: '♾ मुफ्त ✓',
  createAccount: '🏆 खाता बनाएं',
  splashSignIn: 'साइन इन',
  splashSignUp: 'साइन अप',
  dontHaveAccount: 'खाता नहीं है?',
  createFreeAccount: 'मुफ्त खाता बनाएं',
  signInNow: '🏆 अभी साइन इन करें',
  orContinueWith: 'या इसके साथ जारी रखें',
  continueWithGoogle: 'Google के साथ जारी रखें',
  continueWithFacebook: 'Facebook के साथ जारी रखें',
  oauthErrorTitle: 'साइन-इन विफल',
  oauthErrorGeneric: 'साइन इन करते समय कुछ गड़बड़ हो गई। कृपया फिर से प्रयास करें।',
  oauthErrorEmailNotVerified: 'उस खाते में कोई सत्यापित ईमेल पता नहीं है, इसलिए हम आपको उससे साइन इन नहीं कर सकते।',
  oauthErrorAccountSuspended: 'यह खाता निलंबित कर दिया गया है।',
  oauthErrorDenied: 'आपने साइन-इन रद्द कर दिया।',
  oauthErrorProviderDisabled: 'इस प्रदाता के साथ साइन-इन फ़िलहाल बंद है।',
  noPasswordSetError: 'यह खाता Google या Facebook से साइन इन होता है — इसके बजाय उनमें से किसी एक बटन का उपयोग करें।',
  navPlayersAdmin: '⚙ खिलाड़ी',
  allPlayersDesc: 'आपके द्वारा बनाए गए हर टूर्नामेंट के सभी खिलाड़ी। फोटो पर क्लिक करके उसे अपडेट करें; हैंडीकैप संपादन योग्य हैं।',
  pwStrengthWeak: 'कमजोर',
  pwStrengthFair: 'ठीक',
  pwStrengthGood: 'अच्छा',
  pwStrengthStrong: 'मजबूत',
  pauseShotClock: 'रोकें',
  resumeShotClock: 'फिर शुरू करें',
  newTournamentTitle: '🏆 नया टूर्नामेंट',
  editTournamentTitle: '✎ टूर्नामेंट संपादित करें',
  locationLabel: '📍 स्थान / स्थल',
  locationPlaceholder: 'जैसे: क्राउन क्लब, दिल्ली',
  locationHint: 'वैकल्पिक — टूर्नामेंट कार्ड पर दिखाया जाएगा।',
  entryFeeLabel: '💰 प्रवेश शुल्क',
  entryFeeHint: 'यदि कोई प्रवेश शुल्क नहीं है तो खाली छोड़ें।',
  prizePlacesLabel: '🏆 पुरस्कार स्थान',
  prizePlacesNone: 'कोई नहीं',
  prizePlacesHint: 'चुनें कि कितने स्थानों को पुरस्कार मिलेगा।',
  prizePoolLabel: 'कुल पुरस्कार राशि',
  matchFormatLabel: '🔴 मैच प्रारूप',
  shootoutDesc: 'शूटआउट: 10 मिनट · {r} लाल · 15 सेकंड (5 मिनट) · 10 सेकंड',
  snooker900Desc: 'स्नूकर 900: 15 मिनट · {r} लाल · 20 सेकंड',
  sixRedsLabel: '🔴 सिक्स रेड्स — 15 के बजाय केवल 6 लाल गेंदें',
  sixRedsDesc: 'सिक्स रेड्स',
  standardFormatHint: 'मानक स्नूकर: कोई समय सीमा नहीं · पूर्ण नियम · {r} लाल',
  bestOfDialogTitle: 'प्रति राउंड फ्रेम',
  bestOfDialogDesc: 'चुनें कि प्रत्येक राउंड जीतने के लिए कितने फ्रेम चाहिए (केवल विषम संख्याएँ, ताकि हमेशा एक विजेता हो)।',
  bestOfContinueBtn: 'जारी रखें',
  bestOfBackBtn: 'वापस',
  handicapHint: 'सक्षम होने पर, पंजीकरण पर प्रत्येक खिलाड़ी का हैंडीकैप दर्ज करें।',
  makePublicLabel: 'सार्वजनिक टूर्नामेंट',
  makePublicHint: 'कोई भी साइन-इन उपयोगकर्ता ड्रॉ देख सकेगा और मैच लाइव देख सकेगा।',
  cancelBtn: 'रद्द करें',
  timedTournamentTitle: 'टाइम्ड टूर्नामेंट',
  timedTournamentDesc: 'शूटआउट या स्नूकर 900 · शॉट क्लॉक लागू',
  standardTournamentTitle: 'मानक टूर्नामेंट',
  standardTournamentDesc: 'मानक नियम · कोई समय सीमा नहीं · वैकल्पिक सिक्स रेड्स',
  chooseTournamentType: 'बनाना चाहते हैं टूर्नामेंट का प्रकार चुनें।',
  completedTournamentsAppearHere: 'पूर्ण टूर्नामेंट यहाँ दिखाई देंगे।',
  maxEntriesLabel: 'अधिकतम {n} प्रतिभागी',
  prizePlaceSingle: 'पुरस्कार स्थान',
  prizePlacePlural: 'पुरस्कार स्थान',
  prizePoolPrefix: 'पुरस्कार',
  entryLabel: 'प्रवेश',
  handicapTournament: 'हैंडीकैप टूर्नामेंट',
  scratchTournament: 'स्क्रैच टूर्नामेंट',
  highBreakPrizeDisplay: 'उच्च ब्रेक पुरस्कार',
  noDateVenueWarning: 'कोई तिथि, स्थल, शुल्क या पुरस्कार नहीं। बेहतर पोस्टर के लिए पहले टूर्नामेंट संपादित करें।',
  additionalTextLabel: 'अतिरिक्त पाठ (वैकल्पिक)',
  additionalTextPlaceholder: 'जैसे: सभी स्वागत हैं! राम से संपर्क करें: 07700 900000',
  additionalTextHint: 'पोस्टर के निचले भाग पर मुद्रित होगा।',
  downloadPdfPoster: '⬇ PDF पोस्टर डाउनलोड करें',
  generatingPoster: '⏳ तैयार हो रहा है…',
  paymentGateTitle: 'नया टूर्नामेंट',
  paymentGateDesc: 'आपने अपना मुफ़्त टूर्नामेंट उपयोग कर लिया है। एक और बनाने के लिए {amount} का एकमुश्त भुगतान आवश्यक है।',
  editBtn: '✎ संपादित करें',
  posterBtn: '🖨 पोस्टर',
  sharedBadge: 'साझा',
  publicBadge: 'सार्वजनिक',
  privateBadge: 'निजी',
  togglePublicHint: 'सार्वजनिक और निजी के बीच बदलने के लिए क्लिक करें',
  adminsBtn: 'एडमिन',
  adminsDesc: 'एडमिन के पास इस टूर्नामेंट के लिए स्कोरिंग और प्रबंधन की पूरी पहुंच है, सिवाय इसे हटाने या इस सूची को प्रबंधित करने के।',
  usernamePlaceholder: 'उपयोगकर्ता नाम…',
  addBtn: 'जोड़ें',
  removeBtn: 'हटाएं',
  noAdminsYet: 'अभी तक कोई एडमिन नहीं जोड़ा गया।',
  statusRegistrationLabel: 'पंजीकरण',
  statusActiveLabel: 'चल रहा है',
  statusCompleteLabel: 'पूर्ण',
  emailAddress: 'Email',
  bracketWinner: 'विजेता',
  bracketChampionTitle: 'चैम्पियन',
  bracketSavingLabel: 'सहेज रहे हैं…',
  bracketSaveResult: 'परिणाम सहेजें',
  bracketEntries: 'प्रतिभागी',
  bracketEntry: 'प्रतिभागी',
  bracketPrizePool: 'पुरस्कार राशि',
  bracketHighBreak: 'उच्चतम ब्रेक',
  bracketSixReds: 'छह लाल',
  bracketHandicap: 'हैंडीकैप',
  bracketShootoutLabel: 'शूटआउट',
  bracketSnooker900Label: 'स्नूकर 900',
  bracketStandardLabel: 'मानक',
  bracketPlace: 'स्थान',
  bracketPlaces: 'स्थान',
  statsPlayersLabel: 'खिलाड़ी',
  statsHighBreakLabel: 'उच्चतम ब्रेक',
  statsDateLabel: 'तारीख',
  statsVenueLabel: 'स्थल',
  spectatorView: 'दर्शक मोड — दूसरा डिवाइस इस मैच को स्कोर कर रहा है',
  resetLinkInvalidTitle: 'लिंक अमान्य',
  resetLinkExpiredMsg: 'यह रीसेट लिंक समाप्त हो गया है।',
  resetLinkInvalidMsg: 'यह लिंक अमान्य है या पहले ही उपयोग किया जा चुका है।',
  emailUpdatedTitle: 'ईमेल अपडेट हुआ',
  emailChangeLinkInvalidTitle: 'लिंक अमान्य',
  emailAlreadyTaken: 'यह ईमेल पता किसी अन्य खाते द्वारा उपयोग में है।',
  emailChangeLinkInvalidMsg: 'यह ईमेल बदलाव लिंक अमान्य है या पहले ही उपयोग किया जा चुका है।',
  accountSuspendedTitle: 'खाता निलंबित',
  accountSuspendedMsg: 'आपका खाता निलंबित कर दिया गया है।',
  editMatchResult: 'मैच परिणाम संपादित करें',
  adminOnlineNow: 'अभी ऑनलाइन (5 मिनट)',
  adminTotalAccounts: 'कुल खाते',
  adminAwaitingVerification: 'सत्यापन प्रतीक्षित',
  adminNewThisWeek: 'इस सप्ताह नए',
  adminNewThisMonth: 'इस माह नए',
  adminMatchesInProgress: 'चल रहे मैच',
  adminInProgress: 'प्रगति में',
  adminUniquePlayerEntries: 'अद्वितीय खिलाड़ी प्रविष्टियाँ',
  adminTotalEver: 'कुल ऐतिहासिक',
  adminLoadingStats: 'आँकड़े लोड हो रहे हैं…',
  settingsSavePrices: 'कीमतें सहेजें',
  settingsCurrentState: 'वर्तमान स्थिति:',
  settingsTimedLabel: 'समयबद्ध',
  settingsStandardLabel: 'मानक',
  settingsPerUserOverrides: 'उपयोगकर्ता-वार अपवाद',
  usersAccountStates: 'खाता स्थिति:',
  usersActiveState: 'सक्रिय',
  usersPendingState: 'लंबित',
  usersSuspendedState: 'निलंबित',
  usersDeactivatedState: 'निष्क्रिय',
  loadingLabel: 'लोड हो रहा है…',
  leaguesEmptyDesc: 'पूरे सीज़न चलने वाली टीम-आधारित प्रतियोगिता आयोजित करें — डिवीज़न, फिक्स्चर और स्टैंडिंग्स। शुरू करने के लिए अपनी पहली लीग बनाएं।',
  createLeagueBtn: '+ लीग बनाएं',
  leagueNamePlaceholder: 'लीग का नाम',
  divisionTabTeams: '👥 टीमें',
  divisionTabFixtures: '📅 फिक्स्चर',
  divisionTabStandings: '🏆 स्टैंडिंग्स',
  standingsTeamCol: 'टीम',
  noTeamsInDivision: 'इस डिवीज़न में अभी तक कोई टीम नहीं है।',
  fixtureStatusScheduled: 'निर्धारित',
  fixtureStatusLineupSet: 'लाइनअप तय',
  fixtureStatusInProgress: 'जारी',
  backToFixture: '← फिक्स्चर पर वापस जाएं',
  publicLeaguesTitle: '🌐 सार्वजनिक लीग',
  publicLeaguesDesc: 'अन्य आयोजकों द्वारा सार्वजनिक की गई लीगों को ब्राउज़ करें और देखें।',
  noPublicLeaguesYet: 'अभी तक कोई सार्वजनिक लीग नहीं है।',
  backToPublicLeagues: '← सार्वजनिक लीग',
  noFixturesYetLabel: 'अभी तक कोई फिक्स्चर नहीं है।',
  noTeamsYetLabel: 'अभी तक कोई टीम नहीं है।',
  backToAllSeasons: '← सभी सीज़न',
  noPastSeasonsYet: 'अभी तक कोई पिछला सीज़न नहीं है।',
  noPastSeasonsYetOwner: 'अभी तक कोई पिछला सीज़न नहीं है — इस डिवीज़न के पहले "सीज़न समाप्त करें" के बाद यहां दिखाई देंगे।',
  endedLabel: 'समाप्त',
  promotedLabel: 'प्रमोट',
  relegatedLabel: 'रेलिगेट',
  finalStandingsLabel: 'अंतिम स्टैंडिंग्स',
  fixturesLabel: 'फिक्स्चर',
  historyTabLabel: '📜 इतिहास',
  doubleRoundRobinLabel: 'होम और अवे (डबल राउंड-रॉबिन)',
  pendingClaimApprovalLabel: '⏳ स्वीकृति लंबित',
  approveBtn: 'स्वीकृत करें',
  rejectBtn: 'अस्वीकार करें',
  tierFieldLabel: 'स्तर (1 = शीर्ष डिवीज़न)',
  promotionSpotsFieldLabel: 'प्रमोशन स्थान (डिफ़ॉल्ट)',
  relegationSpotsFieldLabel: 'रेलिगेशन स्थान (डिफ़ॉल्ट)',
  seasonManagementHint: 'सीज़न प्रबंधन: इस डिवीज़न का रैंक स्तर (1 = शीर्ष) और अगले सीज़न-समाप्ति पूर्वावलोकन में पहले से भरी गई डिफ़ॉल्ट प्रमोशन/रेलिगेशन संख्या। इन्हें हर सीज़न बदला जा सकता है।',
  togglePublicTooltip: 'यह टॉगल करें कि क्या कोई भी साइन-इन उपयोगकर्ता इस लीग को ब्राउज़ और देख सकता है',
  toggleClaimApprovalTooltip: 'यह टॉगल करें कि क्या रोस्टर सेल्फ-क्लेम को मालिक/एडमिन की स्वीकृति चाहिए',
  publicChipLabel: '🌐 सार्वजनिक',
  privateChipLabel: '🔒 निजी',
  claimsApprovalChipLabel: '🛂 दावे: स्वीकृति आवश्यक',
  claimsInstantChipLabel: '⚡ दावे: तुरंत',
  endSeasonBtn: '🏁 सीज़न समाप्त करें',
  browsePublicLeaguesLink: '🌐 सार्वजनिक लीग ब्राउज़ करें',
  myStatsTitle: 'मेरे आंकड़े',
  statsPlayedLabel: 'खेले',
  statsWonLabel: 'जीते',
  statsLostLabel: 'हारे',
  seasonLabelFieldLabel: 'सीज़न लेबल',
  seasonLabelPlaceholder: 'जैसे 2025/26',
  seasonCountsHint: 'इस सीज़न के लिए प्रमोशन/रेलिगेशन संख्या — हर डिवीज़न के डिफ़ॉल्ट मानों से पहले से भरी गई, केवल इस बार के लिए संपादन योग्य।',
  tierLabel: 'स्तर',
  previewBtn: 'पूर्वावलोकन →',
  reviewMovesHint: 'नीचे प्रस्तावित बदलावों की समीक्षा करें — किसी भी टीम को उसकी वर्तमान डिवीज़न में रखने के लिए उसका चेकबॉक्स हटाएं। हर स्थिति में सभी डिवीज़न के फिक्स्चर संग्रहीत और रीसेट किए जाएंगे।',
  noMovesThisSeason: 'इस सीज़न में कोई प्रमोशन/रेलिगेशन बदलाव नहीं है।',
  confirmEndSeasonBtn: 'पुष्टि करें और सीज़न समाप्त करें',
};

export const LANGUAGES: Record<LangCode, Translations> = { en, es, fr, de, pt, it, ja, zh, ar, hi };

export const LANG_OPTIONS: { code: LangCode; name: string; flag: string }[] = [
  { code: 'en', name: 'English',    flag: '🇬🇧' },
  { code: 'es', name: 'Español',    flag: '🇪🇸' },
  { code: 'fr', name: 'Français',   flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch',    flag: '🇩🇪' },
  { code: 'pt', name: 'Português',  flag: '🇧🇷' },
  { code: 'it', name: 'Italiano',   flag: '🇮🇹' },
  { code: 'ja', name: '日本語',      flag: '🇯🇵' },
  { code: 'zh', name: '中文',        flag: '🇨🇳' },
  { code: 'ar', name: 'العربية',    flag: '🇸🇦' },
  { code: 'hi', name: 'हिन्दी',     flag: '🇮🇳' },
];
